import { jsx as k, jsxs as J, Fragment as ve } from "react/jsx-runtime";
import Bt, { useState as ye, createContext as Dr, useCallback as me, useMemo as fe, memo as ae, useContext as Ft, forwardRef as ji, useRef as ne, useLayoutEffect as xl, useEffect as re, createElement as vl } from "react";
import { createPortal as El } from "react-dom";
import { createRoot as _l } from "react-dom/client";
function ce(e) {
  if (typeof e == "string" || typeof e == "number") return "" + e;
  let t = "";
  if (Array.isArray(e))
    for (let n = 0, r; n < e.length; n++)
      (r = ce(e[n])) !== "" && (t += (t && " ") + r);
  else
    for (let n in e)
      e[n] && (t += (t && " ") + n);
  return t;
}
var Sl = { value: () => {
} };
function On() {
  for (var e = 0, t = arguments.length, n = {}, r; e < t; ++e) {
    if (!(r = arguments[e] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new un(n);
}
function un(e) {
  this._ = e;
}
function Nl(e, t) {
  return e.trim().split(/^|\s+/).map(function(n) {
    var r = "", o = n.indexOf(".");
    if (o >= 0 && (r = n.slice(o + 1), n = n.slice(0, o)), n && !t.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
un.prototype = On.prototype = {
  constructor: un,
  on: function(e, t) {
    var n = this._, r = Nl(e + "", n), o, i = -1, s = r.length;
    if (arguments.length < 2) {
      for (; ++i < s; ) if ((o = (e = r[i]).type) && (o = Cl(n[o], e.name))) return o;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++i < s; )
      if (o = (e = r[i]).type) n[o] = yo(n[o], e.name, t);
      else if (t == null) for (o in n) n[o] = yo(n[o], e.name, null);
    return this;
  },
  copy: function() {
    var e = {}, t = this._;
    for (var n in t) e[n] = t[n].slice();
    return new un(e);
  },
  call: function(e, t) {
    if ((o = arguments.length - 2) > 0) for (var n = new Array(o), r = 0, o, i; r < o; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (i = this._[e], r = 0, o = i.length; r < o; ++r) i[r].value.apply(t, n);
  },
  apply: function(e, t, n) {
    if (!this._.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    for (var r = this._[e], o = 0, i = r.length; o < i; ++o) r[o].value.apply(t, n);
  }
};
function Cl(e, t) {
  for (var n = 0, r = e.length, o; n < r; ++n)
    if ((o = e[n]).name === t)
      return o.value;
}
function yo(e, t, n) {
  for (var r = 0, o = e.length; r < o; ++r)
    if (e[r].name === t) {
      e[r] = Sl, e = e.slice(0, r).concat(e.slice(r + 1));
      break;
    }
  return n != null && e.push({ name: t, value: n }), e;
}
var wr = "http://www.w3.org/1999/xhtml";
const wo = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: wr,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Ln(e) {
  var t = e += "", n = t.indexOf(":");
  return n >= 0 && (t = e.slice(0, n)) !== "xmlns" && (e = e.slice(n + 1)), wo.hasOwnProperty(t) ? { space: wo[t], local: e } : e;
}
function kl(e) {
  return function() {
    var t = this.ownerDocument, n = this.namespaceURI;
    return n === wr && t.documentElement.namespaceURI === wr ? t.createElement(e) : t.createElementNS(n, e);
  };
}
function Ml(e) {
  return function() {
    return this.ownerDocument.createElementNS(e.space, e.local);
  };
}
function qi(e) {
  var t = Ln(e);
  return (t.local ? Ml : kl)(t);
}
function Il() {
}
function Rr(e) {
  return e == null ? Il : function() {
    return this.querySelector(e);
  };
}
function Pl(e) {
  typeof e != "function" && (e = Rr(e));
  for (var t = this._groups, n = t.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = t[o], s = i.length, a = r[o] = new Array(s), c, l, u = 0; u < s; ++u)
      (c = i[u]) && (l = e.call(c, c.__data__, u, i)) && ("__data__" in c && (l.__data__ = c.__data__), a[u] = l);
  return new we(r, this._parents);
}
function Al(e) {
  return e == null ? [] : Array.isArray(e) ? e : Array.from(e);
}
function Tl() {
  return [];
}
function Ki(e) {
  return e == null ? Tl : function() {
    return this.querySelectorAll(e);
  };
}
function Ol(e) {
  return function() {
    return Al(e.apply(this, arguments));
  };
}
function Ll(e) {
  typeof e == "function" ? e = Ol(e) : e = Ki(e);
  for (var t = this._groups, n = t.length, r = [], o = [], i = 0; i < n; ++i)
    for (var s = t[i], a = s.length, c, l = 0; l < a; ++l)
      (c = s[l]) && (r.push(e.call(c, c.__data__, l, s)), o.push(c));
  return new we(r, o);
}
function Ui(e) {
  return function() {
    return this.matches(e);
  };
}
function Zi(e) {
  return function(t) {
    return t.matches(e);
  };
}
var $l = Array.prototype.find;
function Dl(e) {
  return function() {
    return $l.call(this.children, e);
  };
}
function Rl() {
  return this.firstElementChild;
}
function zl(e) {
  return this.select(e == null ? Rl : Dl(typeof e == "function" ? e : Zi(e)));
}
var Vl = Array.prototype.filter;
function Hl() {
  return Array.from(this.children);
}
function Bl(e) {
  return function() {
    return Vl.call(this.children, e);
  };
}
function Fl(e) {
  return this.selectAll(e == null ? Hl : Bl(typeof e == "function" ? e : Zi(e)));
}
function Yl(e) {
  typeof e != "function" && (e = Ui(e));
  for (var t = this._groups, n = t.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = t[o], s = i.length, a = r[o] = [], c, l = 0; l < s; ++l)
      (c = i[l]) && e.call(c, c.__data__, l, i) && a.push(c);
  return new we(r, this._parents);
}
function Qi(e) {
  return new Array(e.length);
}
function Xl() {
  return new we(this._enter || this._groups.map(Qi), this._parents);
}
function pn(e, t) {
  this.ownerDocument = e.ownerDocument, this.namespaceURI = e.namespaceURI, this._next = null, this._parent = e, this.__data__ = t;
}
pn.prototype = {
  constructor: pn,
  appendChild: function(e) {
    return this._parent.insertBefore(e, this._next);
  },
  insertBefore: function(e, t) {
    return this._parent.insertBefore(e, t);
  },
  querySelector: function(e) {
    return this._parent.querySelector(e);
  },
  querySelectorAll: function(e) {
    return this._parent.querySelectorAll(e);
  }
};
function Wl(e) {
  return function() {
    return e;
  };
}
function Gl(e, t, n, r, o, i) {
  for (var s = 0, a, c = t.length, l = i.length; s < l; ++s)
    (a = t[s]) ? (a.__data__ = i[s], r[s] = a) : n[s] = new pn(e, i[s]);
  for (; s < c; ++s)
    (a = t[s]) && (o[s] = a);
}
function jl(e, t, n, r, o, i, s) {
  var a, c, l = /* @__PURE__ */ new Map(), u = t.length, d = i.length, f = new Array(u), h;
  for (a = 0; a < u; ++a)
    (c = t[a]) && (f[a] = h = s.call(c, c.__data__, a, t) + "", l.has(h) ? o[a] = c : l.set(h, c));
  for (a = 0; a < d; ++a)
    h = s.call(e, i[a], a, i) + "", (c = l.get(h)) ? (r[a] = c, c.__data__ = i[a], l.delete(h)) : n[a] = new pn(e, i[a]);
  for (a = 0; a < u; ++a)
    (c = t[a]) && l.get(f[a]) === c && (o[a] = c);
}
function ql(e) {
  return e.__data__;
}
function Kl(e, t) {
  if (!arguments.length) return Array.from(this, ql);
  var n = t ? jl : Gl, r = this._parents, o = this._groups;
  typeof e != "function" && (e = Wl(e));
  for (var i = o.length, s = new Array(i), a = new Array(i), c = new Array(i), l = 0; l < i; ++l) {
    var u = r[l], d = o[l], f = d.length, h = Ul(e.call(u, u && u.__data__, l, r)), g = h.length, y = a[l] = new Array(g), w = s[l] = new Array(g), m = c[l] = new Array(f);
    n(u, d, y, w, m, h, t);
    for (var x = 0, p = 0, b, _; x < g; ++x)
      if (b = y[x]) {
        for (x >= p && (p = x + 1); !(_ = w[p]) && ++p < g; ) ;
        b._next = _ || null;
      }
  }
  return s = new we(s, r), s._enter = a, s._exit = c, s;
}
function Ul(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Zl() {
  return new we(this._exit || this._groups.map(Qi), this._parents);
}
function Ql(e, t, n) {
  var r = this.enter(), o = this, i = this.exit();
  return typeof e == "function" ? (r = e(r), r && (r = r.selection())) : r = r.append(e + ""), t != null && (o = t(o), o && (o = o.selection())), n == null ? i.remove() : n(i), r && o ? r.merge(o).order() : o;
}
function Jl(e) {
  for (var t = e.selection ? e.selection() : e, n = this._groups, r = t._groups, o = n.length, i = r.length, s = Math.min(o, i), a = new Array(o), c = 0; c < s; ++c)
    for (var l = n[c], u = r[c], d = l.length, f = a[c] = new Array(d), h, g = 0; g < d; ++g)
      (h = l[g] || u[g]) && (f[g] = h);
  for (; c < o; ++c)
    a[c] = n[c];
  return new we(a, this._parents);
}
function eu() {
  for (var e = this._groups, t = -1, n = e.length; ++t < n; )
    for (var r = e[t], o = r.length - 1, i = r[o], s; --o >= 0; )
      (s = r[o]) && (i && s.compareDocumentPosition(i) ^ 4 && i.parentNode.insertBefore(s, i), i = s);
  return this;
}
function tu(e) {
  e || (e = nu);
  function t(d, f) {
    return d && f ? e(d.__data__, f.__data__) : !d - !f;
  }
  for (var n = this._groups, r = n.length, o = new Array(r), i = 0; i < r; ++i) {
    for (var s = n[i], a = s.length, c = o[i] = new Array(a), l, u = 0; u < a; ++u)
      (l = s[u]) && (c[u] = l);
    c.sort(t);
  }
  return new we(o, this._parents).order();
}
function nu(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function ru() {
  var e = arguments[0];
  return arguments[0] = this, e.apply(null, arguments), this;
}
function ou() {
  return Array.from(this);
}
function iu() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], o = 0, i = r.length; o < i; ++o) {
      var s = r[o];
      if (s) return s;
    }
  return null;
}
function su() {
  let e = 0;
  for (const t of this) ++e;
  return e;
}
function au() {
  return !this.node();
}
function cu(e) {
  for (var t = this._groups, n = 0, r = t.length; n < r; ++n)
    for (var o = t[n], i = 0, s = o.length, a; i < s; ++i)
      (a = o[i]) && e.call(a, a.__data__, i, o);
  return this;
}
function lu(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function uu(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function du(e, t) {
  return function() {
    this.setAttribute(e, t);
  };
}
function fu(e, t) {
  return function() {
    this.setAttributeNS(e.space, e.local, t);
  };
}
function hu(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttribute(e) : this.setAttribute(e, n);
  };
}
function gu(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? this.removeAttributeNS(e.space, e.local) : this.setAttributeNS(e.space, e.local, n);
  };
}
function pu(e, t) {
  var n = Ln(e);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((t == null ? n.local ? uu : lu : typeof t == "function" ? n.local ? gu : hu : n.local ? fu : du)(n, t));
}
function Ji(e) {
  return e.ownerDocument && e.ownerDocument.defaultView || e.document && e || e.defaultView;
}
function mu(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function yu(e, t, n) {
  return function() {
    this.style.setProperty(e, t, n);
  };
}
function wu(e, t, n) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(e) : this.style.setProperty(e, r, n);
  };
}
function bu(e, t, n) {
  return arguments.length > 1 ? this.each((t == null ? mu : typeof t == "function" ? wu : yu)(e, t, n ?? "")) : lt(this.node(), e);
}
function lt(e, t) {
  return e.style.getPropertyValue(t) || Ji(e).getComputedStyle(e, null).getPropertyValue(t);
}
function xu(e) {
  return function() {
    delete this[e];
  };
}
function vu(e, t) {
  return function() {
    this[e] = t;
  };
}
function Eu(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    n == null ? delete this[e] : this[e] = n;
  };
}
function _u(e, t) {
  return arguments.length > 1 ? this.each((t == null ? xu : typeof t == "function" ? Eu : vu)(e, t)) : this.node()[e];
}
function es(e) {
  return e.trim().split(/^|\s+/);
}
function zr(e) {
  return e.classList || new ts(e);
}
function ts(e) {
  this._node = e, this._names = es(e.getAttribute("class") || "");
}
ts.prototype = {
  add: function(e) {
    var t = this._names.indexOf(e);
    t < 0 && (this._names.push(e), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(e) {
    var t = this._names.indexOf(e);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(e) {
    return this._names.indexOf(e) >= 0;
  }
};
function ns(e, t) {
  for (var n = zr(e), r = -1, o = t.length; ++r < o; ) n.add(t[r]);
}
function rs(e, t) {
  for (var n = zr(e), r = -1, o = t.length; ++r < o; ) n.remove(t[r]);
}
function Su(e) {
  return function() {
    ns(this, e);
  };
}
function Nu(e) {
  return function() {
    rs(this, e);
  };
}
function Cu(e, t) {
  return function() {
    (t.apply(this, arguments) ? ns : rs)(this, e);
  };
}
function ku(e, t) {
  var n = es(e + "");
  if (arguments.length < 2) {
    for (var r = zr(this.node()), o = -1, i = n.length; ++o < i; ) if (!r.contains(n[o])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? Cu : t ? Su : Nu)(n, t));
}
function Mu() {
  this.textContent = "";
}
function Iu(e) {
  return function() {
    this.textContent = e;
  };
}
function Pu(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function Au(e) {
  return arguments.length ? this.each(e == null ? Mu : (typeof e == "function" ? Pu : Iu)(e)) : this.node().textContent;
}
function Tu() {
  this.innerHTML = "";
}
function Ou(e) {
  return function() {
    this.innerHTML = e;
  };
}
function Lu(e) {
  return function() {
    var t = e.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function $u(e) {
  return arguments.length ? this.each(e == null ? Tu : (typeof e == "function" ? Lu : Ou)(e)) : this.node().innerHTML;
}
function Du() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Ru() {
  return this.each(Du);
}
function zu() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Vu() {
  return this.each(zu);
}
function Hu(e) {
  var t = typeof e == "function" ? e : qi(e);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function Bu() {
  return null;
}
function Fu(e, t) {
  var n = typeof e == "function" ? e : qi(e), r = t == null ? Bu : typeof t == "function" ? t : Rr(t);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function Yu() {
  var e = this.parentNode;
  e && e.removeChild(this);
}
function Xu() {
  return this.each(Yu);
}
function Wu() {
  var e = this.cloneNode(!1), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function Gu() {
  var e = this.cloneNode(!0), t = this.parentNode;
  return t ? t.insertBefore(e, this.nextSibling) : e;
}
function ju(e) {
  return this.select(e ? Gu : Wu);
}
function qu(e) {
  return arguments.length ? this.property("__data__", e) : this.node().__data__;
}
function Ku(e) {
  return function(t) {
    e.call(this, t, this.__data__);
  };
}
function Uu(e) {
  return e.trim().split(/^|\s+/).map(function(t) {
    var n = "", r = t.indexOf(".");
    return r >= 0 && (n = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: n };
  });
}
function Zu(e) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var n = 0, r = -1, o = t.length, i; n < o; ++n)
        i = t[n], (!e.type || i.type === e.type) && i.name === e.name ? this.removeEventListener(i.type, i.listener, i.options) : t[++r] = i;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function Qu(e, t, n) {
  return function() {
    var r = this.__on, o, i = Ku(t);
    if (r) {
      for (var s = 0, a = r.length; s < a; ++s)
        if ((o = r[s]).type === e.type && o.name === e.name) {
          this.removeEventListener(o.type, o.listener, o.options), this.addEventListener(o.type, o.listener = i, o.options = n), o.value = t;
          return;
        }
    }
    this.addEventListener(e.type, i, n), o = { type: e.type, name: e.name, value: t, listener: i, options: n }, r ? r.push(o) : this.__on = [o];
  };
}
function Ju(e, t, n) {
  var r = Uu(e + ""), o, i = r.length, s;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var c = 0, l = a.length, u; c < l; ++c)
        for (o = 0, u = a[c]; o < i; ++o)
          if ((s = r[o]).type === u.type && s.name === u.name)
            return u.value;
    }
    return;
  }
  for (a = t ? Qu : Zu, o = 0; o < i; ++o) this.each(a(r[o], t, n));
  return this;
}
function os(e, t, n) {
  var r = Ji(e), o = r.CustomEvent;
  typeof o == "function" ? o = new o(t, n) : (o = r.document.createEvent("Event"), n ? (o.initEvent(t, n.bubbles, n.cancelable), o.detail = n.detail) : o.initEvent(t, !1, !1)), e.dispatchEvent(o);
}
function ed(e, t) {
  return function() {
    return os(this, e, t);
  };
}
function td(e, t) {
  return function() {
    return os(this, e, t.apply(this, arguments));
  };
}
function nd(e, t) {
  return this.each((typeof t == "function" ? td : ed)(e, t));
}
function* rd() {
  for (var e = this._groups, t = 0, n = e.length; t < n; ++t)
    for (var r = e[t], o = 0, i = r.length, s; o < i; ++o)
      (s = r[o]) && (yield s);
}
var is = [null];
function we(e, t) {
  this._groups = e, this._parents = t;
}
function Yt() {
  return new we([[document.documentElement]], is);
}
function od() {
  return this;
}
we.prototype = Yt.prototype = {
  constructor: we,
  select: Pl,
  selectAll: Ll,
  selectChild: zl,
  selectChildren: Fl,
  filter: Yl,
  data: Kl,
  enter: Xl,
  exit: Zl,
  join: Ql,
  merge: Jl,
  selection: od,
  order: eu,
  sort: tu,
  call: ru,
  nodes: ou,
  node: iu,
  size: su,
  empty: au,
  each: cu,
  attr: pu,
  style: bu,
  property: _u,
  classed: ku,
  text: Au,
  html: $u,
  raise: Ru,
  lower: Vu,
  append: Hu,
  insert: Fu,
  remove: Xu,
  clone: ju,
  datum: qu,
  on: Ju,
  dispatch: nd,
  [Symbol.iterator]: rd
};
function pe(e) {
  return typeof e == "string" ? new we([[document.querySelector(e)]], [document.documentElement]) : new we([[e]], is);
}
function id(e) {
  let t;
  for (; t = e.sourceEvent; ) e = t;
  return e;
}
function _e(e, t) {
  if (e = id(e), t === void 0 && (t = e.currentTarget), t) {
    var n = t.ownerSVGElement || t;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = e.clientX, r.y = e.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (t.getBoundingClientRect) {
      var o = t.getBoundingClientRect();
      return [e.clientX - o.left - t.clientLeft, e.clientY - o.top - t.clientTop];
    }
  }
  return [e.pageX, e.pageY];
}
const sd = { passive: !1 }, At = { capture: !0, passive: !1 };
function Qn(e) {
  e.stopImmediatePropagation();
}
function at(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function ss(e) {
  var t = e.document.documentElement, n = pe(e).on("dragstart.drag", at, At);
  "onselectstart" in t ? n.on("selectstart.drag", at, At) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function as(e, t) {
  var n = e.document.documentElement, r = pe(e).on("dragstart.drag", null);
  t && (r.on("click.drag", at, At), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const Qt = (e) => () => e;
function br(e, {
  sourceEvent: t,
  subject: n,
  target: r,
  identifier: o,
  active: i,
  x: s,
  y: a,
  dx: c,
  dy: l,
  dispatch: u
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: o, enumerable: !0, configurable: !0 },
    active: { value: i, enumerable: !0, configurable: !0 },
    x: { value: s, enumerable: !0, configurable: !0 },
    y: { value: a, enumerable: !0, configurable: !0 },
    dx: { value: c, enumerable: !0, configurable: !0 },
    dy: { value: l, enumerable: !0, configurable: !0 },
    _: { value: u }
  });
}
br.prototype.on = function() {
  var e = this._.on.apply(this._, arguments);
  return e === this._ ? this : e;
};
function ad(e) {
  return !e.ctrlKey && !e.button;
}
function cd() {
  return this.parentNode;
}
function ld(e, t) {
  return t ?? { x: e.x, y: e.y };
}
function ud() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function cs() {
  var e = ad, t = cd, n = ld, r = ud, o = {}, i = On("start", "drag", "end"), s = 0, a, c, l, u, d = 0;
  function f(b) {
    b.on("mousedown.drag", h).filter(r).on("touchstart.drag", w).on("touchmove.drag", m, sd).on("touchend.drag touchcancel.drag", x).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function h(b, _) {
    if (!(u || !e.call(this, b, _))) {
      var E = p(this, t.call(this, b, _), b, _, "mouse");
      E && (pe(b.view).on("mousemove.drag", g, At).on("mouseup.drag", y, At), ss(b.view), Qn(b), l = !1, a = b.clientX, c = b.clientY, E("start", b));
    }
  }
  function g(b) {
    if (at(b), !l) {
      var _ = b.clientX - a, E = b.clientY - c;
      l = _ * _ + E * E > d;
    }
    o.mouse("drag", b);
  }
  function y(b) {
    pe(b.view).on("mousemove.drag mouseup.drag", null), as(b.view, l), at(b), o.mouse("end", b);
  }
  function w(b, _) {
    if (e.call(this, b, _)) {
      var E = b.changedTouches, C = t.call(this, b, _), A = E.length, M, z;
      for (M = 0; M < A; ++M)
        (z = p(this, C, b, _, E[M].identifier, E[M])) && (Qn(b), z("start", b, E[M]));
    }
  }
  function m(b) {
    var _ = b.changedTouches, E = _.length, C, A;
    for (C = 0; C < E; ++C)
      (A = o[_[C].identifier]) && (at(b), A("drag", b, _[C]));
  }
  function x(b) {
    var _ = b.changedTouches, E = _.length, C, A;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), C = 0; C < E; ++C)
      (A = o[_[C].identifier]) && (Qn(b), A("end", b, _[C]));
  }
  function p(b, _, E, C, A, M) {
    var z = i.copy(), P = _e(M || E, _), L, V, v;
    if ((v = n.call(b, new br("beforestart", {
      sourceEvent: E,
      target: f,
      identifier: A,
      active: s,
      x: P[0],
      y: P[1],
      dx: 0,
      dy: 0,
      dispatch: z
    }), C)) != null)
      return L = v.x - P[0] || 0, V = v.y - P[1] || 0, function T(S, O, I) {
        var N = P, $;
        switch (S) {
          case "start":
            o[A] = T, $ = s++;
            break;
          case "end":
            delete o[A], --s;
          case "drag":
            P = _e(I || O, _), $ = s;
            break;
        }
        z.call(
          S,
          b,
          new br(S, {
            sourceEvent: O,
            subject: v,
            target: f,
            identifier: A,
            active: $,
            x: P[0] + L,
            y: P[1] + V,
            dx: P[0] - N[0],
            dy: P[1] - N[1],
            dispatch: z
          }),
          C
        );
      };
  }
  return f.filter = function(b) {
    return arguments.length ? (e = typeof b == "function" ? b : Qt(!!b), f) : e;
  }, f.container = function(b) {
    return arguments.length ? (t = typeof b == "function" ? b : Qt(b), f) : t;
  }, f.subject = function(b) {
    return arguments.length ? (n = typeof b == "function" ? b : Qt(b), f) : n;
  }, f.touchable = function(b) {
    return arguments.length ? (r = typeof b == "function" ? b : Qt(!!b), f) : r;
  }, f.on = function() {
    var b = i.on.apply(i, arguments);
    return b === i ? f : b;
  }, f.clickDistance = function(b) {
    return arguments.length ? (d = (b = +b) * b, f) : Math.sqrt(d);
  }, f;
}
function Vr(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function ls(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Xt() {
}
var Tt = 0.7, mn = 1 / Tt, ct = "\\s*([+-]?\\d+)\\s*", Ot = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Pe = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", dd = /^#([0-9a-f]{3,8})$/, fd = new RegExp(`^rgb\\(${ct},${ct},${ct}\\)$`), hd = new RegExp(`^rgb\\(${Pe},${Pe},${Pe}\\)$`), gd = new RegExp(`^rgba\\(${ct},${ct},${ct},${Ot}\\)$`), pd = new RegExp(`^rgba\\(${Pe},${Pe},${Pe},${Ot}\\)$`), md = new RegExp(`^hsl\\(${Ot},${Pe},${Pe}\\)$`), yd = new RegExp(`^hsla\\(${Ot},${Pe},${Pe},${Ot}\\)$`), bo = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Vr(Xt, Ke, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: xo,
  // Deprecated! Use color.formatHex.
  formatHex: xo,
  formatHex8: wd,
  formatHsl: bd,
  formatRgb: vo,
  toString: vo
});
function xo() {
  return this.rgb().formatHex();
}
function wd() {
  return this.rgb().formatHex8();
}
function bd() {
  return us(this).formatHsl();
}
function vo() {
  return this.rgb().formatRgb();
}
function Ke(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = dd.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Eo(t) : n === 3 ? new de(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Jt(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Jt(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = fd.exec(e)) ? new de(t[1], t[2], t[3], 1) : (t = hd.exec(e)) ? new de(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = gd.exec(e)) ? Jt(t[1], t[2], t[3], t[4]) : (t = pd.exec(e)) ? Jt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = md.exec(e)) ? No(t[1], t[2] / 100, t[3] / 100, 1) : (t = yd.exec(e)) ? No(t[1], t[2] / 100, t[3] / 100, t[4]) : bo.hasOwnProperty(e) ? Eo(bo[e]) : e === "transparent" ? new de(NaN, NaN, NaN, 0) : null;
}
function Eo(e) {
  return new de(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Jt(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new de(e, t, n, r);
}
function xd(e) {
  return e instanceof Xt || (e = Ke(e)), e ? (e = e.rgb(), new de(e.r, e.g, e.b, e.opacity)) : new de();
}
function xr(e, t, n, r) {
  return arguments.length === 1 ? xd(e) : new de(e, t, n, r ?? 1);
}
function de(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Vr(de, xr, ls(Xt, {
  brighter(e) {
    return e = e == null ? mn : Math.pow(mn, e), new de(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Tt : Math.pow(Tt, e), new de(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new de(je(this.r), je(this.g), je(this.b), yn(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: _o,
  // Deprecated! Use color.formatHex.
  formatHex: _o,
  formatHex8: vd,
  formatRgb: So,
  toString: So
}));
function _o() {
  return `#${Ge(this.r)}${Ge(this.g)}${Ge(this.b)}`;
}
function vd() {
  return `#${Ge(this.r)}${Ge(this.g)}${Ge(this.b)}${Ge((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function So() {
  const e = yn(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${je(this.r)}, ${je(this.g)}, ${je(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function yn(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function je(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Ge(e) {
  return e = je(e), (e < 16 ? "0" : "") + e.toString(16);
}
function No(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Se(e, t, n, r);
}
function us(e) {
  if (e instanceof Se) return new Se(e.h, e.s, e.l, e.opacity);
  if (e instanceof Xt || (e = Ke(e)), !e) return new Se();
  if (e instanceof Se) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), i = Math.max(t, n, r), s = NaN, a = i - o, c = (i + o) / 2;
  return a ? (t === i ? s = (n - r) / a + (n < r) * 6 : n === i ? s = (r - t) / a + 2 : s = (t - n) / a + 4, a /= c < 0.5 ? i + o : 2 - i - o, s *= 60) : a = c > 0 && c < 1 ? 0 : s, new Se(s, a, c, e.opacity);
}
function Ed(e, t, n, r) {
  return arguments.length === 1 ? us(e) : new Se(e, t, n, r ?? 1);
}
function Se(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Vr(Se, Ed, ls(Xt, {
  brighter(e) {
    return e = e == null ? mn : Math.pow(mn, e), new Se(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? Tt : Math.pow(Tt, e), new Se(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new de(
      Jn(e >= 240 ? e - 240 : e + 120, o, r),
      Jn(e, o, r),
      Jn(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new Se(Co(this.h), en(this.s), en(this.l), yn(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = yn(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Co(this.h)}, ${en(this.s) * 100}%, ${en(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Co(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function en(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function Jn(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const Hr = (e) => () => e;
function _d(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Sd(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Nd(e) {
  return (e = +e) == 1 ? ds : function(t, n) {
    return n - t ? Sd(t, n, e) : Hr(isNaN(t) ? n : t);
  };
}
function ds(e, t) {
  var n = t - e;
  return n ? _d(e, n) : Hr(isNaN(e) ? t : e);
}
const wn = function e(t) {
  var n = Nd(t);
  function r(o, i) {
    var s = n((o = xr(o)).r, (i = xr(i)).r), a = n(o.g, i.g), c = n(o.b, i.b), l = ds(o.opacity, i.opacity);
    return function(u) {
      return o.r = s(u), o.g = a(u), o.b = c(u), o.opacity = l(u), o + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Cd(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(i) {
    for (o = 0; o < n; ++o) r[o] = e[o] * (1 - i) + t[o] * i;
    return r;
  };
}
function kd(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Md(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), i = new Array(n), s;
  for (s = 0; s < r; ++s) o[s] = It(e[s], t[s]);
  for (; s < n; ++s) i[s] = t[s];
  return function(a) {
    for (s = 0; s < r; ++s) i[s] = o[s](a);
    return i;
  };
}
function Id(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Me(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Pd(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = It(e[o], t[o]) : r[o] = t[o];
  return function(i) {
    for (o in n) r[o] = n[o](i);
    return r;
  };
}
var vr = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, er = new RegExp(vr.source, "g");
function Ad(e) {
  return function() {
    return e;
  };
}
function Td(e) {
  return function(t) {
    return e(t) + "";
  };
}
function fs(e, t) {
  var n = vr.lastIndex = er.lastIndex = 0, r, o, i, s = -1, a = [], c = [];
  for (e = e + "", t = t + ""; (r = vr.exec(e)) && (o = er.exec(t)); )
    (i = o.index) > n && (i = t.slice(n, i), a[s] ? a[s] += i : a[++s] = i), (r = r[0]) === (o = o[0]) ? a[s] ? a[s] += o : a[++s] = o : (a[++s] = null, c.push({ i: s, x: Me(r, o) })), n = er.lastIndex;
  return n < t.length && (i = t.slice(n), a[s] ? a[s] += i : a[++s] = i), a.length < 2 ? c[0] ? Td(c[0].x) : Ad(t) : (t = c.length, function(l) {
    for (var u = 0, d; u < t; ++u) a[(d = c[u]).i] = d.x(l);
    return a.join("");
  });
}
function It(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Hr(t) : (n === "number" ? Me : n === "string" ? (r = Ke(t)) ? (t = r, wn) : fs : t instanceof Ke ? wn : t instanceof Date ? Id : kd(t) ? Cd : Array.isArray(t) ? Md : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Pd : Me)(e, t);
}
var ko = 180 / Math.PI, Er = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function hs(e, t, n, r, o, i) {
  var s, a, c;
  return (s = Math.sqrt(e * e + t * t)) && (e /= s, t /= s), (c = e * n + t * r) && (n -= e * c, r -= t * c), (a = Math.sqrt(n * n + r * r)) && (n /= a, r /= a, c /= a), e * r < t * n && (e = -e, t = -t, c = -c, s = -s), {
    translateX: o,
    translateY: i,
    rotate: Math.atan2(t, e) * ko,
    skewX: Math.atan(c) * ko,
    scaleX: s,
    scaleY: a
  };
}
var tn;
function Od(e) {
  const t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
  return t.isIdentity ? Er : hs(t.a, t.b, t.c, t.d, t.e, t.f);
}
function Ld(e) {
  return e == null || (tn || (tn = document.createElementNS("http://www.w3.org/2000/svg", "g")), tn.setAttribute("transform", e), !(e = tn.transform.baseVal.consolidate())) ? Er : (e = e.matrix, hs(e.a, e.b, e.c, e.d, e.e, e.f));
}
function gs(e, t, n, r) {
  function o(l) {
    return l.length ? l.pop() + " " : "";
  }
  function i(l, u, d, f, h, g) {
    if (l !== d || u !== f) {
      var y = h.push("translate(", null, t, null, n);
      g.push({ i: y - 4, x: Me(l, d) }, { i: y - 2, x: Me(u, f) });
    } else (d || f) && h.push("translate(" + d + t + f + n);
  }
  function s(l, u, d, f) {
    l !== u ? (l - u > 180 ? u += 360 : u - l > 180 && (l += 360), f.push({ i: d.push(o(d) + "rotate(", null, r) - 2, x: Me(l, u) })) : u && d.push(o(d) + "rotate(" + u + r);
  }
  function a(l, u, d, f) {
    l !== u ? f.push({ i: d.push(o(d) + "skewX(", null, r) - 2, x: Me(l, u) }) : u && d.push(o(d) + "skewX(" + u + r);
  }
  function c(l, u, d, f, h, g) {
    if (l !== d || u !== f) {
      var y = h.push(o(h) + "scale(", null, ",", null, ")");
      g.push({ i: y - 4, x: Me(l, d) }, { i: y - 2, x: Me(u, f) });
    } else (d !== 1 || f !== 1) && h.push(o(h) + "scale(" + d + "," + f + ")");
  }
  return function(l, u) {
    var d = [], f = [];
    return l = e(l), u = e(u), i(l.translateX, l.translateY, u.translateX, u.translateY, d, f), s(l.rotate, u.rotate, d, f), a(l.skewX, u.skewX, d, f), c(l.scaleX, l.scaleY, u.scaleX, u.scaleY, d, f), l = u = null, function(h) {
      for (var g = -1, y = f.length, w; ++g < y; ) d[(w = f[g]).i] = w.x(h);
      return d.join("");
    };
  };
}
var $d = gs(Od, "px, ", "px)", "deg)"), Dd = gs(Ld, ", ", ")", ")"), Rd = 1e-12;
function Mo(e) {
  return ((e = Math.exp(e)) + 1 / e) / 2;
}
function zd(e) {
  return ((e = Math.exp(e)) - 1 / e) / 2;
}
function Vd(e) {
  return ((e = Math.exp(2 * e)) - 1) / (e + 1);
}
const dn = function e(t, n, r) {
  function o(i, s) {
    var a = i[0], c = i[1], l = i[2], u = s[0], d = s[1], f = s[2], h = u - a, g = d - c, y = h * h + g * g, w, m;
    if (y < Rd)
      m = Math.log(f / l) / t, w = function(C) {
        return [
          a + C * h,
          c + C * g,
          l * Math.exp(t * C * m)
        ];
      };
    else {
      var x = Math.sqrt(y), p = (f * f - l * l + r * y) / (2 * l * n * x), b = (f * f - l * l - r * y) / (2 * f * n * x), _ = Math.log(Math.sqrt(p * p + 1) - p), E = Math.log(Math.sqrt(b * b + 1) - b);
      m = (E - _) / t, w = function(C) {
        var A = C * m, M = Mo(_), z = l / (n * x) * (M * Vd(t * A + _) - zd(_));
        return [
          a + z * h,
          c + z * g,
          l * M / Mo(t * A + _)
        ];
      };
    }
    return w.duration = m * 1e3 * t / Math.SQRT2, w;
  }
  return o.rho = function(i) {
    var s = Math.max(1e-3, +i), a = s * s, c = a * a;
    return e(s, a, c);
  }, o;
}(Math.SQRT2, 2, 4);
var ut = 0, Ct = 0, _t = 0, ps = 1e3, bn, kt, xn = 0, Ue = 0, $n = 0, Lt = typeof performance == "object" && performance.now ? performance : Date, ms = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(e) {
  setTimeout(e, 17);
};
function Br() {
  return Ue || (ms(Hd), Ue = Lt.now() + $n);
}
function Hd() {
  Ue = 0;
}
function vn() {
  this._call = this._time = this._next = null;
}
vn.prototype = ys.prototype = {
  constructor: vn,
  restart: function(e, t, n) {
    if (typeof e != "function") throw new TypeError("callback is not a function");
    n = (n == null ? Br() : +n) + (t == null ? 0 : +t), !this._next && kt !== this && (kt ? kt._next = this : bn = this, kt = this), this._call = e, this._time = n, _r();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, _r());
  }
};
function ys(e, t, n) {
  var r = new vn();
  return r.restart(e, t, n), r;
}
function Bd() {
  Br(), ++ut;
  for (var e = bn, t; e; )
    (t = Ue - e._time) >= 0 && e._call.call(void 0, t), e = e._next;
  --ut;
}
function Io() {
  Ue = (xn = Lt.now()) + $n, ut = Ct = 0;
  try {
    Bd();
  } finally {
    ut = 0, Yd(), Ue = 0;
  }
}
function Fd() {
  var e = Lt.now(), t = e - xn;
  t > ps && ($n -= t, xn = e);
}
function Yd() {
  for (var e, t = bn, n, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), e = t, t = t._next) : (n = t._next, t._next = null, t = e ? e._next = n : bn = n);
  kt = e, _r(r);
}
function _r(e) {
  if (!ut) {
    Ct && (Ct = clearTimeout(Ct));
    var t = e - Ue;
    t > 24 ? (e < 1 / 0 && (Ct = setTimeout(Io, e - Lt.now() - $n)), _t && (_t = clearInterval(_t))) : (_t || (xn = Lt.now(), _t = setInterval(Fd, ps)), ut = 1, ms(Io));
  }
}
function Po(e, t, n) {
  var r = new vn();
  return t = t == null ? 0 : +t, r.restart((o) => {
    r.stop(), e(o + t);
  }, t, n), r;
}
var Xd = On("start", "end", "cancel", "interrupt"), Wd = [], ws = 0, Ao = 1, Sr = 2, fn = 3, To = 4, Nr = 5, hn = 6;
function Dn(e, t, n, r, o, i) {
  var s = e.__transition;
  if (!s) e.__transition = {};
  else if (n in s) return;
  Gd(e, n, {
    name: t,
    index: r,
    // For context during callback.
    group: o,
    // For context during callback.
    on: Xd,
    tween: Wd,
    time: i.time,
    delay: i.delay,
    duration: i.duration,
    ease: i.ease,
    timer: null,
    state: ws
  });
}
function Fr(e, t) {
  var n = ke(e, t);
  if (n.state > ws) throw new Error("too late; already scheduled");
  return n;
}
function Ae(e, t) {
  var n = ke(e, t);
  if (n.state > fn) throw new Error("too late; already running");
  return n;
}
function ke(e, t) {
  var n = e.__transition;
  if (!n || !(n = n[t])) throw new Error("transition not found");
  return n;
}
function Gd(e, t, n) {
  var r = e.__transition, o;
  r[t] = n, n.timer = ys(i, 0, n.time);
  function i(l) {
    n.state = Ao, n.timer.restart(s, n.delay, n.time), n.delay <= l && s(l - n.delay);
  }
  function s(l) {
    var u, d, f, h;
    if (n.state !== Ao) return c();
    for (u in r)
      if (h = r[u], h.name === n.name) {
        if (h.state === fn) return Po(s);
        h.state === To ? (h.state = hn, h.timer.stop(), h.on.call("interrupt", e, e.__data__, h.index, h.group), delete r[u]) : +u < t && (h.state = hn, h.timer.stop(), h.on.call("cancel", e, e.__data__, h.index, h.group), delete r[u]);
      }
    if (Po(function() {
      n.state === fn && (n.state = To, n.timer.restart(a, n.delay, n.time), a(l));
    }), n.state = Sr, n.on.call("start", e, e.__data__, n.index, n.group), n.state === Sr) {
      for (n.state = fn, o = new Array(f = n.tween.length), u = 0, d = -1; u < f; ++u)
        (h = n.tween[u].value.call(e, e.__data__, n.index, n.group)) && (o[++d] = h);
      o.length = d + 1;
    }
  }
  function a(l) {
    for (var u = l < n.duration ? n.ease.call(null, l / n.duration) : (n.timer.restart(c), n.state = Nr, 1), d = -1, f = o.length; ++d < f; )
      o[d].call(e, u);
    n.state === Nr && (n.on.call("end", e, e.__data__, n.index, n.group), c());
  }
  function c() {
    n.state = hn, n.timer.stop(), delete r[t];
    for (var l in r) return;
    delete e.__transition;
  }
}
function gn(e, t) {
  var n = e.__transition, r, o, i = !0, s;
  if (n) {
    t = t == null ? null : t + "";
    for (s in n) {
      if ((r = n[s]).name !== t) {
        i = !1;
        continue;
      }
      o = r.state > Sr && r.state < Nr, r.state = hn, r.timer.stop(), r.on.call(o ? "interrupt" : "cancel", e, e.__data__, r.index, r.group), delete n[s];
    }
    i && delete e.__transition;
  }
}
function jd(e) {
  return this.each(function() {
    gn(this, e);
  });
}
function qd(e, t) {
  var n, r;
  return function() {
    var o = Ae(this, e), i = o.tween;
    if (i !== n) {
      r = n = i;
      for (var s = 0, a = r.length; s < a; ++s)
        if (r[s].name === t) {
          r = r.slice(), r.splice(s, 1);
          break;
        }
    }
    o.tween = r;
  };
}
function Kd(e, t, n) {
  var r, o;
  if (typeof n != "function") throw new Error();
  return function() {
    var i = Ae(this, e), s = i.tween;
    if (s !== r) {
      o = (r = s).slice();
      for (var a = { name: t, value: n }, c = 0, l = o.length; c < l; ++c)
        if (o[c].name === t) {
          o[c] = a;
          break;
        }
      c === l && o.push(a);
    }
    i.tween = o;
  };
}
function Ud(e, t) {
  var n = this._id;
  if (e += "", arguments.length < 2) {
    for (var r = ke(this.node(), n).tween, o = 0, i = r.length, s; o < i; ++o)
      if ((s = r[o]).name === e)
        return s.value;
    return null;
  }
  return this.each((t == null ? qd : Kd)(n, e, t));
}
function Yr(e, t, n) {
  var r = e._id;
  return e.each(function() {
    var o = Ae(this, r);
    (o.value || (o.value = {}))[t] = n.apply(this, arguments);
  }), function(o) {
    return ke(o, r).value[t];
  };
}
function bs(e, t) {
  var n;
  return (typeof t == "number" ? Me : t instanceof Ke ? wn : (n = Ke(t)) ? (t = n, wn) : fs)(e, t);
}
function Zd(e) {
  return function() {
    this.removeAttribute(e);
  };
}
function Qd(e) {
  return function() {
    this.removeAttributeNS(e.space, e.local);
  };
}
function Jd(e, t, n) {
  var r, o = n + "", i;
  return function() {
    var s = this.getAttribute(e);
    return s === o ? null : s === r ? i : i = t(r = s, n);
  };
}
function ef(e, t, n) {
  var r, o = n + "", i;
  return function() {
    var s = this.getAttributeNS(e.space, e.local);
    return s === o ? null : s === r ? i : i = t(r = s, n);
  };
}
function tf(e, t, n) {
  var r, o, i;
  return function() {
    var s, a = n(this), c;
    return a == null ? void this.removeAttribute(e) : (s = this.getAttribute(e), c = a + "", s === c ? null : s === r && c === o ? i : (o = c, i = t(r = s, a)));
  };
}
function nf(e, t, n) {
  var r, o, i;
  return function() {
    var s, a = n(this), c;
    return a == null ? void this.removeAttributeNS(e.space, e.local) : (s = this.getAttributeNS(e.space, e.local), c = a + "", s === c ? null : s === r && c === o ? i : (o = c, i = t(r = s, a)));
  };
}
function rf(e, t) {
  var n = Ln(e), r = n === "transform" ? Dd : bs;
  return this.attrTween(e, typeof t == "function" ? (n.local ? nf : tf)(n, r, Yr(this, "attr." + e, t)) : t == null ? (n.local ? Qd : Zd)(n) : (n.local ? ef : Jd)(n, r, t));
}
function of(e, t) {
  return function(n) {
    this.setAttribute(e, t.call(this, n));
  };
}
function sf(e, t) {
  return function(n) {
    this.setAttributeNS(e.space, e.local, t.call(this, n));
  };
}
function af(e, t) {
  var n, r;
  function o() {
    var i = t.apply(this, arguments);
    return i !== r && (n = (r = i) && sf(e, i)), n;
  }
  return o._value = t, o;
}
function cf(e, t) {
  var n, r;
  function o() {
    var i = t.apply(this, arguments);
    return i !== r && (n = (r = i) && of(e, i)), n;
  }
  return o._value = t, o;
}
function lf(e, t) {
  var n = "attr." + e;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (t == null) return this.tween(n, null);
  if (typeof t != "function") throw new Error();
  var r = Ln(e);
  return this.tween(n, (r.local ? af : cf)(r, t));
}
function uf(e, t) {
  return function() {
    Fr(this, e).delay = +t.apply(this, arguments);
  };
}
function df(e, t) {
  return t = +t, function() {
    Fr(this, e).delay = t;
  };
}
function ff(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? uf : df)(t, e)) : ke(this.node(), t).delay;
}
function hf(e, t) {
  return function() {
    Ae(this, e).duration = +t.apply(this, arguments);
  };
}
function gf(e, t) {
  return t = +t, function() {
    Ae(this, e).duration = t;
  };
}
function pf(e) {
  var t = this._id;
  return arguments.length ? this.each((typeof e == "function" ? hf : gf)(t, e)) : ke(this.node(), t).duration;
}
function mf(e, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Ae(this, e).ease = t;
  };
}
function yf(e) {
  var t = this._id;
  return arguments.length ? this.each(mf(t, e)) : ke(this.node(), t).ease;
}
function wf(e, t) {
  return function() {
    var n = t.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Ae(this, e).ease = n;
  };
}
function bf(e) {
  if (typeof e != "function") throw new Error();
  return this.each(wf(this._id, e));
}
function xf(e) {
  typeof e != "function" && (e = Ui(e));
  for (var t = this._groups, n = t.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = t[o], s = i.length, a = r[o] = [], c, l = 0; l < s; ++l)
      (c = i[l]) && e.call(c, c.__data__, l, i) && a.push(c);
  return new $e(r, this._parents, this._name, this._id);
}
function vf(e) {
  if (e._id !== this._id) throw new Error();
  for (var t = this._groups, n = e._groups, r = t.length, o = n.length, i = Math.min(r, o), s = new Array(r), a = 0; a < i; ++a)
    for (var c = t[a], l = n[a], u = c.length, d = s[a] = new Array(u), f, h = 0; h < u; ++h)
      (f = c[h] || l[h]) && (d[h] = f);
  for (; a < r; ++a)
    s[a] = t[a];
  return new $e(s, this._parents, this._name, this._id);
}
function Ef(e) {
  return (e + "").trim().split(/^|\s+/).every(function(t) {
    var n = t.indexOf(".");
    return n >= 0 && (t = t.slice(0, n)), !t || t === "start";
  });
}
function _f(e, t, n) {
  var r, o, i = Ef(t) ? Fr : Ae;
  return function() {
    var s = i(this, e), a = s.on;
    a !== r && (o = (r = a).copy()).on(t, n), s.on = o;
  };
}
function Sf(e, t) {
  var n = this._id;
  return arguments.length < 2 ? ke(this.node(), n).on.on(e) : this.each(_f(n, e, t));
}
function Nf(e) {
  return function() {
    var t = this.parentNode;
    for (var n in this.__transition) if (+n !== e) return;
    t && t.removeChild(this);
  };
}
function Cf() {
  return this.on("end.remove", Nf(this._id));
}
function kf(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Rr(e));
  for (var r = this._groups, o = r.length, i = new Array(o), s = 0; s < o; ++s)
    for (var a = r[s], c = a.length, l = i[s] = new Array(c), u, d, f = 0; f < c; ++f)
      (u = a[f]) && (d = e.call(u, u.__data__, f, a)) && ("__data__" in u && (d.__data__ = u.__data__), l[f] = d, Dn(l[f], t, n, f, l, ke(u, n)));
  return new $e(i, this._parents, t, n);
}
function Mf(e) {
  var t = this._name, n = this._id;
  typeof e != "function" && (e = Ki(e));
  for (var r = this._groups, o = r.length, i = [], s = [], a = 0; a < o; ++a)
    for (var c = r[a], l = c.length, u, d = 0; d < l; ++d)
      if (u = c[d]) {
        for (var f = e.call(u, u.__data__, d, c), h, g = ke(u, n), y = 0, w = f.length; y < w; ++y)
          (h = f[y]) && Dn(h, t, n, y, f, g);
        i.push(f), s.push(u);
      }
  return new $e(i, s, t, n);
}
var If = Yt.prototype.constructor;
function Pf() {
  return new If(this._groups, this._parents);
}
function Af(e, t) {
  var n, r, o;
  return function() {
    var i = lt(this, e), s = (this.style.removeProperty(e), lt(this, e));
    return i === s ? null : i === n && s === r ? o : o = t(n = i, r = s);
  };
}
function xs(e) {
  return function() {
    this.style.removeProperty(e);
  };
}
function Tf(e, t, n) {
  var r, o = n + "", i;
  return function() {
    var s = lt(this, e);
    return s === o ? null : s === r ? i : i = t(r = s, n);
  };
}
function Of(e, t, n) {
  var r, o, i;
  return function() {
    var s = lt(this, e), a = n(this), c = a + "";
    return a == null && (c = a = (this.style.removeProperty(e), lt(this, e))), s === c ? null : s === r && c === o ? i : (o = c, i = t(r = s, a));
  };
}
function Lf(e, t) {
  var n, r, o, i = "style." + t, s = "end." + i, a;
  return function() {
    var c = Ae(this, e), l = c.on, u = c.value[i] == null ? a || (a = xs(t)) : void 0;
    (l !== n || o !== u) && (r = (n = l).copy()).on(s, o = u), c.on = r;
  };
}
function $f(e, t, n) {
  var r = (e += "") == "transform" ? $d : bs;
  return t == null ? this.styleTween(e, Af(e, r)).on("end.style." + e, xs(e)) : typeof t == "function" ? this.styleTween(e, Of(e, r, Yr(this, "style." + e, t))).each(Lf(this._id, e)) : this.styleTween(e, Tf(e, r, t), n).on("end.style." + e, null);
}
function Df(e, t, n) {
  return function(r) {
    this.style.setProperty(e, t.call(this, r), n);
  };
}
function Rf(e, t, n) {
  var r, o;
  function i() {
    var s = t.apply(this, arguments);
    return s !== o && (r = (o = s) && Df(e, s, n)), r;
  }
  return i._value = t, i;
}
function zf(e, t, n) {
  var r = "style." + (e += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, Rf(e, t, n ?? ""));
}
function Vf(e) {
  return function() {
    this.textContent = e;
  };
}
function Hf(e) {
  return function() {
    var t = e(this);
    this.textContent = t ?? "";
  };
}
function Bf(e) {
  return this.tween("text", typeof e == "function" ? Hf(Yr(this, "text", e)) : Vf(e == null ? "" : e + ""));
}
function Ff(e) {
  return function(t) {
    this.textContent = e.call(this, t);
  };
}
function Yf(e) {
  var t, n;
  function r() {
    var o = e.apply(this, arguments);
    return o !== n && (t = (n = o) && Ff(o)), t;
  }
  return r._value = e, r;
}
function Xf(e) {
  var t = "text";
  if (arguments.length < 1) return (t = this.tween(t)) && t._value;
  if (e == null) return this.tween(t, null);
  if (typeof e != "function") throw new Error();
  return this.tween(t, Yf(e));
}
function Wf() {
  for (var e = this._name, t = this._id, n = vs(), r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s = r[i], a = s.length, c, l = 0; l < a; ++l)
      if (c = s[l]) {
        var u = ke(c, t);
        Dn(c, e, n, l, s, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new $e(r, this._parents, e, n);
}
function Gf() {
  var e, t, n = this, r = n._id, o = n.size();
  return new Promise(function(i, s) {
    var a = { value: s }, c = { value: function() {
      --o === 0 && i();
    } };
    n.each(function() {
      var l = Ae(this, r), u = l.on;
      u !== e && (t = (e = u).copy(), t._.cancel.push(a), t._.interrupt.push(a), t._.end.push(c)), l.on = t;
    }), o === 0 && i();
  });
}
var jf = 0;
function $e(e, t, n, r) {
  this._groups = e, this._parents = t, this._name = n, this._id = r;
}
function vs() {
  return ++jf;
}
var Oe = Yt.prototype;
$e.prototype = {
  constructor: $e,
  select: kf,
  selectAll: Mf,
  selectChild: Oe.selectChild,
  selectChildren: Oe.selectChildren,
  filter: xf,
  merge: vf,
  selection: Pf,
  transition: Wf,
  call: Oe.call,
  nodes: Oe.nodes,
  node: Oe.node,
  size: Oe.size,
  empty: Oe.empty,
  each: Oe.each,
  on: Sf,
  attr: rf,
  attrTween: lf,
  style: $f,
  styleTween: zf,
  text: Bf,
  textTween: Xf,
  remove: Cf,
  tween: Ud,
  delay: ff,
  duration: pf,
  ease: yf,
  easeVarying: bf,
  end: Gf,
  [Symbol.iterator]: Oe[Symbol.iterator]
};
function qf(e) {
  return ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2;
}
var Kf = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: qf
};
function Uf(e, t) {
  for (var n; !(n = e.__transition) || !(n = n[t]); )
    if (!(e = e.parentNode))
      throw new Error(`transition ${t} not found`);
  return n;
}
function Zf(e) {
  var t, n;
  e instanceof $e ? (t = e._id, e = e._name) : (t = vs(), (n = Kf).time = Br(), e = e == null ? null : e + "");
  for (var r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s = r[i], a = s.length, c, l = 0; l < a; ++l)
      (c = s[l]) && Dn(c, e, t, l, s, n || Uf(c, t));
  return new $e(r, this._parents, e, t);
}
Yt.prototype.interrupt = jd;
Yt.prototype.transition = Zf;
const nn = (e) => () => e;
function Qf(e, {
  sourceEvent: t,
  target: n,
  transform: r,
  dispatch: o
}) {
  Object.defineProperties(this, {
    type: { value: e, enumerable: !0, configurable: !0 },
    sourceEvent: { value: t, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: o }
  });
}
function Le(e, t, n) {
  this.k = e, this.x = t, this.y = n;
}
Le.prototype = {
  constructor: Le,
  scale: function(e) {
    return e === 1 ? this : new Le(this.k * e, this.x, this.y);
  },
  translate: function(e, t) {
    return e === 0 & t === 0 ? this : new Le(this.k, this.x + this.k * e, this.y + this.k * t);
  },
  apply: function(e) {
    return [e[0] * this.k + this.x, e[1] * this.k + this.y];
  },
  applyX: function(e) {
    return e * this.k + this.x;
  },
  applyY: function(e) {
    return e * this.k + this.y;
  },
  invert: function(e) {
    return [(e[0] - this.x) / this.k, (e[1] - this.y) / this.k];
  },
  invertX: function(e) {
    return (e - this.x) / this.k;
  },
  invertY: function(e) {
    return (e - this.y) / this.k;
  },
  rescaleX: function(e) {
    return e.copy().domain(e.range().map(this.invertX, this).map(e.invert, e));
  },
  rescaleY: function(e) {
    return e.copy().domain(e.range().map(this.invertY, this).map(e.invert, e));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Rn = new Le(1, 0, 0);
Es.prototype = Le.prototype;
function Es(e) {
  for (; !e.__zoom; ) if (!(e = e.parentNode)) return Rn;
  return e.__zoom;
}
function tr(e) {
  e.stopImmediatePropagation();
}
function St(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function Jf(e) {
  return (!e.ctrlKey || e.type === "wheel") && !e.button;
}
function eh() {
  var e = this;
  return e instanceof SVGElement ? (e = e.ownerSVGElement || e, e.hasAttribute("viewBox") ? (e = e.viewBox.baseVal, [[e.x, e.y], [e.x + e.width, e.y + e.height]]) : [[0, 0], [e.width.baseVal.value, e.height.baseVal.value]]) : [[0, 0], [e.clientWidth, e.clientHeight]];
}
function Oo() {
  return this.__zoom || Rn;
}
function th(e) {
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * (e.ctrlKey ? 10 : 1);
}
function nh() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function rh(e, t, n) {
  var r = e.invertX(t[0][0]) - n[0][0], o = e.invertX(t[1][0]) - n[1][0], i = e.invertY(t[0][1]) - n[0][1], s = e.invertY(t[1][1]) - n[1][1];
  return e.translate(
    o > r ? (r + o) / 2 : Math.min(0, r) || Math.max(0, o),
    s > i ? (i + s) / 2 : Math.min(0, i) || Math.max(0, s)
  );
}
function _s() {
  var e = Jf, t = eh, n = rh, r = th, o = nh, i = [0, 1 / 0], s = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], a = 250, c = dn, l = On("start", "zoom", "end"), u, d, f, h = 500, g = 150, y = 0, w = 10;
  function m(v) {
    v.property("__zoom", Oo).on("wheel.zoom", A, { passive: !1 }).on("mousedown.zoom", M).on("dblclick.zoom", z).filter(o).on("touchstart.zoom", P).on("touchmove.zoom", L).on("touchend.zoom touchcancel.zoom", V).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  m.transform = function(v, T, S, O) {
    var I = v.selection ? v.selection() : v;
    I.property("__zoom", Oo), v !== I ? _(v, T, S, O) : I.interrupt().each(function() {
      E(this, arguments).event(O).start().zoom(null, typeof T == "function" ? T.apply(this, arguments) : T).end();
    });
  }, m.scaleBy = function(v, T, S, O) {
    m.scaleTo(v, function() {
      var I = this.__zoom.k, N = typeof T == "function" ? T.apply(this, arguments) : T;
      return I * N;
    }, S, O);
  }, m.scaleTo = function(v, T, S, O) {
    m.transform(v, function() {
      var I = t.apply(this, arguments), N = this.__zoom, $ = S == null ? b(I) : typeof S == "function" ? S.apply(this, arguments) : S, R = N.invert($), D = typeof T == "function" ? T.apply(this, arguments) : T;
      return n(p(x(N, D), $, R), I, s);
    }, S, O);
  }, m.translateBy = function(v, T, S, O) {
    m.transform(v, function() {
      return n(this.__zoom.translate(
        typeof T == "function" ? T.apply(this, arguments) : T,
        typeof S == "function" ? S.apply(this, arguments) : S
      ), t.apply(this, arguments), s);
    }, null, O);
  }, m.translateTo = function(v, T, S, O, I) {
    m.transform(v, function() {
      var N = t.apply(this, arguments), $ = this.__zoom, R = O == null ? b(N) : typeof O == "function" ? O.apply(this, arguments) : O;
      return n(Rn.translate(R[0], R[1]).scale($.k).translate(
        typeof T == "function" ? -T.apply(this, arguments) : -T,
        typeof S == "function" ? -S.apply(this, arguments) : -S
      ), N, s);
    }, O, I);
  };
  function x(v, T) {
    return T = Math.max(i[0], Math.min(i[1], T)), T === v.k ? v : new Le(T, v.x, v.y);
  }
  function p(v, T, S) {
    var O = T[0] - S[0] * v.k, I = T[1] - S[1] * v.k;
    return O === v.x && I === v.y ? v : new Le(v.k, O, I);
  }
  function b(v) {
    return [(+v[0][0] + +v[1][0]) / 2, (+v[0][1] + +v[1][1]) / 2];
  }
  function _(v, T, S, O) {
    v.on("start.zoom", function() {
      E(this, arguments).event(O).start();
    }).on("interrupt.zoom end.zoom", function() {
      E(this, arguments).event(O).end();
    }).tween("zoom", function() {
      var I = this, N = arguments, $ = E(I, N).event(O), R = t.apply(I, N), D = S == null ? b(R) : typeof S == "function" ? S.apply(I, N) : S, F = Math.max(R[1][0] - R[0][0], R[1][1] - R[0][1]), Y = I.__zoom, X = typeof T == "function" ? T.apply(I, N) : T, q = c(Y.invert(D).concat(F / Y.k), X.invert(D).concat(F / X.k));
      return function(G) {
        if (G === 1) G = X;
        else {
          var H = q(G), W = F / H[2];
          G = new Le(W, D[0] - H[0] * W, D[1] - H[1] * W);
        }
        $.zoom(null, G);
      };
    });
  }
  function E(v, T, S) {
    return !S && v.__zooming || new C(v, T);
  }
  function C(v, T) {
    this.that = v, this.args = T, this.active = 0, this.sourceEvent = null, this.extent = t.apply(v, T), this.taps = 0;
  }
  C.prototype = {
    event: function(v) {
      return v && (this.sourceEvent = v), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(v, T) {
      return this.mouse && v !== "mouse" && (this.mouse[1] = T.invert(this.mouse[0])), this.touch0 && v !== "touch" && (this.touch0[1] = T.invert(this.touch0[0])), this.touch1 && v !== "touch" && (this.touch1[1] = T.invert(this.touch1[0])), this.that.__zoom = T, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(v) {
      var T = pe(this.that).datum();
      l.call(
        v,
        this.that,
        new Qf(v, {
          sourceEvent: this.sourceEvent,
          target: m,
          transform: this.that.__zoom,
          dispatch: l
        }),
        T
      );
    }
  };
  function A(v, ...T) {
    if (!e.apply(this, arguments)) return;
    var S = E(this, T).event(v), O = this.__zoom, I = Math.max(i[0], Math.min(i[1], O.k * Math.pow(2, r.apply(this, arguments)))), N = _e(v);
    if (S.wheel)
      (S.mouse[0][0] !== N[0] || S.mouse[0][1] !== N[1]) && (S.mouse[1] = O.invert(S.mouse[0] = N)), clearTimeout(S.wheel);
    else {
      if (O.k === I) return;
      S.mouse = [N, O.invert(N)], gn(this), S.start();
    }
    St(v), S.wheel = setTimeout($, g), S.zoom("mouse", n(p(x(O, I), S.mouse[0], S.mouse[1]), S.extent, s));
    function $() {
      S.wheel = null, S.end();
    }
  }
  function M(v, ...T) {
    if (f || !e.apply(this, arguments)) return;
    var S = v.currentTarget, O = E(this, T, !0).event(v), I = pe(v.view).on("mousemove.zoom", D, !0).on("mouseup.zoom", F, !0), N = _e(v, S), $ = v.clientX, R = v.clientY;
    ss(v.view), tr(v), O.mouse = [N, this.__zoom.invert(N)], gn(this), O.start();
    function D(Y) {
      if (St(Y), !O.moved) {
        var X = Y.clientX - $, q = Y.clientY - R;
        O.moved = X * X + q * q > y;
      }
      O.event(Y).zoom("mouse", n(p(O.that.__zoom, O.mouse[0] = _e(Y, S), O.mouse[1]), O.extent, s));
    }
    function F(Y) {
      I.on("mousemove.zoom mouseup.zoom", null), as(Y.view, O.moved), St(Y), O.event(Y).end();
    }
  }
  function z(v, ...T) {
    if (e.apply(this, arguments)) {
      var S = this.__zoom, O = _e(v.changedTouches ? v.changedTouches[0] : v, this), I = S.invert(O), N = S.k * (v.shiftKey ? 0.5 : 2), $ = n(p(x(S, N), O, I), t.apply(this, T), s);
      St(v), a > 0 ? pe(this).transition().duration(a).call(_, $, O, v) : pe(this).call(m.transform, $, O, v);
    }
  }
  function P(v, ...T) {
    if (e.apply(this, arguments)) {
      var S = v.touches, O = S.length, I = E(this, T, v.changedTouches.length === O).event(v), N, $, R, D;
      for (tr(v), $ = 0; $ < O; ++$)
        R = S[$], D = _e(R, this), D = [D, this.__zoom.invert(D), R.identifier], I.touch0 ? !I.touch1 && I.touch0[2] !== D[2] && (I.touch1 = D, I.taps = 0) : (I.touch0 = D, N = !0, I.taps = 1 + !!u);
      u && (u = clearTimeout(u)), N && (I.taps < 2 && (d = D[0], u = setTimeout(function() {
        u = null;
      }, h)), gn(this), I.start());
    }
  }
  function L(v, ...T) {
    if (this.__zooming) {
      var S = E(this, T).event(v), O = v.changedTouches, I = O.length, N, $, R, D;
      for (St(v), N = 0; N < I; ++N)
        $ = O[N], R = _e($, this), S.touch0 && S.touch0[2] === $.identifier ? S.touch0[0] = R : S.touch1 && S.touch1[2] === $.identifier && (S.touch1[0] = R);
      if ($ = S.that.__zoom, S.touch1) {
        var F = S.touch0[0], Y = S.touch0[1], X = S.touch1[0], q = S.touch1[1], G = (G = X[0] - F[0]) * G + (G = X[1] - F[1]) * G, H = (H = q[0] - Y[0]) * H + (H = q[1] - Y[1]) * H;
        $ = x($, Math.sqrt(G / H)), R = [(F[0] + X[0]) / 2, (F[1] + X[1]) / 2], D = [(Y[0] + q[0]) / 2, (Y[1] + q[1]) / 2];
      } else if (S.touch0) R = S.touch0[0], D = S.touch0[1];
      else return;
      S.zoom("touch", n(p($, R, D), S.extent, s));
    }
  }
  function V(v, ...T) {
    if (this.__zooming) {
      var S = E(this, T).event(v), O = v.changedTouches, I = O.length, N, $;
      for (tr(v), f && clearTimeout(f), f = setTimeout(function() {
        f = null;
      }, h), N = 0; N < I; ++N)
        $ = O[N], S.touch0 && S.touch0[2] === $.identifier ? delete S.touch0 : S.touch1 && S.touch1[2] === $.identifier && delete S.touch1;
      if (S.touch1 && !S.touch0 && (S.touch0 = S.touch1, delete S.touch1), S.touch0) S.touch0[1] = this.__zoom.invert(S.touch0[0]);
      else if (S.end(), S.taps === 2 && ($ = _e($, this), Math.hypot(d[0] - $[0], d[1] - $[1]) < w)) {
        var R = pe(this).on("dblclick.zoom");
        R && R.apply(this, arguments);
      }
    }
  }
  return m.wheelDelta = function(v) {
    return arguments.length ? (r = typeof v == "function" ? v : nn(+v), m) : r;
  }, m.filter = function(v) {
    return arguments.length ? (e = typeof v == "function" ? v : nn(!!v), m) : e;
  }, m.touchable = function(v) {
    return arguments.length ? (o = typeof v == "function" ? v : nn(!!v), m) : o;
  }, m.extent = function(v) {
    return arguments.length ? (t = typeof v == "function" ? v : nn([[+v[0][0], +v[0][1]], [+v[1][0], +v[1][1]]]), m) : t;
  }, m.scaleExtent = function(v) {
    return arguments.length ? (i[0] = +v[0], i[1] = +v[1], m) : [i[0], i[1]];
  }, m.translateExtent = function(v) {
    return arguments.length ? (s[0][0] = +v[0][0], s[1][0] = +v[1][0], s[0][1] = +v[0][1], s[1][1] = +v[1][1], m) : [[s[0][0], s[0][1]], [s[1][0], s[1][1]]];
  }, m.constrain = function(v) {
    return arguments.length ? (n = v, m) : n;
  }, m.duration = function(v) {
    return arguments.length ? (a = +v, m) : a;
  }, m.interpolate = function(v) {
    return arguments.length ? (c = v, m) : c;
  }, m.on = function() {
    var v = l.on.apply(l, arguments);
    return v === l ? m : v;
  }, m.clickDistance = function(v) {
    return arguments.length ? (y = (v = +v) * v, m) : Math.sqrt(y);
  }, m.tapDistance = function(v) {
    return arguments.length ? (w = +v, m) : w;
  }, m;
}
const be = {
  error001: () => "[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001",
  error002: () => "It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
  error003: (e) => `Node type "${e}" not found. Using fallback type "default".`,
  error004: () => "The React Flow parent container needs a width and a height to render the graph.",
  error005: () => "Only child nodes can use a parent extent.",
  error006: () => "Can't create edge. An edge needs a source and a target.",
  error007: (e) => `The old edge with id=${e} does not exist.`,
  error009: (e) => `Marker type "${e}" doesn't exist.`,
  error008: (e, { id: t, sourceHandle: n, targetHandle: r }) => `Couldn't create edge for ${e} handle id: "${e === "source" ? n : r}", edge id: ${t}.`,
  error010: () => "Handle: No node id found. Make sure to only use a Handle inside a custom Node.",
  error011: (e) => `Edge type "${e}" not found. Using fallback type "default".`,
  error012: (e) => `Node with id "${e}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`,
  error013: (e = "react") => `It seems that you haven't loaded the styles. Please import '@xyflow/${e}/dist/style.css' or base.css to make sure everything is working properly.`,
  error014: () => "useNodeConnections: No node ID found. Call useNodeConnections inside a custom Node or provide a node ID.",
  error015: () => "It seems that you are trying to drag a node that is not initialized. Please use onNodesChange as explained in the docs."
}, $t = [
  [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
  [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
], Ss = ["Enter", " ", "Escape"], Ns = {
  "node.a11yDescription.default": "Press enter or space to select a node. Press delete to remove it and escape to cancel.",
  "node.a11yDescription.keyboardDisabled": "Press enter or space to select a node. You can then use the arrow keys to move the node around. Press delete to remove it and escape to cancel.",
  "node.a11yDescription.ariaLiveMessage": ({ direction: e, x: t, y: n }) => `Moved selected node ${e}. New position, x: ${t}, y: ${n}`,
  "edge.a11yDescription.default": "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel.",
  // Control elements
  "controls.ariaLabel": "Control Panel",
  "controls.zoomIn.ariaLabel": "Zoom In",
  "controls.zoomOut.ariaLabel": "Zoom Out",
  "controls.fitView.ariaLabel": "Fit View",
  "controls.interactive.ariaLabel": "Toggle Interactivity",
  // Mini map
  "minimap.ariaLabel": "Mini Map",
  // Handle
  "handle.ariaLabel": "Handle"
};
var dt;
(function(e) {
  e.Strict = "strict", e.Loose = "loose";
})(dt || (dt = {}));
var qe;
(function(e) {
  e.Free = "free", e.Vertical = "vertical", e.Horizontal = "horizontal";
})(qe || (qe = {}));
var Dt;
(function(e) {
  e.Partial = "partial", e.Full = "full";
})(Dt || (Dt = {}));
const Cs = {
  inProgress: !1,
  isValid: null,
  from: null,
  fromHandle: null,
  fromPosition: null,
  fromNode: null,
  to: null,
  toHandle: null,
  toPosition: null,
  toNode: null,
  pointer: null
};
var Be;
(function(e) {
  e.Bezier = "default", e.Straight = "straight", e.Step = "step", e.SmoothStep = "smoothstep", e.SimpleBezier = "simplebezier";
})(Be || (Be = {}));
var En;
(function(e) {
  e.Arrow = "arrow", e.ArrowClosed = "arrowclosed";
})(En || (En = {}));
var B;
(function(e) {
  e.Left = "left", e.Top = "top", e.Right = "right", e.Bottom = "bottom";
})(B || (B = {}));
const Lo = {
  [B.Left]: B.Right,
  [B.Right]: B.Left,
  [B.Top]: B.Bottom,
  [B.Bottom]: B.Top
};
function ks(e) {
  return e === null ? null : e ? "valid" : "invalid";
}
const Ms = (e) => "id" in e && "source" in e && "target" in e, oh = (e) => "id" in e && "position" in e && !("source" in e) && !("target" in e), Xr = (e) => "id" in e && "internals" in e && !("source" in e) && !("target" in e), Wt = (e, t = [0, 0]) => {
  const { width: n, height: r } = De(e), o = e.origin ?? t, i = n * o[0], s = r * o[1];
  return {
    x: e.position.x - i,
    y: e.position.y - s
  };
}, ih = (e, t = { nodeOrigin: [0, 0] }) => {
  if (process.env.NODE_ENV === "development" && !t.nodeLookup && console.warn("Please use `getNodesBounds` from `useReactFlow`/`useSvelteFlow` hook to ensure correct values for sub flows. If not possible, you have to provide a nodeLookup to support sub flows."), e.length === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  const n = e.reduce((r, o) => {
    const i = typeof o == "string";
    let s = !t.nodeLookup && !i ? o : void 0;
    t.nodeLookup && (s = i ? t.nodeLookup.get(o) : Xr(o) ? o : t.nodeLookup.get(o.id));
    const a = s ? _n(s, t.nodeOrigin) : { x: 0, y: 0, x2: 0, y2: 0 };
    return zn(r, a);
  }, { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 });
  return Vn(n);
}, Gt = (e, t = {}) => {
  let n = { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 }, r = !1;
  return e.forEach((o) => {
    (t.filter === void 0 || t.filter(o)) && (n = zn(n, _n(o)), r = !0);
  }), r ? Vn(n) : { x: 0, y: 0, width: 0, height: 0 };
}, Wr = (e, t, [n, r, o] = [0, 0, 1], i = !1, s = !1) => {
  const a = {
    ...qt(t, [n, r, o]),
    width: t.width / o,
    height: t.height / o
  }, c = [];
  for (const l of e.values()) {
    const { measured: u, selectable: d = !0, hidden: f = !1 } = l;
    if (s && !d || f)
      continue;
    const h = u.width ?? l.width ?? l.initialWidth ?? null, g = u.height ?? l.height ?? l.initialHeight ?? null, y = Rt(a, ht(l)), w = (h ?? 0) * (g ?? 0), m = i && y > 0;
    (!l.internals.handleBounds || m || y >= w || l.dragging) && c.push(l);
  }
  return c;
}, sh = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    n.add(r.id);
  }), t.filter((r) => n.has(r.source) || n.has(r.target));
};
function ah(e, t) {
  const n = /* @__PURE__ */ new Map(), r = t != null && t.nodes ? new Set(t.nodes.map((o) => o.id)) : null;
  return e.forEach((o) => {
    o.measured.width && o.measured.height && ((t == null ? void 0 : t.includeHiddenNodes) || !o.hidden) && (!r || r.has(o.id)) && n.set(o.id, o);
  }), n;
}
async function ch({ nodes: e, width: t, height: n, panZoom: r, minZoom: o, maxZoom: i }, s) {
  if (e.size === 0)
    return Promise.resolve(!0);
  const a = ah(e, s), c = Gt(a), l = Gr(c, t, n, (s == null ? void 0 : s.minZoom) ?? o, (s == null ? void 0 : s.maxZoom) ?? i, (s == null ? void 0 : s.padding) ?? 0.1);
  return await r.setViewport(l, {
    duration: s == null ? void 0 : s.duration,
    ease: s == null ? void 0 : s.ease,
    interpolate: s == null ? void 0 : s.interpolate
  }), Promise.resolve(!0);
}
function Is({ nodeId: e, nextPosition: t, nodeLookup: n, nodeOrigin: r = [0, 0], nodeExtent: o, onError: i }) {
  const s = n.get(e), a = s.parentId ? n.get(s.parentId) : void 0, { x: c, y: l } = a ? a.internals.positionAbsolute : { x: 0, y: 0 }, u = s.origin ?? r;
  let d = s.extent || o;
  if (s.extent === "parent" && !s.expandParent)
    if (!a)
      i == null || i("005", be.error005());
    else {
      const h = a.measured.width, g = a.measured.height;
      h && g && (d = [
        [c, l],
        [c + h, l + g]
      ]);
    }
  else a && gt(s.extent) && (d = [
    [s.extent[0][0] + c, s.extent[0][1] + l],
    [s.extent[1][0] + c, s.extent[1][1] + l]
  ]);
  const f = gt(d) ? Ze(t, d, s.measured) : t;
  return (s.measured.width === void 0 || s.measured.height === void 0) && (i == null || i("015", be.error015())), {
    position: {
      x: f.x - c + (s.measured.width ?? 0) * u[0],
      y: f.y - l + (s.measured.height ?? 0) * u[1]
    },
    positionAbsolute: f
  };
}
async function lh({ nodesToRemove: e = [], edgesToRemove: t = [], nodes: n, edges: r, onBeforeDelete: o }) {
  const i = new Set(e.map((f) => f.id)), s = [];
  for (const f of n) {
    if (f.deletable === !1)
      continue;
    const h = i.has(f.id), g = !h && f.parentId && s.find((y) => y.id === f.parentId);
    (h || g) && s.push(f);
  }
  const a = new Set(t.map((f) => f.id)), c = r.filter((f) => f.deletable !== !1), u = sh(s, c);
  for (const f of c)
    a.has(f.id) && !u.find((g) => g.id === f.id) && u.push(f);
  if (!o)
    return {
      edges: u,
      nodes: s
    };
  const d = await o({
    nodes: s,
    edges: u
  });
  return typeof d == "boolean" ? d ? { edges: u, nodes: s } : { edges: [], nodes: [] } : d;
}
const ft = (e, t = 0, n = 1) => Math.min(Math.max(e, t), n), Ze = (e = { x: 0, y: 0 }, t, n) => ({
  x: ft(e.x, t[0][0], t[1][0] - ((n == null ? void 0 : n.width) ?? 0)),
  y: ft(e.y, t[0][1], t[1][1] - ((n == null ? void 0 : n.height) ?? 0))
});
function Ps(e, t, n) {
  const { width: r, height: o } = De(n), { x: i, y: s } = n.internals.positionAbsolute;
  return Ze(e, [
    [i, s],
    [i + r, s + o]
  ], t);
}
const $o = (e, t, n) => e < t ? ft(Math.abs(e - t), 1, t) / t : e > n ? -ft(Math.abs(e - n), 1, t) / t : 0, As = (e, t, n = 15, r = 40) => {
  const o = $o(e.x, r, t.width - r) * n, i = $o(e.y, r, t.height - r) * n;
  return [o, i];
}, zn = (e, t) => ({
  x: Math.min(e.x, t.x),
  y: Math.min(e.y, t.y),
  x2: Math.max(e.x2, t.x2),
  y2: Math.max(e.y2, t.y2)
}), Cr = ({ x: e, y: t, width: n, height: r }) => ({
  x: e,
  y: t,
  x2: e + n,
  y2: t + r
}), Vn = ({ x: e, y: t, x2: n, y2: r }) => ({
  x: e,
  y: t,
  width: n - e,
  height: r - t
}), ht = (e, t = [0, 0]) => {
  var o, i;
  const { x: n, y: r } = Xr(e) ? e.internals.positionAbsolute : Wt(e, t);
  return {
    x: n,
    y: r,
    width: ((o = e.measured) == null ? void 0 : o.width) ?? e.width ?? e.initialWidth ?? 0,
    height: ((i = e.measured) == null ? void 0 : i.height) ?? e.height ?? e.initialHeight ?? 0
  };
}, _n = (e, t = [0, 0]) => {
  var o, i;
  const { x: n, y: r } = Xr(e) ? e.internals.positionAbsolute : Wt(e, t);
  return {
    x: n,
    y: r,
    x2: n + (((o = e.measured) == null ? void 0 : o.width) ?? e.width ?? e.initialWidth ?? 0),
    y2: r + (((i = e.measured) == null ? void 0 : i.height) ?? e.height ?? e.initialHeight ?? 0)
  };
}, Ts = (e, t) => Vn(zn(Cr(e), Cr(t))), Rt = (e, t) => {
  const n = Math.max(0, Math.min(e.x + e.width, t.x + t.width) - Math.max(e.x, t.x)), r = Math.max(0, Math.min(e.y + e.height, t.y + t.height) - Math.max(e.y, t.y));
  return Math.ceil(n * r);
}, Do = (e) => Ne(e.width) && Ne(e.height) && Ne(e.x) && Ne(e.y), Ne = (e) => !isNaN(e) && isFinite(e), Os = (e, t) => {
  process.env.NODE_ENV === "development" && console.warn(`[React Flow]: ${t} Help: https://reactflow.dev/error#${e}`);
}, jt = (e, t = [1, 1]) => ({
  x: t[0] * Math.round(e.x / t[0]),
  y: t[1] * Math.round(e.y / t[1])
}), qt = ({ x: e, y: t }, [n, r, o], i = !1, s = [1, 1]) => {
  const a = {
    x: (e - n) / o,
    y: (t - r) / o
  };
  return i ? jt(a, s) : a;
}, Sn = ({ x: e, y: t }, [n, r, o]) => ({
  x: e * o + n,
  y: t * o + r
});
function tt(e, t) {
  if (typeof e == "number")
    return Math.floor((t - t / (1 + e)) * 0.5);
  if (typeof e == "string" && e.endsWith("px")) {
    const n = parseFloat(e);
    if (!Number.isNaN(n))
      return Math.floor(n);
  }
  if (typeof e == "string" && e.endsWith("%")) {
    const n = parseFloat(e);
    if (!Number.isNaN(n))
      return Math.floor(t * n * 0.01);
  }
  return console.error(`[React Flow] The padding value "${e}" is invalid. Please provide a number or a string with a valid unit (px or %).`), 0;
}
function uh(e, t, n) {
  if (typeof e == "string" || typeof e == "number") {
    const r = tt(e, n), o = tt(e, t);
    return {
      top: r,
      right: o,
      bottom: r,
      left: o,
      x: o * 2,
      y: r * 2
    };
  }
  if (typeof e == "object") {
    const r = tt(e.top ?? e.y ?? 0, n), o = tt(e.bottom ?? e.y ?? 0, n), i = tt(e.left ?? e.x ?? 0, t), s = tt(e.right ?? e.x ?? 0, t);
    return { top: r, right: s, bottom: o, left: i, x: i + s, y: r + o };
  }
  return { top: 0, right: 0, bottom: 0, left: 0, x: 0, y: 0 };
}
function dh(e, t, n, r, o, i) {
  const { x: s, y: a } = Sn(e, [t, n, r]), { x: c, y: l } = Sn({ x: e.x + e.width, y: e.y + e.height }, [t, n, r]), u = o - c, d = i - l;
  return {
    left: Math.floor(s),
    top: Math.floor(a),
    right: Math.floor(u),
    bottom: Math.floor(d)
  };
}
const Gr = (e, t, n, r, o, i) => {
  const s = uh(i, t, n), a = (t - s.x) / e.width, c = (n - s.y) / e.height, l = Math.min(a, c), u = ft(l, r, o), d = e.x + e.width / 2, f = e.y + e.height / 2, h = t / 2 - d * u, g = n / 2 - f * u, y = dh(e, h, g, u, t, n), w = {
    left: Math.min(y.left - s.left, 0),
    top: Math.min(y.top - s.top, 0),
    right: Math.min(y.right - s.right, 0),
    bottom: Math.min(y.bottom - s.bottom, 0)
  };
  return {
    x: h - w.left + w.right,
    y: g - w.top + w.bottom,
    zoom: u
  };
}, zt = () => {
  var e;
  return typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : e.indexOf("Mac")) >= 0;
};
function gt(e) {
  return e != null && e !== "parent";
}
function De(e) {
  var t, n;
  return {
    width: ((t = e.measured) == null ? void 0 : t.width) ?? e.width ?? e.initialWidth ?? 0,
    height: ((n = e.measured) == null ? void 0 : n.height) ?? e.height ?? e.initialHeight ?? 0
  };
}
function Ls(e) {
  var t, n;
  return (((t = e.measured) == null ? void 0 : t.width) ?? e.width ?? e.initialWidth) !== void 0 && (((n = e.measured) == null ? void 0 : n.height) ?? e.height ?? e.initialHeight) !== void 0;
}
function $s(e, t = { width: 0, height: 0 }, n, r, o) {
  const i = { ...e }, s = r.get(n);
  if (s) {
    const a = s.origin || o;
    i.x += s.internals.positionAbsolute.x - (t.width ?? 0) * a[0], i.y += s.internals.positionAbsolute.y - (t.height ?? 0) * a[1];
  }
  return i;
}
function Ro(e, t) {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
}
function fh() {
  let e, t;
  return { promise: new Promise((r, o) => {
    e = r, t = o;
  }), resolve: e, reject: t };
}
function hh(e) {
  return { ...Ns, ...e || {} };
}
function Pt(e, { snapGrid: t = [0, 0], snapToGrid: n = !1, transform: r, containerBounds: o }) {
  const { x: i, y: s } = Ce(e), a = qt({ x: i - ((o == null ? void 0 : o.left) ?? 0), y: s - ((o == null ? void 0 : o.top) ?? 0) }, r), { x: c, y: l } = n ? jt(a, t) : a;
  return {
    xSnapped: c,
    ySnapped: l,
    ...a
  };
}
const jr = (e) => ({
  width: e.offsetWidth,
  height: e.offsetHeight
}), Ds = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.getRootNode) == null ? void 0 : t.call(e)) || (window == null ? void 0 : window.document);
}, gh = ["INPUT", "SELECT", "TEXTAREA"];
function Rs(e) {
  var r, o;
  const t = ((o = (r = e.composedPath) == null ? void 0 : r.call(e)) == null ? void 0 : o[0]) || e.target;
  return (t == null ? void 0 : t.nodeType) !== 1 ? !1 : gh.includes(t.nodeName) || t.hasAttribute("contenteditable") || !!t.closest(".nokey");
}
const zs = (e) => "clientX" in e, Ce = (e, t) => {
  var i, s;
  const n = zs(e), r = n ? e.clientX : (i = e.touches) == null ? void 0 : i[0].clientX, o = n ? e.clientY : (s = e.touches) == null ? void 0 : s[0].clientY;
  return {
    x: r - ((t == null ? void 0 : t.left) ?? 0),
    y: o - ((t == null ? void 0 : t.top) ?? 0)
  };
}, zo = (e, t, n, r, o) => {
  const i = t.querySelectorAll(`.${e}`);
  return !i || !i.length ? null : Array.from(i).map((s) => {
    const a = s.getBoundingClientRect();
    return {
      id: s.getAttribute("data-handleid"),
      type: e,
      nodeId: o,
      position: s.getAttribute("data-handlepos"),
      x: (a.left - n.left) / r,
      y: (a.top - n.top) / r,
      ...jr(s)
    };
  });
};
function Vs({ sourceX: e, sourceY: t, targetX: n, targetY: r, sourceControlX: o, sourceControlY: i, targetControlX: s, targetControlY: a }) {
  const c = e * 0.125 + o * 0.375 + s * 0.375 + n * 0.125, l = t * 0.125 + i * 0.375 + a * 0.375 + r * 0.125, u = Math.abs(c - e), d = Math.abs(l - t);
  return [c, l, u, d];
}
function rn(e, t) {
  return e >= 0 ? 0.5 * e : t * 25 * Math.sqrt(-e);
}
function Vo({ pos: e, x1: t, y1: n, x2: r, y2: o, c: i }) {
  switch (e) {
    case B.Left:
      return [t - rn(t - r, i), n];
    case B.Right:
      return [t + rn(r - t, i), n];
    case B.Top:
      return [t, n - rn(n - o, i)];
    case B.Bottom:
      return [t, n + rn(o - n, i)];
  }
}
function qr({ sourceX: e, sourceY: t, sourcePosition: n = B.Bottom, targetX: r, targetY: o, targetPosition: i = B.Top, curvature: s = 0.25 }) {
  const [a, c] = Vo({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: o,
    c: s
  }), [l, u] = Vo({
    pos: i,
    x1: r,
    y1: o,
    x2: e,
    y2: t,
    c: s
  }), [d, f, h, g] = Vs({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: o,
    sourceControlX: a,
    sourceControlY: c,
    targetControlX: l,
    targetControlY: u
  });
  return [
    `M${e},${t} C${a},${c} ${l},${u} ${r},${o}`,
    d,
    f,
    h,
    g
  ];
}
function Hs({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const o = Math.abs(n - e) / 2, i = n < e ? n + o : n - o, s = Math.abs(r - t) / 2, a = r < t ? r + s : r - s;
  return [i, a, o, s];
}
function ph({ sourceNode: e, targetNode: t, selected: n = !1, zIndex: r = 0, elevateOnSelect: o = !1, zIndexMode: i = "basic" }) {
  if (i === "manual")
    return r;
  const s = o && n ? r + 1e3 : r, a = Math.max(e.parentId || o && e.selected ? e.internals.z : 0, t.parentId || o && t.selected ? t.internals.z : 0);
  return s + a;
}
function mh({ sourceNode: e, targetNode: t, width: n, height: r, transform: o }) {
  const i = zn(_n(e), _n(t));
  i.x === i.x2 && (i.x2 += 1), i.y === i.y2 && (i.y2 += 1);
  const s = {
    x: -o[0] / o[2],
    y: -o[1] / o[2],
    width: n / o[2],
    height: r / o[2]
  };
  return Rt(s, Vn(i)) > 0;
}
const yh = ({ source: e, sourceHandle: t, target: n, targetHandle: r }) => `xy-edge__${e}${t || ""}-${n}${r || ""}`, wh = (e, t) => t.some((n) => n.source === e.source && n.target === e.target && (n.sourceHandle === e.sourceHandle || !n.sourceHandle && !e.sourceHandle) && (n.targetHandle === e.targetHandle || !n.targetHandle && !e.targetHandle)), bh = (e, t, n = {}) => {
  if (!e.source || !e.target)
    return Os("006", be.error006()), t;
  const r = n.getEdgeId || yh;
  let o;
  return Ms(e) ? o = { ...e } : o = {
    ...e,
    id: r(e)
  }, wh(o, t) ? t : (o.sourceHandle === null && delete o.sourceHandle, o.targetHandle === null && delete o.targetHandle, t.concat(o));
};
function Bs({ sourceX: e, sourceY: t, targetX: n, targetY: r }) {
  const [o, i, s, a] = Hs({
    sourceX: e,
    sourceY: t,
    targetX: n,
    targetY: r
  });
  return [`M ${e},${t}L ${n},${r}`, o, i, s, a];
}
const Ho = {
  [B.Left]: { x: -1, y: 0 },
  [B.Right]: { x: 1, y: 0 },
  [B.Top]: { x: 0, y: -1 },
  [B.Bottom]: { x: 0, y: 1 }
}, xh = ({ source: e, sourcePosition: t = B.Bottom, target: n }) => t === B.Left || t === B.Right ? e.x < n.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : e.y < n.y ? { x: 0, y: 1 } : { x: 0, y: -1 }, Bo = (e, t) => Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
function vh({ source: e, sourcePosition: t = B.Bottom, target: n, targetPosition: r = B.Top, center: o, offset: i, stepPosition: s }) {
  const a = Ho[t], c = Ho[r], l = { x: e.x + a.x * i, y: e.y + a.y * i }, u = { x: n.x + c.x * i, y: n.y + c.y * i }, d = xh({
    source: l,
    sourcePosition: t,
    target: u
  }), f = d.x !== 0 ? "x" : "y", h = d[f];
  let g = [], y, w;
  const m = { x: 0, y: 0 }, x = { x: 0, y: 0 }, [, , p, b] = Hs({
    sourceX: e.x,
    sourceY: e.y,
    targetX: n.x,
    targetY: n.y
  });
  if (a[f] * c[f] === -1) {
    f === "x" ? (y = o.x ?? l.x + (u.x - l.x) * s, w = o.y ?? (l.y + u.y) / 2) : (y = o.x ?? (l.x + u.x) / 2, w = o.y ?? l.y + (u.y - l.y) * s);
    const A = [
      { x: y, y: l.y },
      { x: y, y: u.y }
    ], M = [
      { x: l.x, y: w },
      { x: u.x, y: w }
    ];
    a[f] === h ? g = f === "x" ? A : M : g = f === "x" ? M : A;
  } else {
    const A = [{ x: l.x, y: u.y }], M = [{ x: u.x, y: l.y }];
    if (f === "x" ? g = a.x === h ? M : A : g = a.y === h ? A : M, t === r) {
      const v = Math.abs(e[f] - n[f]);
      if (v <= i) {
        const T = Math.min(i - 1, i - v);
        a[f] === h ? m[f] = (l[f] > e[f] ? -1 : 1) * T : x[f] = (u[f] > n[f] ? -1 : 1) * T;
      }
    }
    if (t !== r) {
      const v = f === "x" ? "y" : "x", T = a[f] === c[v], S = l[v] > u[v], O = l[v] < u[v];
      (a[f] === 1 && (!T && S || T && O) || a[f] !== 1 && (!T && O || T && S)) && (g = f === "x" ? A : M);
    }
    const z = { x: l.x + m.x, y: l.y + m.y }, P = { x: u.x + x.x, y: u.y + x.y }, L = Math.max(Math.abs(z.x - g[0].x), Math.abs(P.x - g[0].x)), V = Math.max(Math.abs(z.y - g[0].y), Math.abs(P.y - g[0].y));
    L >= V ? (y = (z.x + P.x) / 2, w = g[0].y) : (y = g[0].x, w = (z.y + P.y) / 2);
  }
  const _ = { x: l.x + m.x, y: l.y + m.y }, E = { x: u.x + x.x, y: u.y + x.y };
  return [[
    e,
    // we only want to add the gapped source/target if they are different from the first/last point to avoid duplicates which can cause issues with the bends
    ..._.x !== g[0].x || _.y !== g[0].y ? [_] : [],
    ...g,
    ...E.x !== g[g.length - 1].x || E.y !== g[g.length - 1].y ? [E] : [],
    n
  ], y, w, p, b];
}
function Eh(e, t, n, r) {
  const o = Math.min(Bo(e, t) / 2, Bo(t, n) / 2, r), { x: i, y: s } = t;
  if (e.x === i && i === n.x || e.y === s && s === n.y)
    return `L${i} ${s}`;
  if (e.y === s) {
    const l = e.x < n.x ? -1 : 1, u = e.y < n.y ? 1 : -1;
    return `L ${i + o * l},${s}Q ${i},${s} ${i},${s + o * u}`;
  }
  const a = e.x < n.x ? 1 : -1, c = e.y < n.y ? -1 : 1;
  return `L ${i},${s + o * c}Q ${i},${s} ${i + o * a},${s}`;
}
function Nn({ sourceX: e, sourceY: t, sourcePosition: n = B.Bottom, targetX: r, targetY: o, targetPosition: i = B.Top, borderRadius: s = 5, centerX: a, centerY: c, offset: l = 20, stepPosition: u = 0.5 }) {
  const [d, f, h, g, y] = vh({
    source: { x: e, y: t },
    sourcePosition: n,
    target: { x: r, y: o },
    targetPosition: i,
    center: { x: a, y: c },
    offset: l,
    stepPosition: u
  });
  let w = `M${d[0].x} ${d[0].y}`;
  for (let m = 1; m < d.length - 1; m++)
    w += Eh(d[m - 1], d[m], d[m + 1], s);
  return w += `L${d[d.length - 1].x} ${d[d.length - 1].y}`, [w, f, h, g, y];
}
function Fo(e) {
  var t;
  return e && !!(e.internals.handleBounds || (t = e.handles) != null && t.length) && !!(e.measured.width || e.width || e.initialWidth);
}
function _h(e) {
  var d;
  const { sourceNode: t, targetNode: n } = e;
  if (!Fo(t) || !Fo(n))
    return null;
  const r = t.internals.handleBounds || Yo(t.handles), o = n.internals.handleBounds || Yo(n.handles), i = Xo((r == null ? void 0 : r.source) ?? [], e.sourceHandle), s = Xo(
    // when connection type is loose we can define all handles as sources and connect source -> source
    e.connectionMode === dt.Strict ? (o == null ? void 0 : o.target) ?? [] : ((o == null ? void 0 : o.target) ?? []).concat((o == null ? void 0 : o.source) ?? []),
    e.targetHandle
  );
  if (!i || !s)
    return (d = e.onError) == null || d.call(e, "008", be.error008(i ? "target" : "source", {
      id: e.id,
      sourceHandle: e.sourceHandle,
      targetHandle: e.targetHandle
    })), null;
  const a = (i == null ? void 0 : i.position) || B.Bottom, c = (s == null ? void 0 : s.position) || B.Top, l = Qe(t, i, a), u = Qe(n, s, c);
  return {
    sourceX: l.x,
    sourceY: l.y,
    targetX: u.x,
    targetY: u.y,
    sourcePosition: a,
    targetPosition: c
  };
}
function Yo(e) {
  if (!e)
    return null;
  const t = [], n = [];
  for (const r of e)
    r.width = r.width ?? 1, r.height = r.height ?? 1, r.type === "source" ? t.push(r) : r.type === "target" && n.push(r);
  return {
    source: t,
    target: n
  };
}
function Qe(e, t, n = B.Left, r = !1) {
  const o = ((t == null ? void 0 : t.x) ?? 0) + e.internals.positionAbsolute.x, i = ((t == null ? void 0 : t.y) ?? 0) + e.internals.positionAbsolute.y, { width: s, height: a } = t ?? De(e);
  if (r)
    return { x: o + s / 2, y: i + a / 2 };
  switch ((t == null ? void 0 : t.position) ?? n) {
    case B.Top:
      return { x: o + s / 2, y: i };
    case B.Right:
      return { x: o + s, y: i + a / 2 };
    case B.Bottom:
      return { x: o + s / 2, y: i + a };
    case B.Left:
      return { x: o, y: i + a / 2 };
  }
}
function Xo(e, t) {
  return e && (t ? e.find((n) => n.id === t) : e[0]) || null;
}
function kr(e, t) {
  return e ? typeof e == "string" ? e : `${t ? `${t}__` : ""}${Object.keys(e).sort().map((r) => `${r}=${e[r]}`).join("&")}` : "";
}
function Sh(e, { id: t, defaultColor: n, defaultMarkerStart: r, defaultMarkerEnd: o }) {
  const i = /* @__PURE__ */ new Set();
  return e.reduce((s, a) => ([a.markerStart || r, a.markerEnd || o].forEach((c) => {
    if (c && typeof c == "object") {
      const l = kr(c, t);
      i.has(l) || (s.push({ id: l, color: c.color || n, ...c }), i.add(l));
    }
  }), s), []).sort((s, a) => s.id.localeCompare(a.id));
}
const Fs = 1e3, Nh = 10, Kr = {
  nodeOrigin: [0, 0],
  nodeExtent: $t,
  elevateNodesOnSelect: !0,
  zIndexMode: "basic",
  defaults: {}
}, Ch = {
  ...Kr,
  checkEquality: !0
};
function Ur(e, t) {
  const n = { ...e };
  for (const r in t)
    t[r] !== void 0 && (n[r] = t[r]);
  return n;
}
function kh(e, t, n) {
  const r = Ur(Kr, n);
  for (const o of e.values())
    if (o.parentId)
      Qr(o, e, t, r);
    else {
      const i = Wt(o, r.nodeOrigin), s = gt(o.extent) ? o.extent : r.nodeExtent, a = Ze(i, s, De(o));
      o.internals.positionAbsolute = a;
    }
}
function Mh(e, t) {
  if (!e.handles)
    return e.measured ? t == null ? void 0 : t.internals.handleBounds : void 0;
  const n = [], r = [];
  for (const o of e.handles) {
    const i = {
      id: o.id,
      width: o.width ?? 1,
      height: o.height ?? 1,
      nodeId: e.id,
      x: o.x,
      y: o.y,
      position: o.position,
      type: o.type
    };
    o.type === "source" ? n.push(i) : o.type === "target" && r.push(i);
  }
  return {
    source: n,
    target: r
  };
}
function Zr(e) {
  return e === "manual";
}
function Mr(e, t, n, r = {}) {
  var u, d;
  const o = Ur(Ch, r), i = { i: 0 }, s = new Map(t), a = o != null && o.elevateNodesOnSelect && !Zr(o.zIndexMode) ? Fs : 0;
  let c = e.length > 0, l = !1;
  t.clear(), n.clear();
  for (const f of e) {
    let h = s.get(f.id);
    if (o.checkEquality && f === (h == null ? void 0 : h.internals.userNode))
      t.set(f.id, h);
    else {
      const g = Wt(f, o.nodeOrigin), y = gt(f.extent) ? f.extent : o.nodeExtent, w = Ze(g, y, De(f));
      h = {
        ...o.defaults,
        ...f,
        measured: {
          width: (u = f.measured) == null ? void 0 : u.width,
          height: (d = f.measured) == null ? void 0 : d.height
        },
        internals: {
          positionAbsolute: w,
          // if user re-initializes the node or removes `measured` for whatever reason, we reset the handleBounds so that the node gets re-measured
          handleBounds: Mh(f, h),
          z: Ys(f, a, o.zIndexMode),
          userNode: f
        }
      }, t.set(f.id, h);
    }
    (h.measured === void 0 || h.measured.width === void 0 || h.measured.height === void 0) && !h.hidden && (c = !1), f.parentId && Qr(h, t, n, r, i), l || (l = f.selected ?? !1);
  }
  return { nodesInitialized: c, hasSelectedNodes: l };
}
function Ih(e, t) {
  if (!e.parentId)
    return;
  const n = t.get(e.parentId);
  n ? n.set(e.id, e) : t.set(e.parentId, /* @__PURE__ */ new Map([[e.id, e]]));
}
function Qr(e, t, n, r, o) {
  const { elevateNodesOnSelect: i, nodeOrigin: s, nodeExtent: a, zIndexMode: c } = Ur(Kr, r), l = e.parentId, u = t.get(l);
  if (!u) {
    console.warn(`Parent node ${l} not found. Please make sure that parent nodes are in front of their child nodes in the nodes array.`);
    return;
  }
  Ih(e, n), o && !u.parentId && u.internals.rootParentIndex === void 0 && c === "auto" && (u.internals.rootParentIndex = ++o.i, u.internals.z = u.internals.z + o.i * Nh), o && u.internals.rootParentIndex !== void 0 && (o.i = u.internals.rootParentIndex);
  const d = i && !Zr(c) ? Fs : 0, { x: f, y: h, z: g } = Ph(e, u, s, a, d, c), { positionAbsolute: y } = e.internals, w = f !== y.x || h !== y.y;
  (w || g !== e.internals.z) && t.set(e.id, {
    ...e,
    internals: {
      ...e.internals,
      positionAbsolute: w ? { x: f, y: h } : y,
      z: g
    }
  });
}
function Ys(e, t, n) {
  const r = Ne(e.zIndex) ? e.zIndex : 0;
  return Zr(n) ? r : r + (e.selected ? t : 0);
}
function Ph(e, t, n, r, o, i) {
  const { x: s, y: a } = t.internals.positionAbsolute, c = De(e), l = Wt(e, n), u = gt(e.extent) ? Ze(l, e.extent, c) : l;
  let d = Ze({ x: s + u.x, y: a + u.y }, r, c);
  e.extent === "parent" && (d = Ps(d, c, t));
  const f = Ys(e, o, i), h = t.internals.z ?? 0;
  return {
    x: d.x,
    y: d.y,
    z: h >= f ? h + 1 : f
  };
}
function Jr(e, t, n, r = [0, 0]) {
  var s;
  const o = [], i = /* @__PURE__ */ new Map();
  for (const a of e) {
    const c = t.get(a.parentId);
    if (!c)
      continue;
    const l = ((s = i.get(a.parentId)) == null ? void 0 : s.expandedRect) ?? ht(c), u = Ts(l, a.rect);
    i.set(a.parentId, { expandedRect: u, parent: c });
  }
  return i.size > 0 && i.forEach(({ expandedRect: a, parent: c }, l) => {
    var p;
    const u = c.internals.positionAbsolute, d = De(c), f = c.origin ?? r, h = a.x < u.x ? Math.round(Math.abs(u.x - a.x)) : 0, g = a.y < u.y ? Math.round(Math.abs(u.y - a.y)) : 0, y = Math.max(d.width, Math.round(a.width)), w = Math.max(d.height, Math.round(a.height)), m = (y - d.width) * f[0], x = (w - d.height) * f[1];
    (h > 0 || g > 0 || m || x) && (o.push({
      id: l,
      type: "position",
      position: {
        x: c.position.x - h + m,
        y: c.position.y - g + x
      }
    }), (p = n.get(l)) == null || p.forEach((b) => {
      e.some((_) => _.id === b.id) || o.push({
        id: b.id,
        type: "position",
        position: {
          x: b.position.x + h,
          y: b.position.y + g
        }
      });
    })), (d.width < a.width || d.height < a.height || h || g) && o.push({
      id: l,
      type: "dimensions",
      setAttributes: !0,
      dimensions: {
        width: y + (h ? f[0] * h - m : 0),
        height: w + (g ? f[1] * g - x : 0)
      }
    });
  }), o;
}
function Ah(e, t, n, r, o, i, s) {
  const a = r == null ? void 0 : r.querySelector(".xyflow__viewport");
  let c = !1;
  if (!a)
    return { changes: [], updatedInternals: c };
  const l = [], u = window.getComputedStyle(a), { m22: d } = new window.DOMMatrixReadOnly(u.transform), f = [];
  for (const h of e.values()) {
    const g = t.get(h.id);
    if (!g)
      continue;
    if (g.hidden) {
      t.set(g.id, {
        ...g,
        internals: {
          ...g.internals,
          handleBounds: void 0
        }
      }), c = !0;
      continue;
    }
    const y = jr(h.nodeElement), w = g.measured.width !== y.width || g.measured.height !== y.height;
    if (!!(y.width && y.height && (w || !g.internals.handleBounds || h.force))) {
      const x = h.nodeElement.getBoundingClientRect(), p = gt(g.extent) ? g.extent : i;
      let { positionAbsolute: b } = g.internals;
      g.parentId && g.extent === "parent" ? b = Ps(b, y, t.get(g.parentId)) : p && (b = Ze(b, p, y));
      const _ = {
        ...g,
        measured: y,
        internals: {
          ...g.internals,
          positionAbsolute: b,
          handleBounds: {
            source: zo("source", h.nodeElement, x, d, g.id),
            target: zo("target", h.nodeElement, x, d, g.id)
          }
        }
      };
      t.set(g.id, _), g.parentId && Qr(_, t, n, { nodeOrigin: o, zIndexMode: s }), c = !0, w && (l.push({
        id: g.id,
        type: "dimensions",
        dimensions: y
      }), g.expandParent && g.parentId && f.push({
        id: g.id,
        parentId: g.parentId,
        rect: ht(_, o)
      }));
    }
  }
  if (f.length > 0) {
    const h = Jr(f, t, n, o);
    l.push(...h);
  }
  return { changes: l, updatedInternals: c };
}
async function Th({ delta: e, panZoom: t, transform: n, translateExtent: r, width: o, height: i }) {
  if (!t || !e.x && !e.y)
    return Promise.resolve(!1);
  const s = await t.setViewportConstrained({
    x: n[0] + e.x,
    y: n[1] + e.y,
    zoom: n[2]
  }, [
    [0, 0],
    [o, i]
  ], r), a = !!s && (s.x !== n[0] || s.y !== n[1] || s.k !== n[2]);
  return Promise.resolve(a);
}
function Wo(e, t, n, r, o, i) {
  let s = o;
  const a = r.get(s) || /* @__PURE__ */ new Map();
  r.set(s, a.set(n, t)), s = `${o}-${e}`;
  const c = r.get(s) || /* @__PURE__ */ new Map();
  if (r.set(s, c.set(n, t)), i) {
    s = `${o}-${e}-${i}`;
    const l = r.get(s) || /* @__PURE__ */ new Map();
    r.set(s, l.set(n, t));
  }
}
function Xs(e, t, n) {
  e.clear(), t.clear();
  for (const r of n) {
    const { source: o, target: i, sourceHandle: s = null, targetHandle: a = null } = r, c = { edgeId: r.id, source: o, target: i, sourceHandle: s, targetHandle: a }, l = `${o}-${s}--${i}-${a}`, u = `${i}-${a}--${o}-${s}`;
    Wo("source", c, u, e, o, s), Wo("target", c, l, e, i, a), t.set(r.id, r);
  }
}
function Ws(e, t) {
  if (!e.parentId)
    return !1;
  const n = t.get(e.parentId);
  return n ? n.selected ? !0 : Ws(n, t) : !1;
}
function Go(e, t, n) {
  var o;
  let r = e;
  do {
    if ((o = r == null ? void 0 : r.matches) != null && o.call(r, t))
      return !0;
    if (r === n)
      return !1;
    r = r == null ? void 0 : r.parentElement;
  } while (r);
  return !1;
}
function Oh(e, t, n, r) {
  const o = /* @__PURE__ */ new Map();
  for (const [i, s] of e)
    if ((s.selected || s.id === r) && (!s.parentId || !Ws(s, e)) && (s.draggable || t && typeof s.draggable > "u")) {
      const a = e.get(i);
      a && o.set(i, {
        id: i,
        position: a.position || { x: 0, y: 0 },
        distance: {
          x: n.x - a.internals.positionAbsolute.x,
          y: n.y - a.internals.positionAbsolute.y
        },
        extent: a.extent,
        parentId: a.parentId,
        origin: a.origin,
        expandParent: a.expandParent,
        internals: {
          positionAbsolute: a.internals.positionAbsolute || { x: 0, y: 0 }
        },
        measured: {
          width: a.measured.width ?? 0,
          height: a.measured.height ?? 0
        }
      });
    }
  return o;
}
function nr({ nodeId: e, dragItems: t, nodeLookup: n, dragging: r = !0 }) {
  var s, a, c;
  const o = [];
  for (const [l, u] of t) {
    const d = (s = n.get(l)) == null ? void 0 : s.internals.userNode;
    d && o.push({
      ...d,
      position: u.position,
      dragging: r
    });
  }
  if (!e)
    return [o[0], o];
  const i = (a = n.get(e)) == null ? void 0 : a.internals.userNode;
  return [
    i ? {
      ...i,
      position: ((c = t.get(e)) == null ? void 0 : c.position) || i.position,
      dragging: r
    } : o[0],
    o
  ];
}
function Lh({ dragItems: e, snapGrid: t, x: n, y: r }) {
  const o = e.values().next().value;
  if (!o)
    return null;
  const i = {
    x: n - o.distance.x,
    y: r - o.distance.y
  }, s = jt(i, t);
  return {
    x: s.x - i.x,
    y: s.y - i.y
  };
}
function $h({ onNodeMouseDown: e, getStoreItems: t, onDragStart: n, onDrag: r, onDragStop: o }) {
  let i = { x: null, y: null }, s = 0, a = /* @__PURE__ */ new Map(), c = !1, l = { x: 0, y: 0 }, u = null, d = !1, f = null, h = !1, g = !1, y = null;
  function w({ noDragClassName: x, handleSelector: p, domNode: b, isSelectable: _, nodeId: E, nodeClickDistance: C = 0 }) {
    f = pe(b);
    function A({ x: L, y: V }) {
      const { nodeLookup: v, nodeExtent: T, snapGrid: S, snapToGrid: O, nodeOrigin: I, onNodeDrag: N, onSelectionDrag: $, onError: R, updateNodePositions: D } = t();
      i = { x: L, y: V };
      let F = !1;
      const Y = a.size > 1, X = Y && T ? Cr(Gt(a)) : null, q = Y && O ? Lh({
        dragItems: a,
        snapGrid: S,
        x: L,
        y: V
      }) : null;
      for (const [G, H] of a) {
        if (!v.has(G))
          continue;
        let W = { x: L - H.distance.x, y: V - H.distance.y };
        O && (W = q ? {
          x: Math.round(W.x + q.x),
          y: Math.round(W.y + q.y)
        } : jt(W, S));
        let Z = null;
        if (Y && T && !H.extent && X) {
          const { positionAbsolute: j } = H.internals, te = j.x - X.x + T[0][0], oe = j.x + H.measured.width - X.x2 + T[1][0], ee = j.y - X.y + T[0][1], ue = j.y + H.measured.height - X.y2 + T[1][1];
          Z = [
            [te, ee],
            [oe, ue]
          ];
        }
        const { position: U, positionAbsolute: K } = Is({
          nodeId: G,
          nextPosition: W,
          nodeLookup: v,
          nodeExtent: Z || T,
          nodeOrigin: I,
          onError: R
        });
        F = F || H.position.x !== U.x || H.position.y !== U.y, H.position = U, H.internals.positionAbsolute = K;
      }
      if (g = g || F, !!F && (D(a, !0), y && (r || N || !E && $))) {
        const [G, H] = nr({
          nodeId: E,
          dragItems: a,
          nodeLookup: v
        });
        r == null || r(y, a, G, H), N == null || N(y, G, H), E || $ == null || $(y, H);
      }
    }
    async function M() {
      if (!u)
        return;
      const { transform: L, panBy: V, autoPanSpeed: v, autoPanOnNodeDrag: T } = t();
      if (!T) {
        c = !1, cancelAnimationFrame(s);
        return;
      }
      const [S, O] = As(l, u, v);
      (S !== 0 || O !== 0) && (i.x = (i.x ?? 0) - S / L[2], i.y = (i.y ?? 0) - O / L[2], await V({ x: S, y: O }) && A(i)), s = requestAnimationFrame(M);
    }
    function z(L) {
      var Y;
      const { nodeLookup: V, multiSelectionActive: v, nodesDraggable: T, transform: S, snapGrid: O, snapToGrid: I, selectNodesOnDrag: N, onNodeDragStart: $, onSelectionDragStart: R, unselectNodesAndEdges: D } = t();
      d = !0, (!N || !_) && !v && E && ((Y = V.get(E)) != null && Y.selected || D()), _ && N && E && (e == null || e(E));
      const F = Pt(L.sourceEvent, { transform: S, snapGrid: O, snapToGrid: I, containerBounds: u });
      if (i = F, a = Oh(V, T, F, E), a.size > 0 && (n || $ || !E && R)) {
        const [X, q] = nr({
          nodeId: E,
          dragItems: a,
          nodeLookup: V
        });
        n == null || n(L.sourceEvent, a, X, q), $ == null || $(L.sourceEvent, X, q), E || R == null || R(L.sourceEvent, q);
      }
    }
    const P = cs().clickDistance(C).on("start", (L) => {
      const { domNode: V, nodeDragThreshold: v, transform: T, snapGrid: S, snapToGrid: O } = t();
      u = (V == null ? void 0 : V.getBoundingClientRect()) || null, h = !1, g = !1, y = L.sourceEvent, v === 0 && z(L), i = Pt(L.sourceEvent, { transform: T, snapGrid: S, snapToGrid: O, containerBounds: u }), l = Ce(L.sourceEvent, u);
    }).on("drag", (L) => {
      const { autoPanOnNodeDrag: V, transform: v, snapGrid: T, snapToGrid: S, nodeDragThreshold: O, nodeLookup: I } = t(), N = Pt(L.sourceEvent, { transform: v, snapGrid: T, snapToGrid: S, containerBounds: u });
      if (y = L.sourceEvent, (L.sourceEvent.type === "touchmove" && L.sourceEvent.touches.length > 1 || // if user deletes a node while dragging, we need to abort the drag to prevent errors
      E && !I.has(E)) && (h = !0), !h) {
        if (!c && V && d && (c = !0, M()), !d) {
          const $ = Ce(L.sourceEvent, u), R = $.x - l.x, D = $.y - l.y;
          Math.sqrt(R * R + D * D) > O && z(L);
        }
        (i.x !== N.xSnapped || i.y !== N.ySnapped) && a && d && (l = Ce(L.sourceEvent, u), A(N));
      }
    }).on("end", (L) => {
      if (!(!d || h) && (c = !1, d = !1, cancelAnimationFrame(s), a.size > 0)) {
        const { nodeLookup: V, updateNodePositions: v, onNodeDragStop: T, onSelectionDragStop: S } = t();
        if (g && (v(a, !1), g = !1), o || T || !E && S) {
          const [O, I] = nr({
            nodeId: E,
            dragItems: a,
            nodeLookup: V,
            dragging: !1
          });
          o == null || o(L.sourceEvent, a, O, I), T == null || T(L.sourceEvent, O, I), E || S == null || S(L.sourceEvent, I);
        }
      }
    }).filter((L) => {
      const V = L.target;
      return !L.button && (!x || !Go(V, `.${x}`, b)) && (!p || Go(V, p, b));
    });
    f.call(P);
  }
  function m() {
    f == null || f.on(".drag", null);
  }
  return {
    update: w,
    destroy: m
  };
}
function Dh(e, t, n) {
  const r = [], o = {
    x: e.x - n,
    y: e.y - n,
    width: n * 2,
    height: n * 2
  };
  for (const i of t.values())
    Rt(o, ht(i)) > 0 && r.push(i);
  return r;
}
const Rh = 250;
function zh(e, t, n, r) {
  var a, c;
  let o = [], i = 1 / 0;
  const s = Dh(e, n, t + Rh);
  for (const l of s) {
    const u = [...((a = l.internals.handleBounds) == null ? void 0 : a.source) ?? [], ...((c = l.internals.handleBounds) == null ? void 0 : c.target) ?? []];
    for (const d of u) {
      if (r.nodeId === d.nodeId && r.type === d.type && r.id === d.id)
        continue;
      const { x: f, y: h } = Qe(l, d, d.position, !0), g = Math.sqrt(Math.pow(f - e.x, 2) + Math.pow(h - e.y, 2));
      g > t || (g < i ? (o = [{ ...d, x: f, y: h }], i = g) : g === i && o.push({ ...d, x: f, y: h }));
    }
  }
  if (!o.length)
    return null;
  if (o.length > 1) {
    const l = r.type === "source" ? "target" : "source";
    return o.find((u) => u.type === l) ?? o[0];
  }
  return o[0];
}
function Gs(e, t, n, r, o, i = !1) {
  var l, u, d;
  const s = r.get(e);
  if (!s)
    return null;
  const a = o === "strict" ? (l = s.internals.handleBounds) == null ? void 0 : l[t] : [...((u = s.internals.handleBounds) == null ? void 0 : u.source) ?? [], ...((d = s.internals.handleBounds) == null ? void 0 : d.target) ?? []], c = (n ? a == null ? void 0 : a.find((f) => f.id === n) : a == null ? void 0 : a[0]) ?? null;
  return c && i ? { ...c, ...Qe(s, c, c.position, !0) } : c;
}
function js(e, t) {
  return e || (t != null && t.classList.contains("target") ? "target" : t != null && t.classList.contains("source") ? "source" : null);
}
function Vh(e, t) {
  let n = null;
  return t ? n = !0 : e && !t && (n = !1), n;
}
const qs = () => !0;
function Hh(e, { connectionMode: t, connectionRadius: n, handleId: r, nodeId: o, edgeUpdaterType: i, isTarget: s, domNode: a, nodeLookup: c, lib: l, autoPanOnConnect: u, flowId: d, panBy: f, cancelConnection: h, onConnectStart: g, onConnect: y, onConnectEnd: w, isValidConnection: m = qs, onReconnectEnd: x, updateConnection: p, getTransform: b, getFromHandle: _, autoPanSpeed: E, dragThreshold: C = 1, handleDomNode: A }) {
  const M = Ds(e.target);
  let z = 0, P;
  const { x: L, y: V } = Ce(e), v = js(i, A), T = a == null ? void 0 : a.getBoundingClientRect();
  let S = !1;
  if (!T || !v)
    return;
  const O = Gs(o, v, r, c, t);
  if (!O)
    return;
  let I = Ce(e, T), N = !1, $ = null, R = !1, D = null;
  function F() {
    if (!u || !T)
      return;
    const [U, K] = As(I, T, E);
    f({ x: U, y: K }), z = requestAnimationFrame(F);
  }
  const Y = {
    ...O,
    nodeId: o,
    type: v,
    position: O.position
  }, X = c.get(o);
  let G = {
    inProgress: !0,
    isValid: null,
    from: Qe(X, Y, B.Left, !0),
    fromHandle: Y,
    fromPosition: Y.position,
    fromNode: X,
    to: I,
    toHandle: null,
    toPosition: Lo[Y.position],
    toNode: null,
    pointer: I
  };
  function H() {
    S = !0, p(G), g == null || g(e, { nodeId: o, handleId: r, handleType: v });
  }
  C === 0 && H();
  function W(U) {
    if (!S) {
      const { x: ue, y: Re } = Ce(U), Te = ue - L, Xe = Re - V;
      if (!(Te * Te + Xe * Xe > C * C))
        return;
      H();
    }
    if (!_() || !Y) {
      Z(U);
      return;
    }
    const K = b();
    I = Ce(U, T), P = zh(qt(I, K, !1, [1, 1]), n, c, Y), N || (F(), N = !0);
    const j = Ks(U, {
      handle: P,
      connectionMode: t,
      fromNodeId: o,
      fromHandleId: r,
      fromType: s ? "target" : "source",
      isValidConnection: m,
      doc: M,
      lib: l,
      flowId: d,
      nodeLookup: c
    });
    D = j.handleDomNode, $ = j.connection, R = Vh(!!P, j.isValid);
    const te = c.get(o), oe = te ? Qe(te, Y, B.Left, !0) : G.from, ee = {
      ...G,
      from: oe,
      isValid: R,
      to: j.toHandle && R ? Sn({ x: j.toHandle.x, y: j.toHandle.y }, K) : I,
      toHandle: j.toHandle,
      toPosition: R && j.toHandle ? j.toHandle.position : Lo[Y.position],
      toNode: j.toHandle ? c.get(j.toHandle.nodeId) : null,
      pointer: I
    };
    p(ee), G = ee;
  }
  function Z(U) {
    if (!("touches" in U && U.touches.length > 0)) {
      if (S) {
        (P || D) && $ && R && (y == null || y($));
        const { inProgress: K, ...j } = G, te = {
          ...j,
          toPosition: G.toHandle ? G.toPosition : null
        };
        w == null || w(U, te), i && (x == null || x(U, te));
      }
      h(), cancelAnimationFrame(z), N = !1, R = !1, $ = null, D = null, M.removeEventListener("mousemove", W), M.removeEventListener("mouseup", Z), M.removeEventListener("touchmove", W), M.removeEventListener("touchend", Z);
    }
  }
  M.addEventListener("mousemove", W), M.addEventListener("mouseup", Z), M.addEventListener("touchmove", W), M.addEventListener("touchend", Z);
}
function Ks(e, { handle: t, connectionMode: n, fromNodeId: r, fromHandleId: o, fromType: i, doc: s, lib: a, flowId: c, isValidConnection: l = qs, nodeLookup: u }) {
  const d = i === "target", f = t ? s.querySelector(`.${a}-flow__handle[data-id="${c}-${t == null ? void 0 : t.nodeId}-${t == null ? void 0 : t.id}-${t == null ? void 0 : t.type}"]`) : null, { x: h, y: g } = Ce(e), y = s.elementFromPoint(h, g), w = y != null && y.classList.contains(`${a}-flow__handle`) ? y : f, m = {
    handleDomNode: w,
    isValid: !1,
    connection: null,
    toHandle: null
  };
  if (w) {
    const x = js(void 0, w), p = w.getAttribute("data-nodeid"), b = w.getAttribute("data-handleid"), _ = w.classList.contains("connectable"), E = w.classList.contains("connectableend");
    if (!p || !x)
      return m;
    const C = {
      source: d ? p : r,
      sourceHandle: d ? b : o,
      target: d ? r : p,
      targetHandle: d ? o : b
    };
    m.connection = C;
    const M = _ && E && (n === dt.Strict ? d && x === "source" || !d && x === "target" : p !== r || b !== o);
    m.isValid = M && l(C), m.toHandle = Gs(p, x, b, u, n, !0);
  }
  return m;
}
const Ir = {
  onPointerDown: Hh,
  isValid: Ks
};
function Bh({ domNode: e, panZoom: t, getTransform: n, getViewScale: r }) {
  const o = pe(e);
  function i({ translateExtent: a, width: c, height: l, zoomStep: u = 1, pannable: d = !0, zoomable: f = !0, inversePan: h = !1 }) {
    const g = (p) => {
      if (p.sourceEvent.type !== "wheel" || !t)
        return;
      const b = n(), _ = p.sourceEvent.ctrlKey && zt() ? 10 : 1, E = -p.sourceEvent.deltaY * (p.sourceEvent.deltaMode === 1 ? 0.05 : p.sourceEvent.deltaMode ? 1 : 2e-3) * u, C = b[2] * Math.pow(2, E * _);
      t.scaleTo(C);
    };
    let y = [0, 0];
    const w = (p) => {
      (p.sourceEvent.type === "mousedown" || p.sourceEvent.type === "touchstart") && (y = [
        p.sourceEvent.clientX ?? p.sourceEvent.touches[0].clientX,
        p.sourceEvent.clientY ?? p.sourceEvent.touches[0].clientY
      ]);
    }, m = (p) => {
      const b = n();
      if (p.sourceEvent.type !== "mousemove" && p.sourceEvent.type !== "touchmove" || !t)
        return;
      const _ = [
        p.sourceEvent.clientX ?? p.sourceEvent.touches[0].clientX,
        p.sourceEvent.clientY ?? p.sourceEvent.touches[0].clientY
      ], E = [_[0] - y[0], _[1] - y[1]];
      y = _;
      const C = r() * Math.max(b[2], Math.log(b[2])) * (h ? -1 : 1), A = {
        x: b[0] - E[0] * C,
        y: b[1] - E[1] * C
      }, M = [
        [0, 0],
        [c, l]
      ];
      t.setViewportConstrained({
        x: A.x,
        y: A.y,
        zoom: b[2]
      }, M, a);
    }, x = _s().on("start", w).on("zoom", d ? m : null).on("zoom.wheel", f ? g : null);
    o.call(x, {});
  }
  function s() {
    o.on("zoom", null);
  }
  return {
    update: i,
    destroy: s,
    pointer: _e
  };
}
const Hn = (e) => ({
  x: e.x,
  y: e.y,
  zoom: e.k
}), rr = ({ x: e, y: t, zoom: n }) => Rn.translate(e, t).scale(n), it = (e, t) => e.target.closest(`.${t}`), Us = (e, t) => t === 2 && Array.isArray(e) && e.includes(2), Fh = (e) => ((e *= 2) <= 1 ? e * e * e : (e -= 2) * e * e + 2) / 2, or = (e, t = 0, n = Fh, r = () => {
}) => {
  const o = typeof t == "number" && t > 0;
  return o || r(), o ? e.transition().duration(t).ease(n).on("end", r) : e;
}, Zs = (e) => {
  const t = e.ctrlKey && zt() ? 10 : 1;
  return -e.deltaY * (e.deltaMode === 1 ? 0.05 : e.deltaMode ? 1 : 2e-3) * t;
};
function Yh({ zoomPanValues: e, noWheelClassName: t, d3Selection: n, d3Zoom: r, panOnScrollMode: o, panOnScrollSpeed: i, zoomOnPinch: s, onPanZoomStart: a, onPanZoom: c, onPanZoomEnd: l }) {
  return (u) => {
    if (it(u, t))
      return u.ctrlKey && u.preventDefault(), !1;
    u.preventDefault(), u.stopImmediatePropagation();
    const d = n.property("__zoom").k || 1;
    if (u.ctrlKey && s) {
      const w = _e(u), m = Zs(u), x = d * Math.pow(2, m);
      r.scaleTo(n, x, w, u);
      return;
    }
    const f = u.deltaMode === 1 ? 20 : 1;
    let h = o === qe.Vertical ? 0 : u.deltaX * f, g = o === qe.Horizontal ? 0 : u.deltaY * f;
    !zt() && u.shiftKey && o !== qe.Vertical && (h = u.deltaY * f, g = 0), r.translateBy(
      n,
      -(h / d) * i,
      -(g / d) * i,
      // @ts-ignore
      { internal: !0 }
    );
    const y = Hn(n.property("__zoom"));
    clearTimeout(e.panScrollTimeout), e.isPanScrolling ? (c == null || c(u, y), e.panScrollTimeout = setTimeout(() => {
      l == null || l(u, y), e.isPanScrolling = !1;
    }, 150)) : (e.isPanScrolling = !0, a == null || a(u, y));
  };
}
function Xh({ noWheelClassName: e, preventScrolling: t, d3ZoomHandler: n }) {
  return function(r, o) {
    const i = r.type === "wheel", s = !t && i && !r.ctrlKey, a = it(r, e);
    if (r.ctrlKey && i && a && r.preventDefault(), s || a)
      return null;
    r.preventDefault(), n.call(this, r, o);
  };
}
function Wh({ zoomPanValues: e, onDraggingChange: t, onPanZoomStart: n }) {
  return (r) => {
    var i, s, a;
    if ((i = r.sourceEvent) != null && i.internal)
      return;
    const o = Hn(r.transform);
    e.mouseButton = ((s = r.sourceEvent) == null ? void 0 : s.button) || 0, e.isZoomingOrPanning = !0, e.prevViewport = o, ((a = r.sourceEvent) == null ? void 0 : a.type) === "mousedown" && t(!0), n && (n == null || n(r.sourceEvent, o));
  };
}
function Gh({ zoomPanValues: e, panOnDrag: t, onPaneContextMenu: n, onTransformChange: r, onPanZoom: o }) {
  return (i) => {
    var s, a;
    e.usedRightMouseButton = !!(n && Us(t, e.mouseButton ?? 0)), (s = i.sourceEvent) != null && s.sync || r([i.transform.x, i.transform.y, i.transform.k]), o && !((a = i.sourceEvent) != null && a.internal) && (o == null || o(i.sourceEvent, Hn(i.transform)));
  };
}
function jh({ zoomPanValues: e, panOnDrag: t, panOnScroll: n, onDraggingChange: r, onPanZoomEnd: o, onPaneContextMenu: i }) {
  return (s) => {
    var a;
    if (!((a = s.sourceEvent) != null && a.internal) && (e.isZoomingOrPanning = !1, i && Us(t, e.mouseButton ?? 0) && !e.usedRightMouseButton && s.sourceEvent && i(s.sourceEvent), e.usedRightMouseButton = !1, r(!1), o)) {
      const c = Hn(s.transform);
      e.prevViewport = c, clearTimeout(e.timerId), e.timerId = setTimeout(
        () => {
          o == null || o(s.sourceEvent, c);
        },
        // we need a setTimeout for panOnScroll to suppress multiple end events fired during scroll
        n ? 150 : 0
      );
    }
  };
}
function qh({ zoomActivationKeyPressed: e, zoomOnScroll: t, zoomOnPinch: n, panOnDrag: r, panOnScroll: o, zoomOnDoubleClick: i, userSelectionActive: s, noWheelClassName: a, noPanClassName: c, lib: l, connectionInProgress: u }) {
  return (d) => {
    var w;
    const f = e || t, h = n && d.ctrlKey, g = d.type === "wheel";
    if (d.button === 1 && d.type === "mousedown" && (it(d, `${l}-flow__node`) || it(d, `${l}-flow__edge`)))
      return !0;
    if (!r && !f && !o && !i && !n || s || u && !g || it(d, a) && g || it(d, c) && (!g || o && g && !e) || !n && d.ctrlKey && g)
      return !1;
    if (!n && d.type === "touchstart" && ((w = d.touches) == null ? void 0 : w.length) > 1)
      return d.preventDefault(), !1;
    if (!f && !o && !h && g || !r && (d.type === "mousedown" || d.type === "touchstart") || Array.isArray(r) && !r.includes(d.button) && d.type === "mousedown")
      return !1;
    const y = Array.isArray(r) && r.includes(d.button) || !d.button || d.button <= 1;
    return (!d.ctrlKey || g) && y;
  };
}
function Kh({ domNode: e, minZoom: t, maxZoom: n, translateExtent: r, viewport: o, onPanZoom: i, onPanZoomStart: s, onPanZoomEnd: a, onDraggingChange: c }) {
  const l = {
    isZoomingOrPanning: !1,
    usedRightMouseButton: !1,
    prevViewport: {},
    mouseButton: 0,
    timerId: void 0,
    panScrollTimeout: void 0,
    isPanScrolling: !1
  }, u = e.getBoundingClientRect(), d = _s().scaleExtent([t, n]).translateExtent(r), f = pe(e).call(d);
  x({
    x: o.x,
    y: o.y,
    zoom: ft(o.zoom, t, n)
  }, [
    [0, 0],
    [u.width, u.height]
  ], r);
  const h = f.on("wheel.zoom"), g = f.on("dblclick.zoom");
  d.wheelDelta(Zs);
  function y(P, L) {
    return f ? new Promise((V) => {
      d == null || d.interpolate((L == null ? void 0 : L.interpolate) === "linear" ? It : dn).transform(or(f, L == null ? void 0 : L.duration, L == null ? void 0 : L.ease, () => V(!0)), P);
    }) : Promise.resolve(!1);
  }
  function w({ noWheelClassName: P, noPanClassName: L, onPaneContextMenu: V, userSelectionActive: v, panOnScroll: T, panOnDrag: S, panOnScrollMode: O, panOnScrollSpeed: I, preventScrolling: N, zoomOnPinch: $, zoomOnScroll: R, zoomOnDoubleClick: D, zoomActivationKeyPressed: F, lib: Y, onTransformChange: X, connectionInProgress: q, paneClickDistance: G, selectionOnDrag: H }) {
    v && !l.isZoomingOrPanning && m();
    const W = T && !F && !v;
    d.clickDistance(H ? 1 / 0 : !Ne(G) || G < 0 ? 0 : G);
    const Z = W ? Yh({
      zoomPanValues: l,
      noWheelClassName: P,
      d3Selection: f,
      d3Zoom: d,
      panOnScrollMode: O,
      panOnScrollSpeed: I,
      zoomOnPinch: $,
      onPanZoomStart: s,
      onPanZoom: i,
      onPanZoomEnd: a
    }) : Xh({
      noWheelClassName: P,
      preventScrolling: N,
      d3ZoomHandler: h
    });
    if (f.on("wheel.zoom", Z, { passive: !1 }), !v) {
      const K = Wh({
        zoomPanValues: l,
        onDraggingChange: c,
        onPanZoomStart: s
      });
      d.on("start", K);
      const j = Gh({
        zoomPanValues: l,
        panOnDrag: S,
        onPaneContextMenu: !!V,
        onPanZoom: i,
        onTransformChange: X
      });
      d.on("zoom", j);
      const te = jh({
        zoomPanValues: l,
        panOnDrag: S,
        panOnScroll: T,
        onPaneContextMenu: V,
        onPanZoomEnd: a,
        onDraggingChange: c
      });
      d.on("end", te);
    }
    const U = qh({
      zoomActivationKeyPressed: F,
      panOnDrag: S,
      zoomOnScroll: R,
      panOnScroll: T,
      zoomOnDoubleClick: D,
      zoomOnPinch: $,
      userSelectionActive: v,
      noPanClassName: L,
      noWheelClassName: P,
      lib: Y,
      connectionInProgress: q
    });
    d.filter(U), D ? f.on("dblclick.zoom", g) : f.on("dblclick.zoom", null);
  }
  function m() {
    d.on("zoom", null);
  }
  async function x(P, L, V) {
    const v = rr(P), T = d == null ? void 0 : d.constrain()(v, L, V);
    return T && await y(T), new Promise((S) => S(T));
  }
  async function p(P, L) {
    const V = rr(P);
    return await y(V, L), new Promise((v) => v(V));
  }
  function b(P) {
    if (f) {
      const L = rr(P), V = f.property("__zoom");
      (V.k !== P.zoom || V.x !== P.x || V.y !== P.y) && (d == null || d.transform(f, L, null, { sync: !0 }));
    }
  }
  function _() {
    const P = f ? Es(f.node()) : { x: 0, y: 0, k: 1 };
    return { x: P.x, y: P.y, zoom: P.k };
  }
  function E(P, L) {
    return f ? new Promise((V) => {
      d == null || d.interpolate((L == null ? void 0 : L.interpolate) === "linear" ? It : dn).scaleTo(or(f, L == null ? void 0 : L.duration, L == null ? void 0 : L.ease, () => V(!0)), P);
    }) : Promise.resolve(!1);
  }
  function C(P, L) {
    return f ? new Promise((V) => {
      d == null || d.interpolate((L == null ? void 0 : L.interpolate) === "linear" ? It : dn).scaleBy(or(f, L == null ? void 0 : L.duration, L == null ? void 0 : L.ease, () => V(!0)), P);
    }) : Promise.resolve(!1);
  }
  function A(P) {
    d == null || d.scaleExtent(P);
  }
  function M(P) {
    d == null || d.translateExtent(P);
  }
  function z(P) {
    const L = !Ne(P) || P < 0 ? 0 : P;
    d == null || d.clickDistance(L);
  }
  return {
    update: w,
    destroy: m,
    setViewport: p,
    setViewportConstrained: x,
    getViewport: _,
    scaleTo: E,
    scaleBy: C,
    setScaleExtent: A,
    setTranslateExtent: M,
    syncViewport: b,
    setClickDistance: z
  };
}
var pt;
(function(e) {
  e.Line = "line", e.Handle = "handle";
})(pt || (pt = {}));
function Uh({ width: e, prevWidth: t, height: n, prevHeight: r, affectsX: o, affectsY: i }) {
  const s = e - t, a = n - r, c = [s > 0 ? 1 : s < 0 ? -1 : 0, a > 0 ? 1 : a < 0 ? -1 : 0];
  return s && o && (c[0] = c[0] * -1), a && i && (c[1] = c[1] * -1), c;
}
function jo(e) {
  const t = e.includes("right") || e.includes("left"), n = e.includes("bottom") || e.includes("top"), r = e.includes("left"), o = e.includes("top");
  return {
    isHorizontal: t,
    isVertical: n,
    affectsX: r,
    affectsY: o
  };
}
function ze(e, t) {
  return Math.max(0, t - e);
}
function Ve(e, t) {
  return Math.max(0, e - t);
}
function on(e, t, n) {
  return Math.max(0, t - e, e - n);
}
function qo(e, t) {
  return e ? !t : t;
}
function Zh(e, t, n, r, o, i, s, a) {
  let { affectsX: c, affectsY: l } = t;
  const { isHorizontal: u, isVertical: d } = t, f = u && d, { xSnapped: h, ySnapped: g } = n, { minWidth: y, maxWidth: w, minHeight: m, maxHeight: x } = r, { x: p, y: b, width: _, height: E, aspectRatio: C } = e;
  let A = Math.floor(u ? h - e.pointerX : 0), M = Math.floor(d ? g - e.pointerY : 0);
  const z = _ + (c ? -A : A), P = E + (l ? -M : M), L = -i[0] * _, V = -i[1] * E;
  let v = on(z, y, w), T = on(P, m, x);
  if (s) {
    let I = 0, N = 0;
    c && A < 0 ? I = ze(p + A + L, s[0][0]) : !c && A > 0 && (I = Ve(p + z + L, s[1][0])), l && M < 0 ? N = ze(b + M + V, s[0][1]) : !l && M > 0 && (N = Ve(b + P + V, s[1][1])), v = Math.max(v, I), T = Math.max(T, N);
  }
  if (a) {
    let I = 0, N = 0;
    c && A > 0 ? I = Ve(p + A, a[0][0]) : !c && A < 0 && (I = ze(p + z, a[1][0])), l && M > 0 ? N = Ve(b + M, a[0][1]) : !l && M < 0 && (N = ze(b + P, a[1][1])), v = Math.max(v, I), T = Math.max(T, N);
  }
  if (o) {
    if (u) {
      const I = on(z / C, m, x) * C;
      if (v = Math.max(v, I), s) {
        let N = 0;
        !c && !l || c && !l && f ? N = Ve(b + V + z / C, s[1][1]) * C : N = ze(b + V + (c ? A : -A) / C, s[0][1]) * C, v = Math.max(v, N);
      }
      if (a) {
        let N = 0;
        !c && !l || c && !l && f ? N = ze(b + z / C, a[1][1]) * C : N = Ve(b + (c ? A : -A) / C, a[0][1]) * C, v = Math.max(v, N);
      }
    }
    if (d) {
      const I = on(P * C, y, w) / C;
      if (T = Math.max(T, I), s) {
        let N = 0;
        !c && !l || l && !c && f ? N = Ve(p + P * C + L, s[1][0]) / C : N = ze(p + (l ? M : -M) * C + L, s[0][0]) / C, T = Math.max(T, N);
      }
      if (a) {
        let N = 0;
        !c && !l || l && !c && f ? N = ze(p + P * C, a[1][0]) / C : N = Ve(p + (l ? M : -M) * C, a[0][0]) / C, T = Math.max(T, N);
      }
    }
  }
  M = M + (M < 0 ? T : -T), A = A + (A < 0 ? v : -v), o && (f ? z > P * C ? M = (qo(c, l) ? -A : A) / C : A = (qo(c, l) ? -M : M) * C : u ? (M = A / C, l = c) : (A = M * C, c = l));
  const S = c ? p + A : p, O = l ? b + M : b;
  return {
    width: _ + (c ? -A : A),
    height: E + (l ? -M : M),
    x: i[0] * A * (c ? -1 : 1) + S,
    y: i[1] * M * (l ? -1 : 1) + O
  };
}
const Qs = { width: 0, height: 0, x: 0, y: 0 }, Qh = {
  ...Qs,
  pointerX: 0,
  pointerY: 0,
  aspectRatio: 1
};
function Jh(e) {
  return [
    [0, 0],
    [e.measured.width, e.measured.height]
  ];
}
function eg(e, t, n) {
  const r = t.position.x + e.position.x, o = t.position.y + e.position.y, i = e.measured.width ?? 0, s = e.measured.height ?? 0, a = n[0] * i, c = n[1] * s;
  return [
    [r - a, o - c],
    [r + i - a, o + s - c]
  ];
}
function tg({ domNode: e, nodeId: t, getStoreItems: n, onChange: r, onEnd: o }) {
  const i = pe(e);
  let s = {
    controlDirection: jo("bottom-right"),
    boundaries: {
      minWidth: 0,
      minHeight: 0,
      maxWidth: Number.MAX_VALUE,
      maxHeight: Number.MAX_VALUE
    },
    resizeDirection: void 0,
    keepAspectRatio: !1
  };
  function a({ controlPosition: l, boundaries: u, keepAspectRatio: d, resizeDirection: f, onResizeStart: h, onResize: g, onResizeEnd: y, shouldResize: w }) {
    let m = { ...Qs }, x = { ...Qh };
    s = {
      boundaries: u,
      resizeDirection: f,
      keepAspectRatio: d,
      controlDirection: jo(l)
    };
    let p, b = null, _ = [], E, C, A, M = !1;
    const z = cs().on("start", (P) => {
      const { nodeLookup: L, transform: V, snapGrid: v, snapToGrid: T, nodeOrigin: S, paneDomNode: O } = n();
      if (p = L.get(t), !p)
        return;
      b = (O == null ? void 0 : O.getBoundingClientRect()) ?? null;
      const { xSnapped: I, ySnapped: N } = Pt(P.sourceEvent, {
        transform: V,
        snapGrid: v,
        snapToGrid: T,
        containerBounds: b
      });
      m = {
        width: p.measured.width ?? 0,
        height: p.measured.height ?? 0,
        x: p.position.x ?? 0,
        y: p.position.y ?? 0
      }, x = {
        ...m,
        pointerX: I,
        pointerY: N,
        aspectRatio: m.width / m.height
      }, E = void 0, p.parentId && (p.extent === "parent" || p.expandParent) && (E = L.get(p.parentId), C = E && p.extent === "parent" ? Jh(E) : void 0), _ = [], A = void 0;
      for (const [$, R] of L)
        if (R.parentId === t && (_.push({
          id: $,
          position: { ...R.position },
          extent: R.extent
        }), R.extent === "parent" || R.expandParent)) {
          const D = eg(R, p, R.origin ?? S);
          A ? A = [
            [Math.min(D[0][0], A[0][0]), Math.min(D[0][1], A[0][1])],
            [Math.max(D[1][0], A[1][0]), Math.max(D[1][1], A[1][1])]
          ] : A = D;
        }
      h == null || h(P, { ...m });
    }).on("drag", (P) => {
      const { transform: L, snapGrid: V, snapToGrid: v, nodeOrigin: T } = n(), S = Pt(P.sourceEvent, {
        transform: L,
        snapGrid: V,
        snapToGrid: v,
        containerBounds: b
      }), O = [];
      if (!p)
        return;
      const { x: I, y: N, width: $, height: R } = m, D = {}, F = p.origin ?? T, { width: Y, height: X, x: q, y: G } = Zh(x, s.controlDirection, S, s.boundaries, s.keepAspectRatio, F, C, A), H = Y !== $, W = X !== R, Z = q !== I && H, U = G !== N && W;
      if (!Z && !U && !H && !W)
        return;
      if ((Z || U || F[0] === 1 || F[1] === 1) && (D.x = Z ? q : m.x, D.y = U ? G : m.y, m.x = D.x, m.y = D.y, _.length > 0)) {
        const oe = q - I, ee = G - N;
        for (const ue of _)
          ue.position = {
            x: ue.position.x - oe + F[0] * (Y - $),
            y: ue.position.y - ee + F[1] * (X - R)
          }, O.push(ue);
      }
      if ((H || W) && (D.width = H && (!s.resizeDirection || s.resizeDirection === "horizontal") ? Y : m.width, D.height = W && (!s.resizeDirection || s.resizeDirection === "vertical") ? X : m.height, m.width = D.width, m.height = D.height), E && p.expandParent) {
        const oe = F[0] * (D.width ?? 0);
        D.x && D.x < oe && (m.x = oe, x.x = x.x - (D.x - oe));
        const ee = F[1] * (D.height ?? 0);
        D.y && D.y < ee && (m.y = ee, x.y = x.y - (D.y - ee));
      }
      const K = Uh({
        width: m.width,
        prevWidth: $,
        height: m.height,
        prevHeight: R,
        affectsX: s.controlDirection.affectsX,
        affectsY: s.controlDirection.affectsY
      }), j = { ...m, direction: K };
      (w == null ? void 0 : w(P, j)) !== !1 && (M = !0, g == null || g(P, j), r(D, O));
    }).on("end", (P) => {
      M && (y == null || y(P, { ...m }), o == null || o({ ...m }), M = !1);
    });
    i.call(z);
  }
  function c() {
    i.on(".drag", null);
  }
  return {
    update: a,
    destroy: c
  };
}
function ng(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Pr = { exports: {} }, ir = {}, sn = { exports: {} }, sr = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ko;
function rg() {
  if (Ko) return sr;
  Ko = 1;
  var e = Bt;
  function t(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, i = e.useLayoutEffect, s = e.useDebugValue;
  function a(d, f) {
    var h = f(), g = r({ inst: { value: h, getSnapshot: f } }), y = g[0].inst, w = g[1];
    return i(
      function() {
        y.value = h, y.getSnapshot = f, c(y) && w({ inst: y });
      },
      [d, h, f]
    ), o(
      function() {
        return c(y) && w({ inst: y }), d(function() {
          c(y) && w({ inst: y });
        });
      },
      [d]
    ), s(h), h;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : a;
  return sr.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, sr;
}
var ar = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uo;
function og() {
  return Uo || (Uo = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, g) {
      return h === g && (h !== 0 || 1 / h === 1 / g) || h !== h && g !== g;
    }
    function t(h, g) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var y = g();
      if (!d) {
        var w = g();
        i(y, w) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      w = s({
        inst: { value: y, getSnapshot: g }
      });
      var m = w[0].inst, x = w[1];
      return c(
        function() {
          m.value = y, m.getSnapshot = g, n(m) && x({ inst: m });
        },
        [h, y, g]
      ), a(
        function() {
          return n(m) && x({ inst: m }), h(function() {
            n(m) && x({ inst: m });
          });
        },
        [h]
      ), l(y), y;
    }
    function n(h) {
      var g = h.getSnapshot;
      h = h.value;
      try {
        var y = g();
        return !i(h, y);
      } catch {
        return !0;
      }
    }
    function r(h, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = Bt, i = typeof Object.is == "function" ? Object.is : e, s = o.useState, a = o.useEffect, c = o.useLayoutEffect, l = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    ar.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ar;
}
var Zo;
function Js() {
  return Zo || (Zo = 1, process.env.NODE_ENV === "production" ? sn.exports = rg() : sn.exports = og()), sn.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qo;
function ig() {
  if (Qo) return ir;
  Qo = 1;
  var e = Bt, t = Js();
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = t.useSyncExternalStore, i = e.useRef, s = e.useEffect, a = e.useMemo, c = e.useDebugValue;
  return ir.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
    var g = i(null);
    if (g.current === null) {
      var y = { hasValue: !1, value: null };
      g.current = y;
    } else y = g.current;
    g = a(
      function() {
        function m(E) {
          if (!x) {
            if (x = !0, p = E, E = f(E), h !== void 0 && y.hasValue) {
              var C = y.value;
              if (h(C, E))
                return b = C;
            }
            return b = E;
          }
          if (C = b, r(p, E)) return C;
          var A = f(E);
          return h !== void 0 && h(C, A) ? (p = E, C) : (p = E, b = A);
        }
        var x = !1, p, b, _ = d === void 0 ? null : d;
        return [
          function() {
            return m(u());
          },
          _ === null ? void 0 : function() {
            return m(_());
          }
        ];
      },
      [u, d, f, h]
    );
    var w = o(l, g[0], g[1]);
    return s(
      function() {
        y.hasValue = !0, y.value = w;
      },
      [w]
    ), c(w), w;
  }, ir;
}
var cr = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jo;
function sg() {
  return Jo || (Jo = 1, process.env.NODE_ENV !== "production" && function() {
    function e(l, u) {
      return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = Bt, n = Js(), r = typeof Object.is == "function" ? Object.is : e, o = n.useSyncExternalStore, i = t.useRef, s = t.useEffect, a = t.useMemo, c = t.useDebugValue;
    cr.useSyncExternalStoreWithSelector = function(l, u, d, f, h) {
      var g = i(null);
      if (g.current === null) {
        var y = { hasValue: !1, value: null };
        g.current = y;
      } else y = g.current;
      g = a(
        function() {
          function m(E) {
            if (!x) {
              if (x = !0, p = E, E = f(E), h !== void 0 && y.hasValue) {
                var C = y.value;
                if (h(C, E))
                  return b = C;
              }
              return b = E;
            }
            if (C = b, r(p, E))
              return C;
            var A = f(E);
            return h !== void 0 && h(C, A) ? (p = E, C) : (p = E, b = A);
          }
          var x = !1, p, b, _ = d === void 0 ? null : d;
          return [
            function() {
              return m(u());
            },
            _ === null ? void 0 : function() {
              return m(_());
            }
          ];
        },
        [u, d, f, h]
      );
      var w = o(l, g[0], g[1]);
      return s(
        function() {
          y.hasValue = !0, y.value = w;
        },
        [w]
      ), c(w), w;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), cr;
}
process.env.NODE_ENV === "production" ? Pr.exports = ig() : Pr.exports = sg();
var ag = Pr.exports;
const cg = /* @__PURE__ */ ng(ag), lg = {}, ei = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (u, d) => {
    const f = typeof u == "function" ? u(t) : u;
    if (!Object.is(f, t)) {
      const h = t;
      t = d ?? (typeof f != "object" || f === null) ? f : Object.assign({}, t, f), n.forEach((g) => g(t, h));
    }
  }, o = () => t, c = { setState: r, getState: o, getInitialState: () => l, subscribe: (u) => (n.add(u), () => n.delete(u)), destroy: () => {
    (lg ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, l = t = e(r, o, c);
  return c;
}, ug = (e) => e ? ei(e) : ei, { useDebugValue: dg } = Bt, { useSyncExternalStoreWithSelector: fg } = cg, hg = (e) => e;
function ea(e, t = hg, n) {
  const r = fg(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return dg(r), r;
}
const ti = (e, t) => {
  const n = ug(e), r = (o, i = t) => ea(n, o, i);
  return Object.assign(r, n), r;
}, gg = (e, t) => e ? ti(e, t) : ti;
function ie(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size) return !1;
    for (const [r, o] of e)
      if (!Object.is(o, t.get(r)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size) return !1;
    for (const r of e)
      if (!t.has(r))
        return !1;
    return !0;
  }
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !1;
  for (const r of n)
    if (!Object.prototype.hasOwnProperty.call(t, r) || !Object.is(e[r], t[r]))
      return !1;
  return !0;
}
const Bn = Dr(null), pg = Bn.Provider, ta = be.error001();
function Q(e, t) {
  const n = Ft(Bn);
  if (n === null)
    throw new Error(ta);
  return ea(n, e, t);
}
function se() {
  const e = Ft(Bn);
  if (e === null)
    throw new Error(ta);
  return fe(() => ({
    getState: e.getState,
    setState: e.setState,
    subscribe: e.subscribe
  }), [e]);
}
const ni = { display: "none" }, mg = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0px, 0px, 0px, 0px)",
  clipPath: "inset(100%)"
}, na = "react-flow__node-desc", ra = "react-flow__edge-desc", yg = "react-flow__aria-live", wg = (e) => e.ariaLiveMessage, bg = (e) => e.ariaLabelConfig;
function xg({ rfId: e }) {
  const t = Q(wg);
  return k("div", { id: `${yg}-${e}`, "aria-live": "assertive", "aria-atomic": "true", style: mg, children: t });
}
function vg({ rfId: e, disableKeyboardA11y: t }) {
  const n = Q(bg);
  return J(ve, { children: [k("div", { id: `${na}-${e}`, style: ni, children: t ? n["node.a11yDescription.default"] : n["node.a11yDescription.keyboardDisabled"] }), k("div", { id: `${ra}-${e}`, style: ni, children: n["edge.a11yDescription.default"] }), !t && k(xg, { rfId: e })] });
}
const Fn = ji(({ position: e = "top-left", children: t, className: n, style: r, ...o }, i) => {
  const s = `${e}`.split("-");
  return k("div", { className: ce(["react-flow__panel", n, ...s]), style: r, ref: i, ...o, children: t });
});
Fn.displayName = "Panel";
function Eg({ proOptions: e, position: t = "bottom-right" }) {
  return e != null && e.hideAttribution ? null : k(Fn, { position: t, className: "react-flow__attribution", "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://pro.reactflow.dev", children: k("a", { href: "https://reactflow.dev", target: "_blank", rel: "noopener noreferrer", "aria-label": "React Flow attribution", children: "React Flow" }) });
}
const _g = (e) => {
  const t = [], n = [];
  for (const [, r] of e.nodeLookup)
    r.selected && t.push(r.internals.userNode);
  for (const [, r] of e.edgeLookup)
    r.selected && n.push(r);
  return { selectedNodes: t, selectedEdges: n };
}, an = (e) => e.id;
function Sg(e, t) {
  return ie(e.selectedNodes.map(an), t.selectedNodes.map(an)) && ie(e.selectedEdges.map(an), t.selectedEdges.map(an));
}
function Ng({ onSelectionChange: e }) {
  const t = se(), { selectedNodes: n, selectedEdges: r } = Q(_g, Sg);
  return re(() => {
    const o = { nodes: n, edges: r };
    e == null || e(o), t.getState().onSelectionChangeHandlers.forEach((i) => i(o));
  }, [n, r, e]), null;
}
const Cg = (e) => !!e.onSelectionChangeHandlers;
function kg({ onSelectionChange: e }) {
  const t = Q(Cg);
  return e || t ? k(Ng, { onSelectionChange: e }) : null;
}
const Ar = typeof window < "u" ? xl : re, oa = [0, 0], Mg = { x: 0, y: 0, zoom: 1 }, Ig = [
  "nodes",
  "edges",
  "defaultNodes",
  "defaultEdges",
  "onConnect",
  "onConnectStart",
  "onConnectEnd",
  "onClickConnectStart",
  "onClickConnectEnd",
  "nodesDraggable",
  "autoPanOnNodeFocus",
  "nodesConnectable",
  "nodesFocusable",
  "edgesFocusable",
  "edgesReconnectable",
  "elevateNodesOnSelect",
  "elevateEdgesOnSelect",
  "minZoom",
  "maxZoom",
  "nodeExtent",
  "onNodesChange",
  "onEdgesChange",
  "elementsSelectable",
  "connectionMode",
  "snapGrid",
  "snapToGrid",
  "translateExtent",
  "connectOnClick",
  "defaultEdgeOptions",
  "fitView",
  "fitViewOptions",
  "onNodesDelete",
  "onEdgesDelete",
  "onDelete",
  "onNodeDrag",
  "onNodeDragStart",
  "onNodeDragStop",
  "onSelectionDrag",
  "onSelectionDragStart",
  "onSelectionDragStop",
  "onMoveStart",
  "onMove",
  "onMoveEnd",
  "noPanClassName",
  "nodeOrigin",
  "autoPanOnConnect",
  "autoPanOnNodeDrag",
  "onError",
  "connectionRadius",
  "isValidConnection",
  "selectNodesOnDrag",
  "nodeDragThreshold",
  "connectionDragThreshold",
  "onBeforeDelete",
  "debug",
  "autoPanSpeed",
  "ariaLabelConfig",
  "zIndexMode"
], ri = [...Ig, "rfId"], Pg = (e) => ({
  setNodes: e.setNodes,
  setEdges: e.setEdges,
  setMinZoom: e.setMinZoom,
  setMaxZoom: e.setMaxZoom,
  setTranslateExtent: e.setTranslateExtent,
  setNodeExtent: e.setNodeExtent,
  reset: e.reset,
  setDefaultNodesAndEdges: e.setDefaultNodesAndEdges
}), oi = {
  /*
   * these are values that are also passed directly to other components
   * than the StoreUpdater. We can reduce the number of setStore calls
   * by setting the same values here as prev fields.
   */
  translateExtent: $t,
  nodeOrigin: oa,
  minZoom: 0.5,
  maxZoom: 2,
  elementsSelectable: !0,
  noPanClassName: "nopan",
  rfId: "1"
};
function Ag(e) {
  const { setNodes: t, setEdges: n, setMinZoom: r, setMaxZoom: o, setTranslateExtent: i, setNodeExtent: s, reset: a, setDefaultNodesAndEdges: c } = Q(Pg, ie), l = se();
  Ar(() => (c(e.defaultNodes, e.defaultEdges), () => {
    u.current = oi, a();
  }), []);
  const u = ne(oi);
  return Ar(
    () => {
      for (const d of ri) {
        const f = e[d], h = u.current[d];
        f !== h && (typeof e[d] > "u" || (d === "nodes" ? t(f) : d === "edges" ? n(f) : d === "minZoom" ? r(f) : d === "maxZoom" ? o(f) : d === "translateExtent" ? i(f) : d === "nodeExtent" ? s(f) : d === "ariaLabelConfig" ? l.setState({ ariaLabelConfig: hh(f) }) : d === "fitView" ? l.setState({ fitViewQueued: f }) : d === "fitViewOptions" ? l.setState({ fitViewOptions: f }) : l.setState({ [d]: f })));
      }
      u.current = e;
    },
    // Only re-run the effect if one of the fields we track changes
    ri.map((d) => e[d])
  ), null;
}
function ii() {
  return typeof window > "u" || !window.matchMedia ? null : window.matchMedia("(prefers-color-scheme: dark)");
}
function Tg(e) {
  var r;
  const [t, n] = ye(e === "system" ? null : e);
  return re(() => {
    if (e !== "system") {
      n(e);
      return;
    }
    const o = ii(), i = () => n(o != null && o.matches ? "dark" : "light");
    return i(), o == null || o.addEventListener("change", i), () => {
      o == null || o.removeEventListener("change", i);
    };
  }, [e]), t !== null ? t : (r = ii()) != null && r.matches ? "dark" : "light";
}
const si = typeof document < "u" ? document : null;
function Vt(e = null, t = { target: si, actInsideInputWithModifier: !0 }) {
  const [n, r] = ye(!1), o = ne(!1), i = ne(/* @__PURE__ */ new Set([])), [s, a] = fe(() => {
    if (e !== null) {
      const l = (Array.isArray(e) ? e : [e]).filter((d) => typeof d == "string").map((d) => d.replace("+", `
`).replace(`

`, `
+`).split(`
`)), u = l.reduce((d, f) => d.concat(...f), []);
      return [l, u];
    }
    return [[], []];
  }, [e]);
  return re(() => {
    const c = (t == null ? void 0 : t.target) ?? si, l = (t == null ? void 0 : t.actInsideInputWithModifier) ?? !0;
    if (e !== null) {
      const u = (h) => {
        var w, m;
        if (o.current = h.ctrlKey || h.metaKey || h.shiftKey || h.altKey, (!o.current || o.current && !l) && Rs(h))
          return !1;
        const y = ci(h.code, a);
        if (i.current.add(h[y]), ai(s, i.current, !1)) {
          const x = ((m = (w = h.composedPath) == null ? void 0 : w.call(h)) == null ? void 0 : m[0]) || h.target, p = (x == null ? void 0 : x.nodeName) === "BUTTON" || (x == null ? void 0 : x.nodeName) === "A";
          t.preventDefault !== !1 && (o.current || !p) && h.preventDefault(), r(!0);
        }
      }, d = (h) => {
        const g = ci(h.code, a);
        ai(s, i.current, !0) ? (r(!1), i.current.clear()) : i.current.delete(h[g]), h.key === "Meta" && i.current.clear(), o.current = !1;
      }, f = () => {
        i.current.clear(), r(!1);
      };
      return c == null || c.addEventListener("keydown", u), c == null || c.addEventListener("keyup", d), window.addEventListener("blur", f), window.addEventListener("contextmenu", f), () => {
        c == null || c.removeEventListener("keydown", u), c == null || c.removeEventListener("keyup", d), window.removeEventListener("blur", f), window.removeEventListener("contextmenu", f);
      };
    }
  }, [e, r]), n;
}
function ai(e, t, n) {
  return e.filter((r) => n || r.length === t.size).some((r) => r.every((o) => t.has(o)));
}
function ci(e, t) {
  return t.includes(e) ? "code" : "key";
}
const Og = () => {
  const e = se();
  return fe(() => ({
    zoomIn: (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1.2, t) : Promise.resolve(!1);
    },
    zoomOut: (t) => {
      const { panZoom: n } = e.getState();
      return n ? n.scaleBy(1 / 1.2, t) : Promise.resolve(!1);
    },
    zoomTo: (t, n) => {
      const { panZoom: r } = e.getState();
      return r ? r.scaleTo(t, n) : Promise.resolve(!1);
    },
    getZoom: () => e.getState().transform[2],
    setViewport: async (t, n) => {
      const { transform: [r, o, i], panZoom: s } = e.getState();
      return s ? (await s.setViewport({
        x: t.x ?? r,
        y: t.y ?? o,
        zoom: t.zoom ?? i
      }, n), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    getViewport: () => {
      const [t, n, r] = e.getState().transform;
      return { x: t, y: n, zoom: r };
    },
    setCenter: async (t, n, r) => e.getState().setCenter(t, n, r),
    fitBounds: async (t, n) => {
      const { width: r, height: o, minZoom: i, maxZoom: s, panZoom: a } = e.getState(), c = Gr(t, r, o, i, s, (n == null ? void 0 : n.padding) ?? 0.1);
      return a ? (await a.setViewport(c, {
        duration: n == null ? void 0 : n.duration,
        ease: n == null ? void 0 : n.ease,
        interpolate: n == null ? void 0 : n.interpolate
      }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    screenToFlowPosition: (t, n = {}) => {
      const { transform: r, snapGrid: o, snapToGrid: i, domNode: s } = e.getState();
      if (!s)
        return t;
      const { x: a, y: c } = s.getBoundingClientRect(), l = {
        x: t.x - a,
        y: t.y - c
      }, u = n.snapGrid ?? o, d = n.snapToGrid ?? i;
      return qt(l, r, d, u);
    },
    flowToScreenPosition: (t) => {
      const { transform: n, domNode: r } = e.getState();
      if (!r)
        return t;
      const { x: o, y: i } = r.getBoundingClientRect(), s = Sn(t, n);
      return {
        x: s.x + o,
        y: s.y + i
      };
    }
  }), []);
};
function ia(e, t) {
  const n = [], r = /* @__PURE__ */ new Map(), o = [];
  for (const i of e)
    if (i.type === "add") {
      o.push(i);
      continue;
    } else if (i.type === "remove" || i.type === "replace")
      r.set(i.id, [i]);
    else {
      const s = r.get(i.id);
      s ? s.push(i) : r.set(i.id, [i]);
    }
  for (const i of t) {
    const s = r.get(i.id);
    if (!s) {
      n.push(i);
      continue;
    }
    if (s[0].type === "remove")
      continue;
    if (s[0].type === "replace") {
      n.push({ ...s[0].item });
      continue;
    }
    const a = { ...i };
    for (const c of s)
      Lg(c, a);
    n.push(a);
  }
  return o.length && o.forEach((i) => {
    i.index !== void 0 ? n.splice(i.index, 0, { ...i.item }) : n.push({ ...i.item });
  }), n;
}
function Lg(e, t) {
  switch (e.type) {
    case "select": {
      t.selected = e.selected;
      break;
    }
    case "position": {
      typeof e.position < "u" && (t.position = e.position), typeof e.dragging < "u" && (t.dragging = e.dragging);
      break;
    }
    case "dimensions": {
      typeof e.dimensions < "u" && (t.measured = {
        ...e.dimensions
      }, e.setAttributes && ((e.setAttributes === !0 || e.setAttributes === "width") && (t.width = e.dimensions.width), (e.setAttributes === !0 || e.setAttributes === "height") && (t.height = e.dimensions.height))), typeof e.resizing == "boolean" && (t.resizing = e.resizing);
      break;
    }
  }
}
function $g(e, t) {
  return ia(e, t);
}
function Dg(e, t) {
  return ia(e, t);
}
function We(e, t) {
  return {
    id: e,
    type: "select",
    selected: t
  };
}
function st(e, t = /* @__PURE__ */ new Set(), n = !1) {
  const r = [];
  for (const [o, i] of e) {
    const s = t.has(o);
    !(i.selected === void 0 && !s) && i.selected !== s && (n && (i.selected = s), r.push(We(i.id, s)));
  }
  return r;
}
function li({ items: e = [], lookup: t }) {
  var o;
  const n = [], r = new Map(e.map((i) => [i.id, i]));
  for (const [i, s] of e.entries()) {
    const a = t.get(s.id), c = ((o = a == null ? void 0 : a.internals) == null ? void 0 : o.userNode) ?? a;
    c !== void 0 && c !== s && n.push({ id: s.id, item: s, type: "replace" }), c === void 0 && n.push({ item: s, type: "add", index: i });
  }
  for (const [i] of t)
    r.get(i) === void 0 && n.push({ id: i, type: "remove" });
  return n;
}
function ui(e) {
  return {
    id: e.id,
    type: "remove"
  };
}
const di = (e) => oh(e), Rg = (e) => Ms(e);
function sa(e) {
  return ji(e);
}
function fi(e) {
  const [t, n] = ye(BigInt(0)), [r] = ye(() => zg(() => n((o) => o + BigInt(1))));
  return Ar(() => {
    const o = r.get();
    o.length && (e(o), r.reset());
  }, [t]), r;
}
function zg(e) {
  let t = [];
  return {
    get: () => t,
    reset: () => {
      t = [];
    },
    push: (n) => {
      t.push(n), e();
    }
  };
}
const aa = Dr(null);
function Vg({ children: e }) {
  const t = se(), n = me((a) => {
    const { nodes: c = [], setNodes: l, hasDefaultNodes: u, onNodesChange: d, nodeLookup: f, fitViewQueued: h, onNodesChangeMiddlewareMap: g } = t.getState();
    let y = c;
    for (const m of a)
      y = typeof m == "function" ? m(y) : m;
    let w = li({
      items: y,
      lookup: f
    });
    for (const m of g.values())
      w = m(w);
    u && l(y), w.length > 0 ? d == null || d(w) : h && window.requestAnimationFrame(() => {
      const { fitViewQueued: m, nodes: x, setNodes: p } = t.getState();
      m && p(x);
    });
  }, []), r = fi(n), o = me((a) => {
    const { edges: c = [], setEdges: l, hasDefaultEdges: u, onEdgesChange: d, edgeLookup: f } = t.getState();
    let h = c;
    for (const g of a)
      h = typeof g == "function" ? g(h) : g;
    u ? l(h) : d && d(li({
      items: h,
      lookup: f
    }));
  }, []), i = fi(o), s = fe(() => ({ nodeQueue: r, edgeQueue: i }), []);
  return k(aa.Provider, { value: s, children: e });
}
function Hg() {
  const e = Ft(aa);
  if (!e)
    throw new Error("useBatchContext must be used within a BatchProvider");
  return e;
}
const Bg = (e) => !!e.panZoom;
function Yn() {
  const e = Og(), t = se(), n = Hg(), r = Q(Bg), o = fe(() => {
    const i = (d) => t.getState().nodeLookup.get(d), s = (d) => {
      n.nodeQueue.push(d);
    }, a = (d) => {
      n.edgeQueue.push(d);
    }, c = (d) => {
      var m, x;
      const { nodeLookup: f, nodeOrigin: h } = t.getState(), g = di(d) ? d : f.get(d.id), y = g.parentId ? $s(g.position, g.measured, g.parentId, f, h) : g.position, w = {
        ...g,
        position: y,
        width: ((m = g.measured) == null ? void 0 : m.width) ?? g.width,
        height: ((x = g.measured) == null ? void 0 : x.height) ?? g.height
      };
      return ht(w);
    }, l = (d, f, h = { replace: !1 }) => {
      s((g) => g.map((y) => {
        if (y.id === d) {
          const w = typeof f == "function" ? f(y) : f;
          return h.replace && di(w) ? w : { ...y, ...w };
        }
        return y;
      }));
    }, u = (d, f, h = { replace: !1 }) => {
      a((g) => g.map((y) => {
        if (y.id === d) {
          const w = typeof f == "function" ? f(y) : f;
          return h.replace && Rg(w) ? w : { ...y, ...w };
        }
        return y;
      }));
    };
    return {
      getNodes: () => t.getState().nodes.map((d) => ({ ...d })),
      getNode: (d) => {
        var f;
        return (f = i(d)) == null ? void 0 : f.internals.userNode;
      },
      getInternalNode: i,
      getEdges: () => {
        const { edges: d = [] } = t.getState();
        return d.map((f) => ({ ...f }));
      },
      getEdge: (d) => t.getState().edgeLookup.get(d),
      setNodes: s,
      setEdges: a,
      addNodes: (d) => {
        const f = Array.isArray(d) ? d : [d];
        n.nodeQueue.push((h) => [...h, ...f]);
      },
      addEdges: (d) => {
        const f = Array.isArray(d) ? d : [d];
        n.edgeQueue.push((h) => [...h, ...f]);
      },
      toObject: () => {
        const { nodes: d = [], edges: f = [], transform: h } = t.getState(), [g, y, w] = h;
        return {
          nodes: d.map((m) => ({ ...m })),
          edges: f.map((m) => ({ ...m })),
          viewport: {
            x: g,
            y,
            zoom: w
          }
        };
      },
      deleteElements: async ({ nodes: d = [], edges: f = [] }) => {
        const { nodes: h, edges: g, onNodesDelete: y, onEdgesDelete: w, triggerNodeChanges: m, triggerEdgeChanges: x, onDelete: p, onBeforeDelete: b } = t.getState(), { nodes: _, edges: E } = await lh({
          nodesToRemove: d,
          edgesToRemove: f,
          nodes: h,
          edges: g,
          onBeforeDelete: b
        }), C = E.length > 0, A = _.length > 0;
        if (C) {
          const M = E.map(ui);
          w == null || w(E), x(M);
        }
        if (A) {
          const M = _.map(ui);
          y == null || y(_), m(M);
        }
        return (A || C) && (p == null || p({ nodes: _, edges: E })), { deletedNodes: _, deletedEdges: E };
      },
      /**
       * Partial is defined as "the 2 nodes/areas are intersecting partially".
       * If a is contained in b or b is contained in a, they are both
       * considered fully intersecting.
       */
      getIntersectingNodes: (d, f = !0, h) => {
        const g = Do(d), y = g ? d : c(d), w = h !== void 0;
        return y ? (h || t.getState().nodes).filter((m) => {
          const x = t.getState().nodeLookup.get(m.id);
          if (x && !g && (m.id === d.id || !x.internals.positionAbsolute))
            return !1;
          const p = ht(w ? m : x), b = Rt(p, y);
          return f && b > 0 || b >= p.width * p.height || b >= y.width * y.height;
        }) : [];
      },
      isNodeIntersecting: (d, f, h = !0) => {
        const y = Do(d) ? d : c(d);
        if (!y)
          return !1;
        const w = Rt(y, f);
        return h && w > 0 || w >= f.width * f.height || w >= y.width * y.height;
      },
      updateNode: l,
      updateNodeData: (d, f, h = { replace: !1 }) => {
        l(d, (g) => {
          const y = typeof f == "function" ? f(g) : f;
          return h.replace ? { ...g, data: y } : { ...g, data: { ...g.data, ...y } };
        }, h);
      },
      updateEdge: u,
      updateEdgeData: (d, f, h = { replace: !1 }) => {
        u(d, (g) => {
          const y = typeof f == "function" ? f(g) : f;
          return h.replace ? { ...g, data: y } : { ...g, data: { ...g.data, ...y } };
        }, h);
      },
      getNodesBounds: (d) => {
        const { nodeLookup: f, nodeOrigin: h } = t.getState();
        return ih(d, { nodeLookup: f, nodeOrigin: h });
      },
      getHandleConnections: ({ type: d, id: f, nodeId: h }) => {
        var g;
        return Array.from(((g = t.getState().connectionLookup.get(`${h}-${d}${f ? `-${f}` : ""}`)) == null ? void 0 : g.values()) ?? []);
      },
      getNodeConnections: ({ type: d, handleId: f, nodeId: h }) => {
        var g;
        return Array.from(((g = t.getState().connectionLookup.get(`${h}${d ? f ? `-${d}-${f}` : `-${d}` : ""}`)) == null ? void 0 : g.values()) ?? []);
      },
      fitView: async (d) => {
        const f = t.getState().fitViewResolver ?? fh();
        return t.setState({ fitViewQueued: !0, fitViewOptions: d, fitViewResolver: f }), n.nodeQueue.push((h) => [...h]), f.promise;
      }
    };
  }, []);
  return fe(() => ({
    ...o,
    ...e,
    viewportInitialized: r
  }), [r]);
}
const hi = (e) => e.selected, Fg = typeof window < "u" ? window : void 0;
function Yg({ deleteKeyCode: e, multiSelectionKeyCode: t }) {
  const n = se(), { deleteElements: r } = Yn(), o = Vt(e, { actInsideInputWithModifier: !1 }), i = Vt(t, { target: Fg });
  re(() => {
    if (o) {
      const { edges: s, nodes: a } = n.getState();
      r({ nodes: a.filter(hi), edges: s.filter(hi) }), n.setState({ nodesSelectionActive: !1 });
    }
  }, [o]), re(() => {
    n.setState({ multiSelectionActive: i });
  }, [i]);
}
function Xg(e) {
  const t = se();
  re(() => {
    const n = () => {
      var o, i, s, a;
      if (!e.current || !(((i = (o = e.current).checkVisibility) == null ? void 0 : i.call(o)) ?? !0))
        return !1;
      const r = jr(e.current);
      (r.height === 0 || r.width === 0) && ((a = (s = t.getState()).onError) == null || a.call(s, "004", be.error004())), t.setState({ width: r.width || 500, height: r.height || 500 });
    };
    if (e.current) {
      n(), window.addEventListener("resize", n);
      const r = new ResizeObserver(() => n());
      return r.observe(e.current), () => {
        window.removeEventListener("resize", n), r && e.current && r.unobserve(e.current);
      };
    }
  }, []);
}
const Xn = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
}, Wg = (e) => ({
  userSelectionActive: e.userSelectionActive,
  lib: e.lib,
  connectionInProgress: e.connection.inProgress
});
function Gg({ onPaneContextMenu: e, zoomOnScroll: t = !0, zoomOnPinch: n = !0, panOnScroll: r = !1, panOnScrollSpeed: o = 0.5, panOnScrollMode: i = qe.Free, zoomOnDoubleClick: s = !0, panOnDrag: a = !0, defaultViewport: c, translateExtent: l, minZoom: u, maxZoom: d, zoomActivationKeyCode: f, preventScrolling: h = !0, children: g, noWheelClassName: y, noPanClassName: w, onViewportChange: m, isControlledViewport: x, paneClickDistance: p, selectionOnDrag: b }) {
  const _ = se(), E = ne(null), { userSelectionActive: C, lib: A, connectionInProgress: M } = Q(Wg, ie), z = Vt(f), P = ne();
  Xg(E);
  const L = me((V) => {
    m == null || m({ x: V[0], y: V[1], zoom: V[2] }), x || _.setState({ transform: V });
  }, [m, x]);
  return re(() => {
    if (E.current) {
      P.current = Kh({
        domNode: E.current,
        minZoom: u,
        maxZoom: d,
        translateExtent: l,
        viewport: c,
        onDraggingChange: (S) => _.setState((O) => O.paneDragging === S ? O : { paneDragging: S }),
        onPanZoomStart: (S, O) => {
          const { onViewportChangeStart: I, onMoveStart: N } = _.getState();
          N == null || N(S, O), I == null || I(O);
        },
        onPanZoom: (S, O) => {
          const { onViewportChange: I, onMove: N } = _.getState();
          N == null || N(S, O), I == null || I(O);
        },
        onPanZoomEnd: (S, O) => {
          const { onViewportChangeEnd: I, onMoveEnd: N } = _.getState();
          N == null || N(S, O), I == null || I(O);
        }
      });
      const { x: V, y: v, zoom: T } = P.current.getViewport();
      return _.setState({
        panZoom: P.current,
        transform: [V, v, T],
        domNode: E.current.closest(".react-flow")
      }), () => {
        var S;
        (S = P.current) == null || S.destroy();
      };
    }
  }, []), re(() => {
    var V;
    (V = P.current) == null || V.update({
      onPaneContextMenu: e,
      zoomOnScroll: t,
      zoomOnPinch: n,
      panOnScroll: r,
      panOnScrollSpeed: o,
      panOnScrollMode: i,
      zoomOnDoubleClick: s,
      panOnDrag: a,
      zoomActivationKeyPressed: z,
      preventScrolling: h,
      noPanClassName: w,
      userSelectionActive: C,
      noWheelClassName: y,
      lib: A,
      onTransformChange: L,
      connectionInProgress: M,
      selectionOnDrag: b,
      paneClickDistance: p
    });
  }, [
    e,
    t,
    n,
    r,
    o,
    i,
    s,
    a,
    z,
    h,
    w,
    C,
    y,
    A,
    L,
    M,
    b,
    p
  ]), k("div", { className: "react-flow__renderer", ref: E, style: Xn, children: g });
}
const jg = (e) => ({
  userSelectionActive: e.userSelectionActive,
  userSelectionRect: e.userSelectionRect
});
function qg() {
  const { userSelectionActive: e, userSelectionRect: t } = Q(jg, ie);
  return e && t ? k("div", { className: "react-flow__selection react-flow__container", style: {
    width: t.width,
    height: t.height,
    transform: `translate(${t.x}px, ${t.y}px)`
  } }) : null;
}
const lr = (e, t) => (n) => {
  n.target === t.current && (e == null || e(n));
}, Kg = (e) => ({
  userSelectionActive: e.userSelectionActive,
  elementsSelectable: e.elementsSelectable,
  connectionInProgress: e.connection.inProgress,
  dragging: e.paneDragging
});
function Ug({ isSelecting: e, selectionKeyPressed: t, selectionMode: n = Dt.Full, panOnDrag: r, paneClickDistance: o, selectionOnDrag: i, onSelectionStart: s, onSelectionEnd: a, onPaneClick: c, onPaneContextMenu: l, onPaneScroll: u, onPaneMouseEnter: d, onPaneMouseMove: f, onPaneMouseLeave: h, children: g }) {
  const y = se(), { userSelectionActive: w, elementsSelectable: m, dragging: x, connectionInProgress: p } = Q(Kg, ie), b = m && (e || w), _ = ne(null), E = ne(), C = ne(/* @__PURE__ */ new Set()), A = ne(/* @__PURE__ */ new Set()), M = ne(!1), z = (I) => {
    if (M.current || p) {
      M.current = !1;
      return;
    }
    c == null || c(I), y.getState().resetSelectedElements(), y.setState({ nodesSelectionActive: !1 });
  }, P = (I) => {
    if (Array.isArray(r) && (r != null && r.includes(2))) {
      I.preventDefault();
      return;
    }
    l == null || l(I);
  }, L = u ? (I) => u(I) : void 0, V = (I) => {
    M.current && (I.stopPropagation(), M.current = !1);
  }, v = (I) => {
    var X, q;
    const { domNode: N } = y.getState();
    if (E.current = N == null ? void 0 : N.getBoundingClientRect(), !E.current)
      return;
    const $ = I.target === _.current;
    if (!$ && !!I.target.closest(".nokey") || !e || !(i && $ || t) || I.button !== 0 || !I.isPrimary)
      return;
    (q = (X = I.target) == null ? void 0 : X.setPointerCapture) == null || q.call(X, I.pointerId), M.current = !1;
    const { x: F, y: Y } = Ce(I.nativeEvent, E.current);
    y.setState({
      userSelectionRect: {
        width: 0,
        height: 0,
        startX: F,
        startY: Y,
        x: F,
        y: Y
      }
    }), $ || (I.stopPropagation(), I.preventDefault());
  }, T = (I) => {
    const { userSelectionRect: N, transform: $, nodeLookup: R, edgeLookup: D, connectionLookup: F, triggerNodeChanges: Y, triggerEdgeChanges: X, defaultEdgeOptions: q, resetSelectedElements: G } = y.getState();
    if (!E.current || !N)
      return;
    const { x: H, y: W } = Ce(I.nativeEvent, E.current), { startX: Z, startY: U } = N;
    if (!M.current) {
      const ee = t ? 0 : o;
      if (Math.hypot(H - Z, W - U) <= ee)
        return;
      G(), s == null || s(I);
    }
    M.current = !0;
    const K = {
      startX: Z,
      startY: U,
      x: H < Z ? H : Z,
      y: W < U ? W : U,
      width: Math.abs(H - Z),
      height: Math.abs(W - U)
    }, j = C.current, te = A.current;
    C.current = new Set(Wr(R, K, $, n === Dt.Partial, !0).map((ee) => ee.id)), A.current = /* @__PURE__ */ new Set();
    const oe = (q == null ? void 0 : q.selectable) ?? !0;
    for (const ee of C.current) {
      const ue = F.get(ee);
      if (ue)
        for (const { edgeId: Re } of ue.values()) {
          const Te = D.get(Re);
          Te && (Te.selectable ?? oe) && A.current.add(Re);
        }
    }
    if (!Ro(j, C.current)) {
      const ee = st(R, C.current, !0);
      Y(ee);
    }
    if (!Ro(te, A.current)) {
      const ee = st(D, A.current);
      X(ee);
    }
    y.setState({
      userSelectionRect: K,
      userSelectionActive: !0,
      nodesSelectionActive: !1
    });
  }, S = (I) => {
    var N, $;
    I.button === 0 && (($ = (N = I.target) == null ? void 0 : N.releasePointerCapture) == null || $.call(N, I.pointerId), !w && I.target === _.current && y.getState().userSelectionRect && (z == null || z(I)), y.setState({
      userSelectionActive: !1,
      userSelectionRect: null
    }), M.current && (a == null || a(I), y.setState({
      nodesSelectionActive: C.current.size > 0
    })));
  }, O = r === !0 || Array.isArray(r) && r.includes(0);
  return J("div", { className: ce(["react-flow__pane", { draggable: O, dragging: x, selection: e }]), onClick: b ? void 0 : lr(z, _), onContextMenu: lr(P, _), onWheel: lr(L, _), onPointerEnter: b ? void 0 : d, onPointerMove: b ? T : f, onPointerUp: b ? S : void 0, onPointerDownCapture: b ? v : void 0, onClickCapture: b ? V : void 0, onPointerLeave: h, ref: _, style: Xn, children: [g, k(qg, {})] });
}
function Tr({ id: e, store: t, unselect: n = !1, nodeRef: r }) {
  const { addSelectedNodes: o, unselectNodesAndEdges: i, multiSelectionActive: s, nodeLookup: a, onError: c } = t.getState(), l = a.get(e);
  if (!l) {
    c == null || c("012", be.error012(e));
    return;
  }
  t.setState({ nodesSelectionActive: !1 }), l.selected ? (n || l.selected && s) && (i({ nodes: [l], edges: [] }), requestAnimationFrame(() => {
    var u;
    return (u = r == null ? void 0 : r.current) == null ? void 0 : u.blur();
  })) : o([e]);
}
function ca({ nodeRef: e, disabled: t = !1, noDragClassName: n, handleSelector: r, nodeId: o, isSelectable: i, nodeClickDistance: s }) {
  const a = se(), [c, l] = ye(!1), u = ne();
  return re(() => {
    u.current = $h({
      getStoreItems: () => a.getState(),
      onNodeMouseDown: (d) => {
        Tr({
          id: d,
          store: a,
          nodeRef: e
        });
      },
      onDragStart: () => {
        l(!0);
      },
      onDragStop: () => {
        l(!1);
      }
    });
  }, []), re(() => {
    if (!(t || !e.current || !u.current))
      return u.current.update({
        noDragClassName: n,
        handleSelector: r,
        domNode: e.current,
        isSelectable: i,
        nodeId: o,
        nodeClickDistance: s
      }), () => {
        var d;
        (d = u.current) == null || d.destroy();
      };
  }, [n, r, t, i, e, o, s]), c;
}
const Zg = (e) => (t) => t.selected && (t.draggable || e && typeof t.draggable > "u");
function la() {
  const e = se();
  return me((n) => {
    const { nodeExtent: r, snapToGrid: o, snapGrid: i, nodesDraggable: s, onError: a, updateNodePositions: c, nodeLookup: l, nodeOrigin: u } = e.getState(), d = /* @__PURE__ */ new Map(), f = Zg(s), h = o ? i[0] : 5, g = o ? i[1] : 5, y = n.direction.x * h * n.factor, w = n.direction.y * g * n.factor;
    for (const [, m] of l) {
      if (!f(m))
        continue;
      let x = {
        x: m.internals.positionAbsolute.x + y,
        y: m.internals.positionAbsolute.y + w
      };
      o && (x = jt(x, i));
      const { position: p, positionAbsolute: b } = Is({
        nodeId: m.id,
        nextPosition: x,
        nodeLookup: l,
        nodeExtent: r,
        nodeOrigin: u,
        onError: a
      });
      m.position = p, m.internals.positionAbsolute = b, d.set(m.id, m);
    }
    c(d);
  }, []);
}
const eo = Dr(null), Qg = eo.Provider;
eo.Consumer;
const ua = () => Ft(eo), Jg = (e) => ({
  connectOnClick: e.connectOnClick,
  noPanClassName: e.noPanClassName,
  rfId: e.rfId
}), ep = (e, t, n) => (r) => {
  const { connectionClickStartHandle: o, connectionMode: i, connection: s } = r, { fromHandle: a, toHandle: c, isValid: l } = s, u = (c == null ? void 0 : c.nodeId) === e && (c == null ? void 0 : c.id) === t && (c == null ? void 0 : c.type) === n;
  return {
    connectingFrom: (a == null ? void 0 : a.nodeId) === e && (a == null ? void 0 : a.id) === t && (a == null ? void 0 : a.type) === n,
    connectingTo: u,
    clickConnecting: (o == null ? void 0 : o.nodeId) === e && (o == null ? void 0 : o.id) === t && (o == null ? void 0 : o.type) === n,
    isPossibleEndHandle: i === dt.Strict ? (a == null ? void 0 : a.type) !== n : e !== (a == null ? void 0 : a.nodeId) || t !== (a == null ? void 0 : a.id),
    connectionInProcess: !!a,
    clickConnectionInProcess: !!o,
    valid: u && l
  };
};
function tp({ type: e = "source", position: t = B.Top, isValidConnection: n, isConnectable: r = !0, isConnectableStart: o = !0, isConnectableEnd: i = !0, id: s, onConnect: a, children: c, className: l, onMouseDown: u, onTouchStart: d, ...f }, h) {
  var T, S;
  const g = s || null, y = e === "target", w = se(), m = ua(), { connectOnClick: x, noPanClassName: p, rfId: b } = Q(Jg, ie), { connectingFrom: _, connectingTo: E, clickConnecting: C, isPossibleEndHandle: A, connectionInProcess: M, clickConnectionInProcess: z, valid: P } = Q(ep(m, g, e), ie);
  m || (S = (T = w.getState()).onError) == null || S.call(T, "010", be.error010());
  const L = (O) => {
    const { defaultEdgeOptions: I, onConnect: N, hasDefaultEdges: $ } = w.getState(), R = {
      ...I,
      ...O
    };
    if ($) {
      const { edges: D, setEdges: F } = w.getState();
      F(bh(R, D));
    }
    N == null || N(R), a == null || a(R);
  }, V = (O) => {
    if (!m)
      return;
    const I = zs(O.nativeEvent);
    if (o && (I && O.button === 0 || !I)) {
      const N = w.getState();
      Ir.onPointerDown(O.nativeEvent, {
        handleDomNode: O.currentTarget,
        autoPanOnConnect: N.autoPanOnConnect,
        connectionMode: N.connectionMode,
        connectionRadius: N.connectionRadius,
        domNode: N.domNode,
        nodeLookup: N.nodeLookup,
        lib: N.lib,
        isTarget: y,
        handleId: g,
        nodeId: m,
        flowId: N.rfId,
        panBy: N.panBy,
        cancelConnection: N.cancelConnection,
        onConnectStart: N.onConnectStart,
        onConnectEnd: (...$) => {
          var R, D;
          return (D = (R = w.getState()).onConnectEnd) == null ? void 0 : D.call(R, ...$);
        },
        updateConnection: N.updateConnection,
        onConnect: L,
        isValidConnection: n || ((...$) => {
          var R, D;
          return ((D = (R = w.getState()).isValidConnection) == null ? void 0 : D.call(R, ...$)) ?? !0;
        }),
        getTransform: () => w.getState().transform,
        getFromHandle: () => w.getState().connection.fromHandle,
        autoPanSpeed: N.autoPanSpeed,
        dragThreshold: N.connectionDragThreshold
      });
    }
    I ? u == null || u(O) : d == null || d(O);
  }, v = (O) => {
    const { onClickConnectStart: I, onClickConnectEnd: N, connectionClickStartHandle: $, connectionMode: R, isValidConnection: D, lib: F, rfId: Y, nodeLookup: X, connection: q } = w.getState();
    if (!m || !$ && !o)
      return;
    if (!$) {
      I == null || I(O.nativeEvent, { nodeId: m, handleId: g, handleType: e }), w.setState({ connectionClickStartHandle: { nodeId: m, type: e, id: g } });
      return;
    }
    const G = Ds(O.target), H = n || D, { connection: W, isValid: Z } = Ir.isValid(O.nativeEvent, {
      handle: {
        nodeId: m,
        id: g,
        type: e
      },
      connectionMode: R,
      fromNodeId: $.nodeId,
      fromHandleId: $.id || null,
      fromType: $.type,
      isValidConnection: H,
      flowId: Y,
      doc: G,
      lib: F,
      nodeLookup: X
    });
    Z && W && L(W);
    const U = structuredClone(q);
    delete U.inProgress, U.toPosition = U.toHandle ? U.toHandle.position : null, N == null || N(O, U), w.setState({ connectionClickStartHandle: null });
  };
  return k("div", { "data-handleid": g, "data-nodeid": m, "data-handlepos": t, "data-id": `${b}-${m}-${g}-${e}`, className: ce([
    "react-flow__handle",
    `react-flow__handle-${t}`,
    "nodrag",
    p,
    l,
    {
      source: !y,
      target: y,
      connectable: r,
      connectablestart: o,
      connectableend: i,
      clickconnecting: C,
      connectingfrom: _,
      connectingto: E,
      valid: P,
      /*
       * shows where you can start a connection from
       * and where you can end it while connecting
       */
      connectionindicator: r && (!M || A) && (M || z ? i : o)
    }
  ]), onMouseDown: V, onTouchStart: V, onClick: x ? v : void 0, ref: h, ...f, children: c });
}
const le = ae(sa(tp));
function np({ data: e, isConnectable: t, sourcePosition: n = B.Bottom }) {
  return J(ve, { children: [e == null ? void 0 : e.label, k(le, { type: "source", position: n, isConnectable: t })] });
}
function rp({ data: e, isConnectable: t, targetPosition: n = B.Top, sourcePosition: r = B.Bottom }) {
  return J(ve, { children: [k(le, { type: "target", position: n, isConnectable: t }), e == null ? void 0 : e.label, k(le, { type: "source", position: r, isConnectable: t })] });
}
function op() {
  return null;
}
function ip({ data: e, isConnectable: t, targetPosition: n = B.Top }) {
  return J(ve, { children: [k(le, { type: "target", position: n, isConnectable: t }), e == null ? void 0 : e.label] });
}
const Cn = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
}, gi = {
  input: np,
  default: rp,
  output: ip,
  group: op
};
function sp(e) {
  var t, n, r, o;
  return e.internals.handleBounds === void 0 ? {
    width: e.width ?? e.initialWidth ?? ((t = e.style) == null ? void 0 : t.width),
    height: e.height ?? e.initialHeight ?? ((n = e.style) == null ? void 0 : n.height)
  } : {
    width: e.width ?? ((r = e.style) == null ? void 0 : r.width),
    height: e.height ?? ((o = e.style) == null ? void 0 : o.height)
  };
}
const ap = (e) => {
  const { width: t, height: n, x: r, y: o } = Gt(e.nodeLookup, {
    filter: (i) => !!i.selected
  });
  return {
    width: Ne(t) ? t : null,
    height: Ne(n) ? n : null,
    userSelectionActive: e.userSelectionActive,
    transformString: `translate(${e.transform[0]}px,${e.transform[1]}px) scale(${e.transform[2]}) translate(${r}px,${o}px)`
  };
};
function cp({ onSelectionContextMenu: e, noPanClassName: t, disableKeyboardA11y: n }) {
  const r = se(), { width: o, height: i, transformString: s, userSelectionActive: a } = Q(ap, ie), c = la(), l = ne(null);
  re(() => {
    var h;
    n || (h = l.current) == null || h.focus({
      preventScroll: !0
    });
  }, [n]);
  const u = !a && o !== null && i !== null;
  if (ca({
    nodeRef: l,
    disabled: !u
  }), !u)
    return null;
  const d = e ? (h) => {
    const g = r.getState().nodes.filter((y) => y.selected);
    e(h, g);
  } : void 0, f = (h) => {
    Object.prototype.hasOwnProperty.call(Cn, h.key) && (h.preventDefault(), c({
      direction: Cn[h.key],
      factor: h.shiftKey ? 4 : 1
    }));
  };
  return k("div", { className: ce(["react-flow__nodesselection", "react-flow__container", t]), style: {
    transform: s
  }, children: k("div", { ref: l, className: "react-flow__nodesselection-rect", onContextMenu: d, tabIndex: n ? void 0 : -1, onKeyDown: n ? void 0 : f, style: {
    width: o,
    height: i
  } }) });
}
const pi = typeof window < "u" ? window : void 0, lp = (e) => ({ nodesSelectionActive: e.nodesSelectionActive, userSelectionActive: e.userSelectionActive });
function da({ children: e, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: o, onPaneContextMenu: i, onPaneScroll: s, paneClickDistance: a, deleteKeyCode: c, selectionKeyCode: l, selectionOnDrag: u, selectionMode: d, onSelectionStart: f, onSelectionEnd: h, multiSelectionKeyCode: g, panActivationKeyCode: y, zoomActivationKeyCode: w, elementsSelectable: m, zoomOnScroll: x, zoomOnPinch: p, panOnScroll: b, panOnScrollSpeed: _, panOnScrollMode: E, zoomOnDoubleClick: C, panOnDrag: A, defaultViewport: M, translateExtent: z, minZoom: P, maxZoom: L, preventScrolling: V, onSelectionContextMenu: v, noWheelClassName: T, noPanClassName: S, disableKeyboardA11y: O, onViewportChange: I, isControlledViewport: N }) {
  const { nodesSelectionActive: $, userSelectionActive: R } = Q(lp, ie), D = Vt(l, { target: pi }), F = Vt(y, { target: pi }), Y = F || A, X = F || b, q = u && Y !== !0, G = D || R || q;
  return Yg({ deleteKeyCode: c, multiSelectionKeyCode: g }), k(Gg, { onPaneContextMenu: i, elementsSelectable: m, zoomOnScroll: x, zoomOnPinch: p, panOnScroll: X, panOnScrollSpeed: _, panOnScrollMode: E, zoomOnDoubleClick: C, panOnDrag: !D && Y, defaultViewport: M, translateExtent: z, minZoom: P, maxZoom: L, zoomActivationKeyCode: w, preventScrolling: V, noWheelClassName: T, noPanClassName: S, onViewportChange: I, isControlledViewport: N, paneClickDistance: a, selectionOnDrag: q, children: J(Ug, { onSelectionStart: f, onSelectionEnd: h, onPaneClick: t, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: o, onPaneContextMenu: i, onPaneScroll: s, panOnDrag: Y, isSelecting: !!G, selectionMode: d, selectionKeyPressed: D, paneClickDistance: a, selectionOnDrag: q, children: [e, $ && k(cp, { onSelectionContextMenu: v, noPanClassName: S, disableKeyboardA11y: O })] }) });
}
da.displayName = "FlowRenderer";
const up = ae(da), dp = (e) => (t) => e ? Wr(t.nodeLookup, { x: 0, y: 0, width: t.width, height: t.height }, t.transform, !0).map((n) => n.id) : Array.from(t.nodeLookup.keys());
function fp(e) {
  return Q(me(dp(e), [e]), ie);
}
const hp = (e) => e.updateNodeInternals;
function gp() {
  const e = Q(hp), [t] = ye(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((n) => {
    const r = /* @__PURE__ */ new Map();
    n.forEach((o) => {
      const i = o.target.getAttribute("data-id");
      r.set(i, {
        id: i,
        nodeElement: o.target,
        force: !0
      });
    }), e(r);
  }));
  return re(() => () => {
    t == null || t.disconnect();
  }, [t]), t;
}
function pp({ node: e, nodeType: t, hasDimensions: n, resizeObserver: r }) {
  const o = se(), i = ne(null), s = ne(null), a = ne(e.sourcePosition), c = ne(e.targetPosition), l = ne(t), u = n && !!e.internals.handleBounds;
  return re(() => {
    i.current && !e.hidden && (!u || s.current !== i.current) && (s.current && (r == null || r.unobserve(s.current)), r == null || r.observe(i.current), s.current = i.current);
  }, [u, e.hidden]), re(() => () => {
    s.current && (r == null || r.unobserve(s.current), s.current = null);
  }, []), re(() => {
    if (i.current) {
      const d = l.current !== t, f = a.current !== e.sourcePosition, h = c.current !== e.targetPosition;
      (d || f || h) && (l.current = t, a.current = e.sourcePosition, c.current = e.targetPosition, o.getState().updateNodeInternals(/* @__PURE__ */ new Map([[e.id, { id: e.id, nodeElement: i.current, force: !0 }]])));
    }
  }, [e.id, t, e.sourcePosition, e.targetPosition]), i;
}
function mp({ id: e, onClick: t, onMouseEnter: n, onMouseMove: r, onMouseLeave: o, onContextMenu: i, onDoubleClick: s, nodesDraggable: a, elementsSelectable: c, nodesConnectable: l, nodesFocusable: u, resizeObserver: d, noDragClassName: f, noPanClassName: h, disableKeyboardA11y: g, rfId: y, nodeTypes: w, nodeClickDistance: m, onError: x }) {
  const { node: p, internals: b, isParent: _ } = Q((H) => {
    const W = H.nodeLookup.get(e), Z = H.parentLookup.has(e);
    return {
      node: W,
      internals: W.internals,
      isParent: Z
    };
  }, ie);
  let E = p.type || "default", C = (w == null ? void 0 : w[E]) || gi[E];
  C === void 0 && (x == null || x("003", be.error003(E)), E = "default", C = (w == null ? void 0 : w.default) || gi.default);
  const A = !!(p.draggable || a && typeof p.draggable > "u"), M = !!(p.selectable || c && typeof p.selectable > "u"), z = !!(p.connectable || l && typeof p.connectable > "u"), P = !!(p.focusable || u && typeof p.focusable > "u"), L = se(), V = Ls(p), v = pp({ node: p, nodeType: E, hasDimensions: V, resizeObserver: d }), T = ca({
    nodeRef: v,
    disabled: p.hidden || !A,
    noDragClassName: f,
    handleSelector: p.dragHandle,
    nodeId: e,
    isSelectable: M,
    nodeClickDistance: m
  }), S = la();
  if (p.hidden)
    return null;
  const O = De(p), I = sp(p), N = M || A || t || n || r || o, $ = n ? (H) => n(H, { ...b.userNode }) : void 0, R = r ? (H) => r(H, { ...b.userNode }) : void 0, D = o ? (H) => o(H, { ...b.userNode }) : void 0, F = i ? (H) => i(H, { ...b.userNode }) : void 0, Y = s ? (H) => s(H, { ...b.userNode }) : void 0, X = (H) => {
    const { selectNodesOnDrag: W, nodeDragThreshold: Z } = L.getState();
    M && (!W || !A || Z > 0) && Tr({
      id: e,
      store: L,
      nodeRef: v
    }), t && t(H, { ...b.userNode });
  }, q = (H) => {
    if (!(Rs(H.nativeEvent) || g)) {
      if (Ss.includes(H.key) && M) {
        const W = H.key === "Escape";
        Tr({
          id: e,
          store: L,
          unselect: W,
          nodeRef: v
        });
      } else if (A && p.selected && Object.prototype.hasOwnProperty.call(Cn, H.key)) {
        H.preventDefault();
        const { ariaLabelConfig: W } = L.getState();
        L.setState({
          ariaLiveMessage: W["node.a11yDescription.ariaLiveMessage"]({
            direction: H.key.replace("Arrow", "").toLowerCase(),
            x: ~~b.positionAbsolute.x,
            y: ~~b.positionAbsolute.y
          })
        }), S({
          direction: Cn[H.key],
          factor: H.shiftKey ? 4 : 1
        });
      }
    }
  }, G = () => {
    var te;
    if (g || !((te = v.current) != null && te.matches(":focus-visible")))
      return;
    const { transform: H, width: W, height: Z, autoPanOnNodeFocus: U, setCenter: K } = L.getState();
    if (!U)
      return;
    Wr(/* @__PURE__ */ new Map([[e, p]]), { x: 0, y: 0, width: W, height: Z }, H, !0).length > 0 || K(p.position.x + O.width / 2, p.position.y + O.height / 2, {
      zoom: H[2]
    });
  };
  return k("div", { className: ce([
    "react-flow__node",
    `react-flow__node-${E}`,
    {
      // this is overwritable by passing `nopan` as a class name
      [h]: A
    },
    p.className,
    {
      selected: p.selected,
      selectable: M,
      parent: _,
      draggable: A,
      dragging: T
    }
  ]), ref: v, style: {
    zIndex: b.z,
    transform: `translate(${b.positionAbsolute.x}px,${b.positionAbsolute.y}px)`,
    pointerEvents: N ? "all" : "none",
    visibility: V ? "visible" : "hidden",
    ...p.style,
    ...I
  }, "data-id": e, "data-testid": `rf__node-${e}`, onMouseEnter: $, onMouseMove: R, onMouseLeave: D, onContextMenu: F, onClick: X, onDoubleClick: Y, onKeyDown: P ? q : void 0, tabIndex: P ? 0 : void 0, onFocus: P ? G : void 0, role: p.ariaRole ?? (P ? "group" : void 0), "aria-roledescription": "node", "aria-describedby": g ? void 0 : `${na}-${y}`, "aria-label": p.ariaLabel, ...p.domAttributes, children: k(Qg, { value: e, children: k(C, { id: e, data: p.data, type: E, positionAbsoluteX: b.positionAbsolute.x, positionAbsoluteY: b.positionAbsolute.y, selected: p.selected ?? !1, selectable: M, draggable: A, deletable: p.deletable ?? !0, isConnectable: z, sourcePosition: p.sourcePosition, targetPosition: p.targetPosition, dragging: T, dragHandle: p.dragHandle, zIndex: b.z, parentId: p.parentId, ...O }) }) });
}
var yp = ae(mp);
const wp = (e) => ({
  nodesDraggable: e.nodesDraggable,
  nodesConnectable: e.nodesConnectable,
  nodesFocusable: e.nodesFocusable,
  elementsSelectable: e.elementsSelectable,
  onError: e.onError
});
function fa(e) {
  const { nodesDraggable: t, nodesConnectable: n, nodesFocusable: r, elementsSelectable: o, onError: i } = Q(wp, ie), s = fp(e.onlyRenderVisibleElements), a = gp();
  return k("div", { className: "react-flow__nodes", style: Xn, children: s.map((c) => (
    /*
     * The split of responsibilities between NodeRenderer and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For example, when you’re dragging a single node, that node gets
     * updated multiple times per second. If `NodeRenderer` were to update
     * every time, it would have to re-run the `nodes.map()` loop every
     * time. This gets pricey with hundreds of nodes, especially if every
     * loop cycle does more than just rendering a JSX element!
     *
     * As a result of this choice, we took the following implementation
     * decisions:
     * - NodeRenderer subscribes *only* to node IDs – and therefore
     *   rerender *only* when visible nodes are added or removed.
     * - NodeRenderer performs all operations the result of which can be
     *   shared between nodes (such as creating the `ResizeObserver`
     *   instance, or subscribing to `selector`). This means extra prop
     *   drilling into `NodeComponentWrapper`, but it means we need to run
     *   these operations only once – instead of once per node.
     * - Any operations that you’d normally write inside `nodes.map` are
     *   moved into `NodeComponentWrapper`. This ensures they are
     *   memorized – so if `NodeRenderer` *has* to rerender, it only
     *   needs to regenerate the list of nodes, nothing else.
     */
    k(yp, { id: c, nodeTypes: e.nodeTypes, nodeExtent: e.nodeExtent, onClick: e.onNodeClick, onMouseEnter: e.onNodeMouseEnter, onMouseMove: e.onNodeMouseMove, onMouseLeave: e.onNodeMouseLeave, onContextMenu: e.onNodeContextMenu, onDoubleClick: e.onNodeDoubleClick, noDragClassName: e.noDragClassName, noPanClassName: e.noPanClassName, rfId: e.rfId, disableKeyboardA11y: e.disableKeyboardA11y, resizeObserver: a, nodesDraggable: t, nodesConnectable: n, nodesFocusable: r, elementsSelectable: o, nodeClickDistance: e.nodeClickDistance, onError: i }, c)
  )) });
}
fa.displayName = "NodeRenderer";
const bp = ae(fa);
function xp(e) {
  return Q(me((n) => {
    if (!e)
      return n.edges.map((o) => o.id);
    const r = [];
    if (n.width && n.height)
      for (const o of n.edges) {
        const i = n.nodeLookup.get(o.source), s = n.nodeLookup.get(o.target);
        i && s && mh({
          sourceNode: i,
          targetNode: s,
          width: n.width,
          height: n.height,
          transform: n.transform
        }) && r.push(o.id);
      }
    return r;
  }, [e]), ie);
}
const vp = ({ color: e = "none", strokeWidth: t = 1 }) => {
  const n = {
    strokeWidth: t,
    ...e && { stroke: e }
  };
  return k("polyline", { className: "arrow", style: n, strokeLinecap: "round", fill: "none", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4" });
}, Ep = ({ color: e = "none", strokeWidth: t = 1 }) => {
  const n = {
    strokeWidth: t,
    ...e && { stroke: e, fill: e }
  };
  return k("polyline", { className: "arrowclosed", style: n, strokeLinecap: "round", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4 -5,-4" });
}, mi = {
  [En.Arrow]: vp,
  [En.ArrowClosed]: Ep
};
function _p(e) {
  const t = se();
  return fe(() => {
    var o, i;
    return Object.prototype.hasOwnProperty.call(mi, e) ? mi[e] : ((i = (o = t.getState()).onError) == null || i.call(o, "009", be.error009(e)), null);
  }, [e]);
}
const Sp = ({ id: e, type: t, color: n, width: r = 12.5, height: o = 12.5, markerUnits: i = "strokeWidth", strokeWidth: s, orient: a = "auto-start-reverse" }) => {
  const c = _p(t);
  return c ? k("marker", { className: "react-flow__arrowhead", id: e, markerWidth: `${r}`, markerHeight: `${o}`, viewBox: "-10 -10 20 20", markerUnits: i, orient: a, refX: "0", refY: "0", children: k(c, { color: n, strokeWidth: s }) }) : null;
}, ha = ({ defaultColor: e, rfId: t }) => {
  const n = Q((i) => i.edges), r = Q((i) => i.defaultEdgeOptions), o = fe(() => Sh(n, {
    id: t,
    defaultColor: e,
    defaultMarkerStart: r == null ? void 0 : r.markerStart,
    defaultMarkerEnd: r == null ? void 0 : r.markerEnd
  }), [n, r, t, e]);
  return o.length ? k("svg", { className: "react-flow__marker", "aria-hidden": "true", children: k("defs", { children: o.map((i) => k(Sp, { id: i.id, type: i.type, color: i.color, width: i.width, height: i.height, markerUnits: i.markerUnits, strokeWidth: i.strokeWidth, orient: i.orient }, i.id)) }) }) : null;
};
ha.displayName = "MarkerDefinitions";
var Np = ae(ha);
function ga({ x: e, y: t, label: n, labelStyle: r, labelShowBg: o = !0, labelBgStyle: i, labelBgPadding: s = [2, 4], labelBgBorderRadius: a = 2, children: c, className: l, ...u }) {
  const [d, f] = ye({ x: 1, y: 0, width: 0, height: 0 }), h = ce(["react-flow__edge-textwrapper", l]), g = ne(null);
  return re(() => {
    if (g.current) {
      const y = g.current.getBBox();
      f({
        x: y.x,
        y: y.y,
        width: y.width,
        height: y.height
      });
    }
  }, [n]), n ? J("g", { transform: `translate(${e - d.width / 2} ${t - d.height / 2})`, className: h, visibility: d.width ? "visible" : "hidden", ...u, children: [o && k("rect", { width: d.width + 2 * s[0], x: -s[0], y: -s[1], height: d.height + 2 * s[1], className: "react-flow__edge-textbg", style: i, rx: a, ry: a }), k("text", { className: "react-flow__edge-text", y: d.height / 2, dy: "0.3em", ref: g, style: r, children: n }), c] }) : null;
}
ga.displayName = "EdgeText";
const Cp = ae(ga);
function yt({ path: e, labelX: t, labelY: n, label: r, labelStyle: o, labelShowBg: i, labelBgStyle: s, labelBgPadding: a, labelBgBorderRadius: c, interactionWidth: l = 20, ...u }) {
  return J(ve, { children: [k("path", { ...u, d: e, fill: "none", className: ce(["react-flow__edge-path", u.className]) }), l ? k("path", { d: e, fill: "none", strokeOpacity: 0, strokeWidth: l, className: "react-flow__edge-interaction" }) : null, r && Ne(t) && Ne(n) ? k(Cp, { x: t, y: n, label: r, labelStyle: o, labelShowBg: i, labelBgStyle: s, labelBgPadding: a, labelBgBorderRadius: c }) : null] });
}
function yi({ pos: e, x1: t, y1: n, x2: r, y2: o }) {
  return e === B.Left || e === B.Right ? [0.5 * (t + r), n] : [t, 0.5 * (n + o)];
}
function pa({ sourceX: e, sourceY: t, sourcePosition: n = B.Bottom, targetX: r, targetY: o, targetPosition: i = B.Top }) {
  const [s, a] = yi({
    pos: n,
    x1: e,
    y1: t,
    x2: r,
    y2: o
  }), [c, l] = yi({
    pos: i,
    x1: r,
    y1: o,
    x2: e,
    y2: t
  }), [u, d, f, h] = Vs({
    sourceX: e,
    sourceY: t,
    targetX: r,
    targetY: o,
    sourceControlX: s,
    sourceControlY: a,
    targetControlX: c,
    targetControlY: l
  });
  return [
    `M${e},${t} C${s},${a} ${c},${l} ${r},${o}`,
    u,
    d,
    f,
    h
  ];
}
function ma(e) {
  return ae(({ id: t, sourceX: n, sourceY: r, targetX: o, targetY: i, sourcePosition: s, targetPosition: a, label: c, labelStyle: l, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: g, markerEnd: y, markerStart: w, interactionWidth: m }) => {
    const [x, p, b] = pa({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: o,
      targetY: i,
      targetPosition: a
    }), _ = e.isInternal ? void 0 : t;
    return k(yt, { id: _, path: x, labelX: p, labelY: b, label: c, labelStyle: l, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: g, markerEnd: y, markerStart: w, interactionWidth: m });
  });
}
const kp = ma({ isInternal: !1 }), ya = ma({ isInternal: !0 });
kp.displayName = "SimpleBezierEdge";
ya.displayName = "SimpleBezierEdgeInternal";
function wa(e) {
  return ae(({ id: t, sourceX: n, sourceY: r, targetX: o, targetY: i, label: s, labelStyle: a, labelShowBg: c, labelBgStyle: l, labelBgPadding: u, labelBgBorderRadius: d, style: f, sourcePosition: h = B.Bottom, targetPosition: g = B.Top, markerEnd: y, markerStart: w, pathOptions: m, interactionWidth: x }) => {
    const [p, b, _] = Nn({
      sourceX: n,
      sourceY: r,
      sourcePosition: h,
      targetX: o,
      targetY: i,
      targetPosition: g,
      borderRadius: m == null ? void 0 : m.borderRadius,
      offset: m == null ? void 0 : m.offset,
      stepPosition: m == null ? void 0 : m.stepPosition
    }), E = e.isInternal ? void 0 : t;
    return k(yt, { id: E, path: p, labelX: b, labelY: _, label: s, labelStyle: a, labelShowBg: c, labelBgStyle: l, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: y, markerStart: w, interactionWidth: x });
  });
}
const ba = wa({ isInternal: !1 }), xa = wa({ isInternal: !0 });
ba.displayName = "SmoothStepEdge";
xa.displayName = "SmoothStepEdgeInternal";
function va(e) {
  return ae(({ id: t, ...n }) => {
    var o;
    const r = e.isInternal ? void 0 : t;
    return k(ba, { ...n, id: r, pathOptions: fe(() => {
      var i;
      return { borderRadius: 0, offset: (i = n.pathOptions) == null ? void 0 : i.offset };
    }, [(o = n.pathOptions) == null ? void 0 : o.offset]) });
  });
}
const Mp = va({ isInternal: !1 }), Ea = va({ isInternal: !0 });
Mp.displayName = "StepEdge";
Ea.displayName = "StepEdgeInternal";
function _a(e) {
  return ae(({ id: t, sourceX: n, sourceY: r, targetX: o, targetY: i, label: s, labelStyle: a, labelShowBg: c, labelBgStyle: l, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: h, markerStart: g, interactionWidth: y }) => {
    const [w, m, x] = Bs({ sourceX: n, sourceY: r, targetX: o, targetY: i }), p = e.isInternal ? void 0 : t;
    return k(yt, { id: p, path: w, labelX: m, labelY: x, label: s, labelStyle: a, labelShowBg: c, labelBgStyle: l, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: h, markerStart: g, interactionWidth: y });
  });
}
const Ip = _a({ isInternal: !1 }), Sa = _a({ isInternal: !0 });
Ip.displayName = "StraightEdge";
Sa.displayName = "StraightEdgeInternal";
function Na(e) {
  return ae(({ id: t, sourceX: n, sourceY: r, targetX: o, targetY: i, sourcePosition: s = B.Bottom, targetPosition: a = B.Top, label: c, labelStyle: l, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: g, markerEnd: y, markerStart: w, pathOptions: m, interactionWidth: x }) => {
    const [p, b, _] = qr({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: o,
      targetY: i,
      targetPosition: a,
      curvature: m == null ? void 0 : m.curvature
    }), E = e.isInternal ? void 0 : t;
    return k(yt, { id: E, path: p, labelX: b, labelY: _, label: c, labelStyle: l, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: g, markerEnd: y, markerStart: w, interactionWidth: x });
  });
}
const Pp = Na({ isInternal: !1 }), Ca = Na({ isInternal: !0 });
Pp.displayName = "BezierEdge";
Ca.displayName = "BezierEdgeInternal";
const wi = {
  default: Ca,
  straight: Sa,
  step: Ea,
  smoothstep: xa,
  simplebezier: ya
}, bi = {
  sourceX: null,
  sourceY: null,
  targetX: null,
  targetY: null,
  sourcePosition: null,
  targetPosition: null
}, Ap = (e, t, n) => n === B.Left ? e - t : n === B.Right ? e + t : e, Tp = (e, t, n) => n === B.Top ? e - t : n === B.Bottom ? e + t : e, xi = "react-flow__edgeupdater";
function vi({ position: e, centerX: t, centerY: n, radius: r = 10, onMouseDown: o, onMouseEnter: i, onMouseOut: s, type: a }) {
  return k("circle", { onMouseDown: o, onMouseEnter: i, onMouseOut: s, className: ce([xi, `${xi}-${a}`]), cx: Ap(t, r, e), cy: Tp(n, r, e), r, stroke: "transparent", fill: "transparent" });
}
function Op({ isReconnectable: e, reconnectRadius: t, edge: n, sourceX: r, sourceY: o, targetX: i, targetY: s, sourcePosition: a, targetPosition: c, onReconnect: l, onReconnectStart: u, onReconnectEnd: d, setReconnecting: f, setUpdateHover: h }) {
  const g = se(), y = (b, _) => {
    if (b.button !== 0)
      return;
    const { autoPanOnConnect: E, domNode: C, connectionMode: A, connectionRadius: M, lib: z, onConnectStart: P, cancelConnection: L, nodeLookup: V, rfId: v, panBy: T, updateConnection: S } = g.getState(), O = _.type === "target", I = (R, D) => {
      f(!1), d == null || d(R, n, _.type, D);
    }, N = (R) => l == null ? void 0 : l(n, R), $ = (R, D) => {
      f(!0), u == null || u(b, n, _.type), P == null || P(R, D);
    };
    Ir.onPointerDown(b.nativeEvent, {
      autoPanOnConnect: E,
      connectionMode: A,
      connectionRadius: M,
      domNode: C,
      handleId: _.id,
      nodeId: _.nodeId,
      nodeLookup: V,
      isTarget: O,
      edgeUpdaterType: _.type,
      lib: z,
      flowId: v,
      cancelConnection: L,
      panBy: T,
      isValidConnection: (...R) => {
        var D, F;
        return ((F = (D = g.getState()).isValidConnection) == null ? void 0 : F.call(D, ...R)) ?? !0;
      },
      onConnect: N,
      onConnectStart: $,
      onConnectEnd: (...R) => {
        var D, F;
        return (F = (D = g.getState()).onConnectEnd) == null ? void 0 : F.call(D, ...R);
      },
      onReconnectEnd: I,
      updateConnection: S,
      getTransform: () => g.getState().transform,
      getFromHandle: () => g.getState().connection.fromHandle,
      dragThreshold: g.getState().connectionDragThreshold,
      handleDomNode: b.currentTarget
    });
  }, w = (b) => y(b, { nodeId: n.target, id: n.targetHandle ?? null, type: "target" }), m = (b) => y(b, { nodeId: n.source, id: n.sourceHandle ?? null, type: "source" }), x = () => h(!0), p = () => h(!1);
  return J(ve, { children: [(e === !0 || e === "source") && k(vi, { position: a, centerX: r, centerY: o, radius: t, onMouseDown: w, onMouseEnter: x, onMouseOut: p, type: "source" }), (e === !0 || e === "target") && k(vi, { position: c, centerX: i, centerY: s, radius: t, onMouseDown: m, onMouseEnter: x, onMouseOut: p, type: "target" })] });
}
function Lp({ id: e, edgesFocusable: t, edgesReconnectable: n, elementsSelectable: r, onClick: o, onDoubleClick: i, onContextMenu: s, onMouseEnter: a, onMouseMove: c, onMouseLeave: l, reconnectRadius: u, onReconnect: d, onReconnectStart: f, onReconnectEnd: h, rfId: g, edgeTypes: y, noPanClassName: w, onError: m, disableKeyboardA11y: x }) {
  let p = Q((K) => K.edgeLookup.get(e));
  const b = Q((K) => K.defaultEdgeOptions);
  p = b ? { ...b, ...p } : p;
  let _ = p.type || "default", E = (y == null ? void 0 : y[_]) || wi[_];
  E === void 0 && (m == null || m("011", be.error011(_)), _ = "default", E = (y == null ? void 0 : y.default) || wi.default);
  const C = !!(p.focusable || t && typeof p.focusable > "u"), A = typeof d < "u" && (p.reconnectable || n && typeof p.reconnectable > "u"), M = !!(p.selectable || r && typeof p.selectable > "u"), z = ne(null), [P, L] = ye(!1), [V, v] = ye(!1), T = se(), { zIndex: S, sourceX: O, sourceY: I, targetX: N, targetY: $, sourcePosition: R, targetPosition: D } = Q(me((K) => {
    const j = K.nodeLookup.get(p.source), te = K.nodeLookup.get(p.target);
    if (!j || !te)
      return {
        zIndex: p.zIndex,
        ...bi
      };
    const oe = _h({
      id: e,
      sourceNode: j,
      targetNode: te,
      sourceHandle: p.sourceHandle || null,
      targetHandle: p.targetHandle || null,
      connectionMode: K.connectionMode,
      onError: m
    });
    return {
      zIndex: ph({
        selected: p.selected,
        zIndex: p.zIndex,
        sourceNode: j,
        targetNode: te,
        elevateOnSelect: K.elevateEdgesOnSelect,
        zIndexMode: K.zIndexMode
      }),
      ...oe || bi
    };
  }, [p.source, p.target, p.sourceHandle, p.targetHandle, p.selected, p.zIndex]), ie), F = fe(() => p.markerStart ? `url('#${kr(p.markerStart, g)}')` : void 0, [p.markerStart, g]), Y = fe(() => p.markerEnd ? `url('#${kr(p.markerEnd, g)}')` : void 0, [p.markerEnd, g]);
  if (p.hidden || O === null || I === null || N === null || $ === null)
    return null;
  const X = (K) => {
    var ee;
    const { addSelectedEdges: j, unselectNodesAndEdges: te, multiSelectionActive: oe } = T.getState();
    M && (T.setState({ nodesSelectionActive: !1 }), p.selected && oe ? (te({ nodes: [], edges: [p] }), (ee = z.current) == null || ee.blur()) : j([e])), o && o(K, p);
  }, q = i ? (K) => {
    i(K, { ...p });
  } : void 0, G = s ? (K) => {
    s(K, { ...p });
  } : void 0, H = a ? (K) => {
    a(K, { ...p });
  } : void 0, W = c ? (K) => {
    c(K, { ...p });
  } : void 0, Z = l ? (K) => {
    l(K, { ...p });
  } : void 0, U = (K) => {
    var j;
    if (!x && Ss.includes(K.key) && M) {
      const { unselectNodesAndEdges: te, addSelectedEdges: oe } = T.getState();
      K.key === "Escape" ? ((j = z.current) == null || j.blur(), te({ edges: [p] })) : oe([e]);
    }
  };
  return k("svg", { style: { zIndex: S }, children: J("g", { className: ce([
    "react-flow__edge",
    `react-flow__edge-${_}`,
    p.className,
    w,
    {
      selected: p.selected,
      animated: p.animated,
      inactive: !M && !o,
      updating: P,
      selectable: M
    }
  ]), onClick: X, onDoubleClick: q, onContextMenu: G, onMouseEnter: H, onMouseMove: W, onMouseLeave: Z, onKeyDown: C ? U : void 0, tabIndex: C ? 0 : void 0, role: p.ariaRole ?? (C ? "group" : "img"), "aria-roledescription": "edge", "data-id": e, "data-testid": `rf__edge-${e}`, "aria-label": p.ariaLabel === null ? void 0 : p.ariaLabel || `Edge from ${p.source} to ${p.target}`, "aria-describedby": C ? `${ra}-${g}` : void 0, ref: z, ...p.domAttributes, children: [!V && k(E, { id: e, source: p.source, target: p.target, type: p.type, selected: p.selected, animated: p.animated, selectable: M, deletable: p.deletable ?? !0, label: p.label, labelStyle: p.labelStyle, labelShowBg: p.labelShowBg, labelBgStyle: p.labelBgStyle, labelBgPadding: p.labelBgPadding, labelBgBorderRadius: p.labelBgBorderRadius, sourceX: O, sourceY: I, targetX: N, targetY: $, sourcePosition: R, targetPosition: D, data: p.data, style: p.style, sourceHandleId: p.sourceHandle, targetHandleId: p.targetHandle, markerStart: F, markerEnd: Y, pathOptions: "pathOptions" in p ? p.pathOptions : void 0, interactionWidth: p.interactionWidth }), A && k(Op, { edge: p, isReconnectable: A, reconnectRadius: u, onReconnect: d, onReconnectStart: f, onReconnectEnd: h, sourceX: O, sourceY: I, targetX: N, targetY: $, sourcePosition: R, targetPosition: D, setUpdateHover: L, setReconnecting: v })] }) });
}
var $p = ae(Lp);
const Dp = (e) => ({
  edgesFocusable: e.edgesFocusable,
  edgesReconnectable: e.edgesReconnectable,
  elementsSelectable: e.elementsSelectable,
  connectionMode: e.connectionMode,
  onError: e.onError
});
function ka({ defaultMarkerColor: e, onlyRenderVisibleElements: t, rfId: n, edgeTypes: r, noPanClassName: o, onReconnect: i, onEdgeContextMenu: s, onEdgeMouseEnter: a, onEdgeMouseMove: c, onEdgeMouseLeave: l, onEdgeClick: u, reconnectRadius: d, onEdgeDoubleClick: f, onReconnectStart: h, onReconnectEnd: g, disableKeyboardA11y: y }) {
  const { edgesFocusable: w, edgesReconnectable: m, elementsSelectable: x, onError: p } = Q(Dp, ie), b = xp(t);
  return J("div", { className: "react-flow__edges", children: [k(Np, { defaultColor: e, rfId: n }), b.map((_) => k($p, { id: _, edgesFocusable: w, edgesReconnectable: m, elementsSelectable: x, noPanClassName: o, onReconnect: i, onContextMenu: s, onMouseEnter: a, onMouseMove: c, onMouseLeave: l, onClick: u, reconnectRadius: d, onDoubleClick: f, onReconnectStart: h, onReconnectEnd: g, rfId: n, onError: p, edgeTypes: r, disableKeyboardA11y: y }, _))] });
}
ka.displayName = "EdgeRenderer";
const Rp = ae(ka), zp = (e) => `translate(${e.transform[0]}px,${e.transform[1]}px) scale(${e.transform[2]})`;
function Vp({ children: e }) {
  const t = Q(zp);
  return k("div", { className: "react-flow__viewport xyflow__viewport react-flow__container", style: { transform: t }, children: e });
}
function Hp(e) {
  const t = Yn(), n = ne(!1);
  re(() => {
    !n.current && t.viewportInitialized && e && (setTimeout(() => e(t), 1), n.current = !0);
  }, [e, t.viewportInitialized]);
}
const Bp = (e) => {
  var t;
  return (t = e.panZoom) == null ? void 0 : t.syncViewport;
};
function Fp(e) {
  const t = Q(Bp), n = se();
  return re(() => {
    e && (t == null || t(e), n.setState({ transform: [e.x, e.y, e.zoom] }));
  }, [e, t]), null;
}
function Yp(e) {
  return e.connection.inProgress ? { ...e.connection, to: qt(e.connection.to, e.transform) } : { ...e.connection };
}
function Xp(e) {
  return Yp;
}
function Wp(e) {
  const t = Xp();
  return Q(t, ie);
}
const Gp = (e) => ({
  nodesConnectable: e.nodesConnectable,
  isValid: e.connection.isValid,
  inProgress: e.connection.inProgress,
  width: e.width,
  height: e.height
});
function jp({ containerStyle: e, style: t, type: n, component: r }) {
  const { nodesConnectable: o, width: i, height: s, isValid: a, inProgress: c } = Q(Gp, ie);
  return !(i && o && c) ? null : k("svg", { style: e, width: i, height: s, className: "react-flow__connectionline react-flow__container", children: k("g", { className: ce(["react-flow__connection", ks(a)]), children: k(Ma, { style: t, type: n, CustomComponent: r, isValid: a }) }) });
}
const Ma = ({ style: e, type: t = Be.Bezier, CustomComponent: n, isValid: r }) => {
  const { inProgress: o, from: i, fromNode: s, fromHandle: a, fromPosition: c, to: l, toNode: u, toHandle: d, toPosition: f, pointer: h } = Wp();
  if (!o)
    return;
  if (n)
    return k(n, { connectionLineType: t, connectionLineStyle: e, fromNode: s, fromHandle: a, fromX: i.x, fromY: i.y, toX: l.x, toY: l.y, fromPosition: c, toPosition: f, connectionStatus: ks(r), toNode: u, toHandle: d, pointer: h });
  let g = "";
  const y = {
    sourceX: i.x,
    sourceY: i.y,
    sourcePosition: c,
    targetX: l.x,
    targetY: l.y,
    targetPosition: f
  };
  switch (t) {
    case Be.Bezier:
      [g] = qr(y);
      break;
    case Be.SimpleBezier:
      [g] = pa(y);
      break;
    case Be.Step:
      [g] = Nn({
        ...y,
        borderRadius: 0
      });
      break;
    case Be.SmoothStep:
      [g] = Nn(y);
      break;
    default:
      [g] = Bs(y);
  }
  return k("path", { d: g, fill: "none", className: "react-flow__connection-path", style: e });
};
Ma.displayName = "ConnectionLine";
const qp = {};
function Ei(e = qp) {
  const t = ne(e), n = se();
  re(() => {
    var r, o;
    if (process.env.NODE_ENV === "development") {
      const i = /* @__PURE__ */ new Set([...Object.keys(t.current), ...Object.keys(e)]);
      for (const s of i)
        if (t.current[s] !== e[s]) {
          (o = (r = n.getState()).onError) == null || o.call(r, "002", be.error002());
          break;
        }
      t.current = e;
    }
  }, [e]);
}
function Kp() {
  const e = se(), t = ne(!1);
  re(() => {
    var n, r;
    if (process.env.NODE_ENV === "development" && !t.current) {
      const o = document.querySelector(".react-flow__pane");
      o && window.getComputedStyle(o).zIndex !== "1" && ((r = (n = e.getState()).onError) == null || r.call(n, "013", be.error013("react"))), t.current = !0;
    }
  }, []);
}
function Ia({ nodeTypes: e, edgeTypes: t, onInit: n, onNodeClick: r, onEdgeClick: o, onNodeDoubleClick: i, onEdgeDoubleClick: s, onNodeMouseEnter: a, onNodeMouseMove: c, onNodeMouseLeave: l, onNodeContextMenu: u, onSelectionContextMenu: d, onSelectionStart: f, onSelectionEnd: h, connectionLineType: g, connectionLineStyle: y, connectionLineComponent: w, connectionLineContainerStyle: m, selectionKeyCode: x, selectionOnDrag: p, selectionMode: b, multiSelectionKeyCode: _, panActivationKeyCode: E, zoomActivationKeyCode: C, deleteKeyCode: A, onlyRenderVisibleElements: M, elementsSelectable: z, defaultViewport: P, translateExtent: L, minZoom: V, maxZoom: v, preventScrolling: T, defaultMarkerColor: S, zoomOnScroll: O, zoomOnPinch: I, panOnScroll: N, panOnScrollSpeed: $, panOnScrollMode: R, zoomOnDoubleClick: D, panOnDrag: F, onPaneClick: Y, onPaneMouseEnter: X, onPaneMouseMove: q, onPaneMouseLeave: G, onPaneScroll: H, onPaneContextMenu: W, paneClickDistance: Z, nodeClickDistance: U, onEdgeContextMenu: K, onEdgeMouseEnter: j, onEdgeMouseMove: te, onEdgeMouseLeave: oe, reconnectRadius: ee, onReconnect: ue, onReconnectStart: Re, onReconnectEnd: Te, noDragClassName: Xe, noWheelClassName: bt, noPanClassName: xt, disableKeyboardA11y: vt, nodeExtent: Kn, rfId: Ut, viewport: et, onViewportChange: Et }) {
  return Ei(e), Ei(t), Kp(), Hp(n), Fp(et), k(up, { onPaneClick: Y, onPaneMouseEnter: X, onPaneMouseMove: q, onPaneMouseLeave: G, onPaneContextMenu: W, onPaneScroll: H, paneClickDistance: Z, deleteKeyCode: A, selectionKeyCode: x, selectionOnDrag: p, selectionMode: b, onSelectionStart: f, onSelectionEnd: h, multiSelectionKeyCode: _, panActivationKeyCode: E, zoomActivationKeyCode: C, elementsSelectable: z, zoomOnScroll: O, zoomOnPinch: I, zoomOnDoubleClick: D, panOnScroll: N, panOnScrollSpeed: $, panOnScrollMode: R, panOnDrag: F, defaultViewport: P, translateExtent: L, minZoom: V, maxZoom: v, onSelectionContextMenu: d, preventScrolling: T, noDragClassName: Xe, noWheelClassName: bt, noPanClassName: xt, disableKeyboardA11y: vt, onViewportChange: Et, isControlledViewport: !!et, children: J(Vp, { children: [k(Rp, { edgeTypes: t, onEdgeClick: o, onEdgeDoubleClick: s, onReconnect: ue, onReconnectStart: Re, onReconnectEnd: Te, onlyRenderVisibleElements: M, onEdgeContextMenu: K, onEdgeMouseEnter: j, onEdgeMouseMove: te, onEdgeMouseLeave: oe, reconnectRadius: ee, defaultMarkerColor: S, noPanClassName: xt, disableKeyboardA11y: vt, rfId: Ut }), k(jp, { style: y, type: g, component: w, containerStyle: m }), k("div", { className: "react-flow__edgelabel-renderer" }), k(bp, { nodeTypes: e, onNodeClick: r, onNodeDoubleClick: i, onNodeMouseEnter: a, onNodeMouseMove: c, onNodeMouseLeave: l, onNodeContextMenu: u, nodeClickDistance: U, onlyRenderVisibleElements: M, noPanClassName: xt, noDragClassName: Xe, disableKeyboardA11y: vt, nodeExtent: Kn, rfId: Ut }), k("div", { className: "react-flow__viewport-portal" })] }) });
}
Ia.displayName = "GraphView";
const Up = ae(Ia), _i = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: o, height: i, fitView: s, fitViewOptions: a, minZoom: c = 0.5, maxZoom: l = 2, nodeOrigin: u, nodeExtent: d, zIndexMode: f = "basic" } = {}) => {
  const h = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), m = r ?? t ?? [], x = n ?? e ?? [], p = u ?? [0, 0], b = d ?? $t;
  Xs(y, w, m);
  const { nodesInitialized: _ } = Mr(x, h, g, {
    nodeOrigin: p,
    nodeExtent: b,
    zIndexMode: f
  });
  let E = [0, 0, 1];
  if (s && o && i) {
    const C = Gt(h, {
      filter: (P) => !!((P.width || P.initialWidth) && (P.height || P.initialHeight))
    }), { x: A, y: M, zoom: z } = Gr(C, o, i, c, l, (a == null ? void 0 : a.padding) ?? 0.1);
    E = [A, M, z];
  }
  return {
    rfId: "1",
    width: o ?? 0,
    height: i ?? 0,
    transform: E,
    nodes: x,
    nodesInitialized: _,
    nodeLookup: h,
    parentLookup: g,
    edges: m,
    edgeLookup: w,
    connectionLookup: y,
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: n !== void 0,
    hasDefaultEdges: r !== void 0,
    panZoom: null,
    minZoom: c,
    maxZoom: l,
    translateExtent: $t,
    nodeExtent: b,
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    connectionMode: dt.Strict,
    domNode: null,
    paneDragging: !1,
    noPanClassName: "nopan",
    nodeOrigin: p,
    nodeDragThreshold: 1,
    connectionDragThreshold: 1,
    snapGrid: [15, 15],
    snapToGrid: !1,
    nodesDraggable: !0,
    nodesConnectable: !0,
    nodesFocusable: !0,
    edgesFocusable: !0,
    edgesReconnectable: !0,
    elementsSelectable: !0,
    elevateNodesOnSelect: !0,
    elevateEdgesOnSelect: !0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    fitViewQueued: s ?? !1,
    fitViewOptions: a,
    fitViewResolver: null,
    connection: { ...Cs },
    connectionClickStartHandle: null,
    connectOnClick: !0,
    ariaLiveMessage: "",
    autoPanOnConnect: !0,
    autoPanOnNodeDrag: !0,
    autoPanOnNodeFocus: !0,
    autoPanSpeed: 15,
    connectionRadius: 20,
    onError: Os,
    isValidConnection: void 0,
    onSelectionChangeHandlers: [],
    lib: "react",
    debug: !1,
    ariaLabelConfig: Ns,
    zIndexMode: f,
    onNodesChangeMiddlewareMap: /* @__PURE__ */ new Map(),
    onEdgesChangeMiddlewareMap: /* @__PURE__ */ new Map()
  };
}, Zp = ({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, width: o, height: i, fitView: s, fitViewOptions: a, minZoom: c, maxZoom: l, nodeOrigin: u, nodeExtent: d, zIndexMode: f }) => gg((h, g) => {
  async function y() {
    const { nodeLookup: w, panZoom: m, fitViewOptions: x, fitViewResolver: p, width: b, height: _, minZoom: E, maxZoom: C } = g();
    m && (await ch({
      nodes: w,
      width: b,
      height: _,
      panZoom: m,
      minZoom: E,
      maxZoom: C
    }, x), p == null || p.resolve(!0), h({ fitViewResolver: null }));
  }
  return {
    ..._i({
      nodes: e,
      edges: t,
      width: o,
      height: i,
      fitView: s,
      fitViewOptions: a,
      minZoom: c,
      maxZoom: l,
      nodeOrigin: u,
      nodeExtent: d,
      defaultNodes: n,
      defaultEdges: r,
      zIndexMode: f
    }),
    setNodes: (w) => {
      const { nodeLookup: m, parentLookup: x, nodeOrigin: p, elevateNodesOnSelect: b, fitViewQueued: _, zIndexMode: E, nodesSelectionActive: C } = g(), { nodesInitialized: A, hasSelectedNodes: M } = Mr(w, m, x, {
        nodeOrigin: p,
        nodeExtent: d,
        elevateNodesOnSelect: b,
        checkEquality: !0,
        zIndexMode: E
      }), z = C && M;
      _ && A ? (y(), h({
        nodes: w,
        nodesInitialized: A,
        fitViewQueued: !1,
        fitViewOptions: void 0,
        nodesSelectionActive: z
      })) : h({ nodes: w, nodesInitialized: A, nodesSelectionActive: z });
    },
    setEdges: (w) => {
      const { connectionLookup: m, edgeLookup: x } = g();
      Xs(m, x, w), h({ edges: w });
    },
    setDefaultNodesAndEdges: (w, m) => {
      if (w) {
        const { setNodes: x } = g();
        x(w), h({ hasDefaultNodes: !0 });
      }
      if (m) {
        const { setEdges: x } = g();
        x(m), h({ hasDefaultEdges: !0 });
      }
    },
    /*
     * Every node gets registered at a ResizeObserver. Whenever a node
     * changes its dimensions, this function is called to measure the
     * new dimensions and update the nodes.
     */
    updateNodeInternals: (w) => {
      const { triggerNodeChanges: m, nodeLookup: x, parentLookup: p, domNode: b, nodeOrigin: _, nodeExtent: E, debug: C, fitViewQueued: A, zIndexMode: M } = g(), { changes: z, updatedInternals: P } = Ah(w, x, p, b, _, E, M);
      P && (kh(x, p, { nodeOrigin: _, nodeExtent: E, zIndexMode: M }), A ? (y(), h({ fitViewQueued: !1, fitViewOptions: void 0 })) : h({}), (z == null ? void 0 : z.length) > 0 && (C && console.log("React Flow: trigger node changes", z), m == null || m(z)));
    },
    updateNodePositions: (w, m = !1) => {
      const x = [];
      let p = [];
      const { nodeLookup: b, triggerNodeChanges: _, connection: E, updateConnection: C, onNodesChangeMiddlewareMap: A } = g();
      for (const [M, z] of w) {
        const P = b.get(M), L = !!(P != null && P.expandParent && (P != null && P.parentId) && (z != null && z.position)), V = {
          id: M,
          type: "position",
          position: L ? {
            x: Math.max(0, z.position.x),
            y: Math.max(0, z.position.y)
          } : z.position,
          dragging: m
        };
        if (P && E.inProgress && E.fromNode.id === P.id) {
          const v = Qe(P, E.fromHandle, B.Left, !0);
          C({ ...E, from: v });
        }
        L && P.parentId && x.push({
          id: M,
          parentId: P.parentId,
          rect: {
            ...z.internals.positionAbsolute,
            width: z.measured.width ?? 0,
            height: z.measured.height ?? 0
          }
        }), p.push(V);
      }
      if (x.length > 0) {
        const { parentLookup: M, nodeOrigin: z } = g(), P = Jr(x, b, M, z);
        p.push(...P);
      }
      for (const M of A.values())
        p = M(p);
      _(p);
    },
    triggerNodeChanges: (w) => {
      const { onNodesChange: m, setNodes: x, nodes: p, hasDefaultNodes: b, debug: _ } = g();
      if (w != null && w.length) {
        if (b) {
          const E = $g(w, p);
          x(E);
        }
        _ && console.log("React Flow: trigger node changes", w), m == null || m(w);
      }
    },
    triggerEdgeChanges: (w) => {
      const { onEdgesChange: m, setEdges: x, edges: p, hasDefaultEdges: b, debug: _ } = g();
      if (w != null && w.length) {
        if (b) {
          const E = Dg(w, p);
          x(E);
        }
        _ && console.log("React Flow: trigger edge changes", w), m == null || m(w);
      }
    },
    addSelectedNodes: (w) => {
      const { multiSelectionActive: m, edgeLookup: x, nodeLookup: p, triggerNodeChanges: b, triggerEdgeChanges: _ } = g();
      if (m) {
        const E = w.map((C) => We(C, !0));
        b(E);
        return;
      }
      b(st(p, /* @__PURE__ */ new Set([...w]), !0)), _(st(x));
    },
    addSelectedEdges: (w) => {
      const { multiSelectionActive: m, edgeLookup: x, nodeLookup: p, triggerNodeChanges: b, triggerEdgeChanges: _ } = g();
      if (m) {
        const E = w.map((C) => We(C, !0));
        _(E);
        return;
      }
      _(st(x, /* @__PURE__ */ new Set([...w]))), b(st(p, /* @__PURE__ */ new Set(), !0));
    },
    unselectNodesAndEdges: ({ nodes: w, edges: m } = {}) => {
      const { edges: x, nodes: p, nodeLookup: b, triggerNodeChanges: _, triggerEdgeChanges: E } = g(), C = w || p, A = m || x, M = [];
      for (const P of C) {
        if (!P.selected)
          continue;
        const L = b.get(P.id);
        L && (L.selected = !1), M.push(We(P.id, !1));
      }
      const z = [];
      for (const P of A)
        P.selected && z.push(We(P.id, !1));
      _(M), E(z);
    },
    setMinZoom: (w) => {
      const { panZoom: m, maxZoom: x } = g();
      m == null || m.setScaleExtent([w, x]), h({ minZoom: w });
    },
    setMaxZoom: (w) => {
      const { panZoom: m, minZoom: x } = g();
      m == null || m.setScaleExtent([x, w]), h({ maxZoom: w });
    },
    setTranslateExtent: (w) => {
      var m;
      (m = g().panZoom) == null || m.setTranslateExtent(w), h({ translateExtent: w });
    },
    resetSelectedElements: () => {
      const { edges: w, nodes: m, triggerNodeChanges: x, triggerEdgeChanges: p, elementsSelectable: b } = g();
      if (!b)
        return;
      const _ = m.reduce((C, A) => A.selected ? [...C, We(A.id, !1)] : C, []), E = w.reduce((C, A) => A.selected ? [...C, We(A.id, !1)] : C, []);
      x(_), p(E);
    },
    setNodeExtent: (w) => {
      const { nodes: m, nodeLookup: x, parentLookup: p, nodeOrigin: b, elevateNodesOnSelect: _, nodeExtent: E, zIndexMode: C } = g();
      w[0][0] === E[0][0] && w[0][1] === E[0][1] && w[1][0] === E[1][0] && w[1][1] === E[1][1] || (Mr(m, x, p, {
        nodeOrigin: b,
        nodeExtent: w,
        elevateNodesOnSelect: _,
        checkEquality: !1,
        zIndexMode: C
      }), h({ nodeExtent: w }));
    },
    panBy: (w) => {
      const { transform: m, width: x, height: p, panZoom: b, translateExtent: _ } = g();
      return Th({ delta: w, panZoom: b, transform: m, translateExtent: _, width: x, height: p });
    },
    setCenter: async (w, m, x) => {
      const { width: p, height: b, maxZoom: _, panZoom: E } = g();
      if (!E)
        return Promise.resolve(!1);
      const C = typeof (x == null ? void 0 : x.zoom) < "u" ? x.zoom : _;
      return await E.setViewport({
        x: p / 2 - w * C,
        y: b / 2 - m * C,
        zoom: C
      }, { duration: x == null ? void 0 : x.duration, ease: x == null ? void 0 : x.ease, interpolate: x == null ? void 0 : x.interpolate }), Promise.resolve(!0);
    },
    cancelConnection: () => {
      h({
        connection: { ...Cs }
      });
    },
    updateConnection: (w) => {
      h({ connection: w });
    },
    reset: () => h({ ..._i() })
  };
}, Object.is);
function Pa({ initialNodes: e, initialEdges: t, defaultNodes: n, defaultEdges: r, initialWidth: o, initialHeight: i, initialMinZoom: s, initialMaxZoom: a, initialFitViewOptions: c, fitView: l, nodeOrigin: u, nodeExtent: d, zIndexMode: f, children: h }) {
  const [g] = ye(() => Zp({
    nodes: e,
    edges: t,
    defaultNodes: n,
    defaultEdges: r,
    width: o,
    height: i,
    fitView: l,
    minZoom: s,
    maxZoom: a,
    fitViewOptions: c,
    nodeOrigin: u,
    nodeExtent: d,
    zIndexMode: f
  }));
  return k(pg, { value: g, children: k(Vg, { children: h }) });
}
function Qp({ children: e, nodes: t, edges: n, defaultNodes: r, defaultEdges: o, width: i, height: s, fitView: a, fitViewOptions: c, minZoom: l, maxZoom: u, nodeOrigin: d, nodeExtent: f, zIndexMode: h }) {
  return Ft(Bn) ? k(ve, { children: e }) : k(Pa, { initialNodes: t, initialEdges: n, defaultNodes: r, defaultEdges: o, initialWidth: i, initialHeight: s, fitView: a, initialFitViewOptions: c, initialMinZoom: l, initialMaxZoom: u, nodeOrigin: d, nodeExtent: f, zIndexMode: h, children: e });
}
const Jp = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  zIndex: 0
};
function em({ nodes: e, edges: t, defaultNodes: n, defaultEdges: r, className: o, nodeTypes: i, edgeTypes: s, onNodeClick: a, onEdgeClick: c, onInit: l, onMove: u, onMoveStart: d, onMoveEnd: f, onConnect: h, onConnectStart: g, onConnectEnd: y, onClickConnectStart: w, onClickConnectEnd: m, onNodeMouseEnter: x, onNodeMouseMove: p, onNodeMouseLeave: b, onNodeContextMenu: _, onNodeDoubleClick: E, onNodeDragStart: C, onNodeDrag: A, onNodeDragStop: M, onNodesDelete: z, onEdgesDelete: P, onDelete: L, onSelectionChange: V, onSelectionDragStart: v, onSelectionDrag: T, onSelectionDragStop: S, onSelectionContextMenu: O, onSelectionStart: I, onSelectionEnd: N, onBeforeDelete: $, connectionMode: R, connectionLineType: D = Be.Bezier, connectionLineStyle: F, connectionLineComponent: Y, connectionLineContainerStyle: X, deleteKeyCode: q = "Backspace", selectionKeyCode: G = "Shift", selectionOnDrag: H = !1, selectionMode: W = Dt.Full, panActivationKeyCode: Z = "Space", multiSelectionKeyCode: U = zt() ? "Meta" : "Control", zoomActivationKeyCode: K = zt() ? "Meta" : "Control", snapToGrid: j, snapGrid: te, onlyRenderVisibleElements: oe = !1, selectNodesOnDrag: ee, nodesDraggable: ue, autoPanOnNodeFocus: Re, nodesConnectable: Te, nodesFocusable: Xe, nodeOrigin: bt = oa, edgesFocusable: xt, edgesReconnectable: vt, elementsSelectable: Kn = !0, defaultViewport: Ut = Mg, minZoom: et = 0.5, maxZoom: Et = 2, translateExtent: co = $t, preventScrolling: yc = !0, nodeExtent: Un, defaultMarkerColor: wc = "#b1b1b7", zoomOnScroll: bc = !0, zoomOnPinch: xc = !0, panOnScroll: vc = !1, panOnScrollSpeed: Ec = 0.5, panOnScrollMode: _c = qe.Free, zoomOnDoubleClick: Sc = !0, panOnDrag: Nc = !0, onPaneClick: Cc, onPaneMouseEnter: kc, onPaneMouseMove: Mc, onPaneMouseLeave: Ic, onPaneScroll: Pc, onPaneContextMenu: Ac, paneClickDistance: Tc = 1, nodeClickDistance: Oc = 0, children: Lc, onReconnect: $c, onReconnectStart: Dc, onReconnectEnd: Rc, onEdgeContextMenu: zc, onEdgeDoubleClick: Vc, onEdgeMouseEnter: Hc, onEdgeMouseMove: Bc, onEdgeMouseLeave: Fc, reconnectRadius: Yc = 10, onNodesChange: Xc, onEdgesChange: Wc, noDragClassName: Gc = "nodrag", noWheelClassName: jc = "nowheel", noPanClassName: lo = "nopan", fitView: uo, fitViewOptions: fo, connectOnClick: qc, attributionPosition: Kc, proOptions: Uc, defaultEdgeOptions: Zc, elevateNodesOnSelect: Qc = !0, elevateEdgesOnSelect: Jc = !1, disableKeyboardA11y: ho = !1, autoPanOnConnect: el, autoPanOnNodeDrag: tl, autoPanSpeed: nl, connectionRadius: rl, isValidConnection: ol, onError: il, style: sl, id: go, nodeDragThreshold: al, connectionDragThreshold: cl, viewport: ll, onViewportChange: ul, width: dl, height: fl, colorMode: hl = "light", debug: gl, onScroll: Zt, ariaLabelConfig: pl, zIndexMode: po = "basic", ...ml }, yl) {
  const Zn = go || "1", wl = Tg(hl), bl = me((mo) => {
    mo.currentTarget.scrollTo({ top: 0, left: 0, behavior: "instant" }), Zt == null || Zt(mo);
  }, [Zt]);
  return k("div", { "data-testid": "rf__wrapper", ...ml, onScroll: bl, style: { ...sl, ...Jp }, ref: yl, className: ce(["react-flow", o, wl]), id: go, role: "application", children: J(Qp, { nodes: e, edges: t, width: dl, height: fl, fitView: uo, fitViewOptions: fo, minZoom: et, maxZoom: Et, nodeOrigin: bt, nodeExtent: Un, zIndexMode: po, children: [k(Ag, { nodes: e, edges: t, defaultNodes: n, defaultEdges: r, onConnect: h, onConnectStart: g, onConnectEnd: y, onClickConnectStart: w, onClickConnectEnd: m, nodesDraggable: ue, autoPanOnNodeFocus: Re, nodesConnectable: Te, nodesFocusable: Xe, edgesFocusable: xt, edgesReconnectable: vt, elementsSelectable: Kn, elevateNodesOnSelect: Qc, elevateEdgesOnSelect: Jc, minZoom: et, maxZoom: Et, nodeExtent: Un, onNodesChange: Xc, onEdgesChange: Wc, snapToGrid: j, snapGrid: te, connectionMode: R, translateExtent: co, connectOnClick: qc, defaultEdgeOptions: Zc, fitView: uo, fitViewOptions: fo, onNodesDelete: z, onEdgesDelete: P, onDelete: L, onNodeDragStart: C, onNodeDrag: A, onNodeDragStop: M, onSelectionDrag: T, onSelectionDragStart: v, onSelectionDragStop: S, onMove: u, onMoveStart: d, onMoveEnd: f, noPanClassName: lo, nodeOrigin: bt, rfId: Zn, autoPanOnConnect: el, autoPanOnNodeDrag: tl, autoPanSpeed: nl, onError: il, connectionRadius: rl, isValidConnection: ol, selectNodesOnDrag: ee, nodeDragThreshold: al, connectionDragThreshold: cl, onBeforeDelete: $, debug: gl, ariaLabelConfig: pl, zIndexMode: po }), k(Up, { onInit: l, onNodeClick: a, onEdgeClick: c, onNodeMouseEnter: x, onNodeMouseMove: p, onNodeMouseLeave: b, onNodeContextMenu: _, onNodeDoubleClick: E, nodeTypes: i, edgeTypes: s, connectionLineType: D, connectionLineStyle: F, connectionLineComponent: Y, connectionLineContainerStyle: X, selectionKeyCode: G, selectionOnDrag: H, selectionMode: W, deleteKeyCode: q, multiSelectionKeyCode: U, panActivationKeyCode: Z, zoomActivationKeyCode: K, onlyRenderVisibleElements: oe, defaultViewport: Ut, translateExtent: co, minZoom: et, maxZoom: Et, preventScrolling: yc, zoomOnScroll: bc, zoomOnPinch: xc, zoomOnDoubleClick: Sc, panOnScroll: vc, panOnScrollSpeed: Ec, panOnScrollMode: _c, panOnDrag: Nc, onPaneClick: Cc, onPaneMouseEnter: kc, onPaneMouseMove: Mc, onPaneMouseLeave: Ic, onPaneScroll: Pc, onPaneContextMenu: Ac, paneClickDistance: Tc, nodeClickDistance: Oc, onSelectionContextMenu: O, onSelectionStart: I, onSelectionEnd: N, onReconnect: $c, onReconnectStart: Dc, onReconnectEnd: Rc, onEdgeContextMenu: zc, onEdgeDoubleClick: Vc, onEdgeMouseEnter: Hc, onEdgeMouseMove: Bc, onEdgeMouseLeave: Fc, reconnectRadius: Yc, defaultMarkerColor: wc, noDragClassName: Gc, noWheelClassName: jc, noPanClassName: lo, rfId: Zn, disableKeyboardA11y: ho, nodeExtent: Un, viewport: ll, onViewportChange: ul }), k(kg, { onSelectionChange: V }), Lc, k(Eg, { proOptions: Uc, position: Kc }), k(vg, { rfId: Zn, disableKeyboardA11y: ho })] }) });
}
var tm = sa(em);
const nm = (e) => {
  var t;
  return (t = e.domNode) == null ? void 0 : t.querySelector(".react-flow__edgelabel-renderer");
};
function rm({ children: e }) {
  const t = Q(nm);
  return t ? El(e, t) : null;
}
function om({ dimensions: e, lineWidth: t, variant: n, className: r }) {
  return k("path", { strokeWidth: t, d: `M${e[0] / 2} 0 V${e[1]} M0 ${e[1] / 2} H${e[0]}`, className: ce(["react-flow__background-pattern", n, r]) });
}
function im({ radius: e, className: t }) {
  return k("circle", { cx: e, cy: e, r: e, className: ce(["react-flow__background-pattern", "dots", t]) });
}
var Fe;
(function(e) {
  e.Lines = "lines", e.Dots = "dots", e.Cross = "cross";
})(Fe || (Fe = {}));
const sm = {
  [Fe.Dots]: 1,
  [Fe.Lines]: 1,
  [Fe.Cross]: 6
}, am = (e) => ({ transform: e.transform, patternId: `pattern-${e.rfId}` });
function Aa({
  id: e,
  variant: t = Fe.Dots,
  // only used for dots and cross
  gap: n = 20,
  // only used for lines and cross
  size: r,
  lineWidth: o = 1,
  offset: i = 0,
  color: s,
  bgColor: a,
  style: c,
  className: l,
  patternClassName: u
}) {
  const d = ne(null), { transform: f, patternId: h } = Q(am, ie), g = r || sm[t], y = t === Fe.Dots, w = t === Fe.Cross, m = Array.isArray(n) ? n : [n, n], x = [m[0] * f[2] || 1, m[1] * f[2] || 1], p = g * f[2], b = Array.isArray(i) ? i : [i, i], _ = w ? [p, p] : x, E = [
    b[0] * f[2] || 1 + _[0] / 2,
    b[1] * f[2] || 1 + _[1] / 2
  ], C = `${h}${e || ""}`;
  return J("svg", { className: ce(["react-flow__background", l]), style: {
    ...c,
    ...Xn,
    "--xy-background-color-props": a,
    "--xy-background-pattern-color-props": s
  }, ref: d, "data-testid": "rf__background", children: [k("pattern", { id: C, x: f[0] % x[0], y: f[1] % x[1], width: x[0], height: x[1], patternUnits: "userSpaceOnUse", patternTransform: `translate(-${E[0]},-${E[1]})`, children: y ? k(im, { radius: p / 2, className: u }) : k(om, { dimensions: _, lineWidth: o, variant: t, className: u }) }), k("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${C})` })] });
}
Aa.displayName = "Background";
const cm = ae(Aa);
function lm() {
  return k("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: k("path", { d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" }) });
}
function um() {
  return k("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 5", children: k("path", { d: "M0 0h32v4.2H0z" }) });
}
function dm() {
  return k("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 30", children: k("path", { d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" }) });
}
function fm() {
  return k("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: k("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z" }) });
}
function hm() {
  return k("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: k("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z" }) });
}
function cn({ children: e, className: t, ...n }) {
  return k("button", { type: "button", className: ce(["react-flow__controls-button", t]), ...n, children: e });
}
const gm = (e) => ({
  isInteractive: e.nodesDraggable || e.nodesConnectable || e.elementsSelectable,
  minZoomReached: e.transform[2] <= e.minZoom,
  maxZoomReached: e.transform[2] >= e.maxZoom,
  ariaLabelConfig: e.ariaLabelConfig
});
function Ta({ style: e, showZoom: t = !0, showFitView: n = !0, showInteractive: r = !0, fitViewOptions: o, onZoomIn: i, onZoomOut: s, onFitView: a, onInteractiveChange: c, className: l, children: u, position: d = "bottom-left", orientation: f = "vertical", "aria-label": h }) {
  const g = se(), { isInteractive: y, minZoomReached: w, maxZoomReached: m, ariaLabelConfig: x } = Q(gm, ie), { zoomIn: p, zoomOut: b, fitView: _ } = Yn(), E = () => {
    p(), i == null || i();
  }, C = () => {
    b(), s == null || s();
  }, A = () => {
    _(o), a == null || a();
  }, M = () => {
    g.setState({
      nodesDraggable: !y,
      nodesConnectable: !y,
      elementsSelectable: !y
    }), c == null || c(!y);
  };
  return J(Fn, { className: ce(["react-flow__controls", f === "horizontal" ? "horizontal" : "vertical", l]), position: d, style: e, "data-testid": "rf__controls", "aria-label": h ?? x["controls.ariaLabel"], children: [t && J(ve, { children: [k(cn, { onClick: E, className: "react-flow__controls-zoomin", title: x["controls.zoomIn.ariaLabel"], "aria-label": x["controls.zoomIn.ariaLabel"], disabled: m, children: k(lm, {}) }), k(cn, { onClick: C, className: "react-flow__controls-zoomout", title: x["controls.zoomOut.ariaLabel"], "aria-label": x["controls.zoomOut.ariaLabel"], disabled: w, children: k(um, {}) })] }), n && k(cn, { className: "react-flow__controls-fitview", onClick: A, title: x["controls.fitView.ariaLabel"], "aria-label": x["controls.fitView.ariaLabel"], children: k(dm, {}) }), r && k(cn, { className: "react-flow__controls-interactive", onClick: M, title: x["controls.interactive.ariaLabel"], "aria-label": x["controls.interactive.ariaLabel"], children: y ? k(hm, {}) : k(fm, {}) }), u] });
}
Ta.displayName = "Controls";
const pm = ae(Ta);
function mm({ id: e, x: t, y: n, width: r, height: o, style: i, color: s, strokeColor: a, strokeWidth: c, className: l, borderRadius: u, shapeRendering: d, selected: f, onClick: h }) {
  const { background: g, backgroundColor: y } = i || {}, w = s || g || y;
  return k("rect", { className: ce(["react-flow__minimap-node", { selected: f }, l]), x: t, y: n, rx: u, ry: u, width: r, height: o, style: {
    fill: w,
    stroke: a,
    strokeWidth: c
  }, shapeRendering: d, onClick: h ? (m) => h(m, e) : void 0 });
}
const ym = ae(mm), wm = (e) => e.nodes.map((t) => t.id), ur = (e) => e instanceof Function ? e : () => e;
function bm({
  nodeStrokeColor: e,
  nodeColor: t,
  nodeClassName: n = "",
  nodeBorderRadius: r = 5,
  nodeStrokeWidth: o,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: i = ym,
  onClick: s
}) {
  const a = Q(wm, ie), c = ur(t), l = ur(e), u = ur(n), d = typeof window > "u" || window.chrome ? "crispEdges" : "geometricPrecision";
  return k(ve, { children: a.map((f) => (
    /*
     * The split of responsibilities between MiniMapNodes and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For more details, see a similar commit in `NodeRenderer/index.tsx`.
     */
    k(vm, { id: f, nodeColorFunc: c, nodeStrokeColorFunc: l, nodeClassNameFunc: u, nodeBorderRadius: r, nodeStrokeWidth: o, NodeComponent: i, onClick: s, shapeRendering: d }, f)
  )) });
}
function xm({ id: e, nodeColorFunc: t, nodeStrokeColorFunc: n, nodeClassNameFunc: r, nodeBorderRadius: o, nodeStrokeWidth: i, shapeRendering: s, NodeComponent: a, onClick: c }) {
  const { node: l, x: u, y: d, width: f, height: h } = Q((g) => {
    const y = g.nodeLookup.get(e);
    if (!y)
      return { node: void 0, x: 0, y: 0, width: 0, height: 0 };
    const w = y.internals.userNode, { x: m, y: x } = y.internals.positionAbsolute, { width: p, height: b } = De(w);
    return {
      node: w,
      x: m,
      y: x,
      width: p,
      height: b
    };
  }, ie);
  return !l || l.hidden || !Ls(l) ? null : k(a, { x: u, y: d, width: f, height: h, style: l.style, selected: !!l.selected, className: r(l), color: t(l), borderRadius: o, strokeColor: n(l), strokeWidth: i, shapeRendering: s, onClick: c, id: l.id });
}
const vm = ae(xm);
var Em = ae(bm);
const _m = 200, Sm = 150, Nm = (e) => !e.hidden, Cm = (e) => {
  const t = {
    x: -e.transform[0] / e.transform[2],
    y: -e.transform[1] / e.transform[2],
    width: e.width / e.transform[2],
    height: e.height / e.transform[2]
  };
  return {
    viewBB: t,
    boundingRect: e.nodeLookup.size > 0 ? Ts(Gt(e.nodeLookup, { filter: Nm }), t) : t,
    rfId: e.rfId,
    panZoom: e.panZoom,
    translateExtent: e.translateExtent,
    flowWidth: e.width,
    flowHeight: e.height,
    ariaLabelConfig: e.ariaLabelConfig
  };
}, km = "react-flow__minimap-desc";
function Oa({
  style: e,
  className: t,
  nodeStrokeColor: n,
  nodeColor: r,
  nodeClassName: o = "",
  nodeBorderRadius: i = 5,
  nodeStrokeWidth: s,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: a,
  bgColor: c,
  maskColor: l,
  maskStrokeColor: u,
  maskStrokeWidth: d,
  position: f = "bottom-right",
  onClick: h,
  onNodeClick: g,
  pannable: y = !1,
  zoomable: w = !1,
  ariaLabel: m,
  inversePan: x,
  zoomStep: p = 1,
  offsetScale: b = 5
}) {
  const _ = se(), E = ne(null), { boundingRect: C, viewBB: A, rfId: M, panZoom: z, translateExtent: P, flowWidth: L, flowHeight: V, ariaLabelConfig: v } = Q(Cm, ie), T = (e == null ? void 0 : e.width) ?? _m, S = (e == null ? void 0 : e.height) ?? Sm, O = C.width / T, I = C.height / S, N = Math.max(O, I), $ = N * T, R = N * S, D = b * N, F = C.x - ($ - C.width) / 2 - D, Y = C.y - (R - C.height) / 2 - D, X = $ + D * 2, q = R + D * 2, G = `${km}-${M}`, H = ne(0), W = ne();
  H.current = N, re(() => {
    if (E.current && z)
      return W.current = Bh({
        domNode: E.current,
        panZoom: z,
        getTransform: () => _.getState().transform,
        getViewScale: () => H.current
      }), () => {
        var j;
        (j = W.current) == null || j.destroy();
      };
  }, [z]), re(() => {
    var j;
    (j = W.current) == null || j.update({
      translateExtent: P,
      width: L,
      height: V,
      inversePan: x,
      pannable: y,
      zoomStep: p,
      zoomable: w
    });
  }, [y, w, x, p, P, L, V]);
  const Z = h ? (j) => {
    var ee;
    const [te, oe] = ((ee = W.current) == null ? void 0 : ee.pointer(j)) || [0, 0];
    h(j, { x: te, y: oe });
  } : void 0, U = g ? me((j, te) => {
    const oe = _.getState().nodeLookup.get(te).internals.userNode;
    g(j, oe);
  }, []) : void 0, K = m ?? v["minimap.ariaLabel"];
  return k(Fn, { position: f, style: {
    ...e,
    "--xy-minimap-background-color-props": typeof c == "string" ? c : void 0,
    "--xy-minimap-mask-background-color-props": typeof l == "string" ? l : void 0,
    "--xy-minimap-mask-stroke-color-props": typeof u == "string" ? u : void 0,
    "--xy-minimap-mask-stroke-width-props": typeof d == "number" ? d * N : void 0,
    "--xy-minimap-node-background-color-props": typeof r == "string" ? r : void 0,
    "--xy-minimap-node-stroke-color-props": typeof n == "string" ? n : void 0,
    "--xy-minimap-node-stroke-width-props": typeof s == "number" ? s : void 0
  }, className: ce(["react-flow__minimap", t]), "data-testid": "rf__minimap", children: J("svg", { width: T, height: S, viewBox: `${F} ${Y} ${X} ${q}`, className: "react-flow__minimap-svg", role: "img", "aria-labelledby": G, ref: E, onClick: Z, children: [K && k("title", { id: G, children: K }), k(Em, { onClick: U, nodeColor: r, nodeStrokeColor: n, nodeBorderRadius: i, nodeClassName: o, nodeStrokeWidth: s, nodeComponent: a }), k("path", { className: "react-flow__minimap-mask", d: `M${F - D},${Y - D}h${X + D * 2}v${q + D * 2}h${-X - D * 2}z
        M${A.x},${A.y}h${A.width}v${A.height}h${-A.width}z`, fillRule: "evenodd", pointerEvents: "none" })] }) });
}
Oa.displayName = "MiniMap";
ae(Oa);
const Mm = (e) => (t) => e ? `${Math.max(1 / t.transform[2], 1)}` : void 0, Im = {
  [pt.Line]: "right",
  [pt.Handle]: "bottom-right"
};
function Pm({ nodeId: e, position: t, variant: n = pt.Handle, className: r, style: o = void 0, children: i, color: s, minWidth: a = 10, minHeight: c = 10, maxWidth: l = Number.MAX_VALUE, maxHeight: u = Number.MAX_VALUE, keepAspectRatio: d = !1, resizeDirection: f, autoScale: h = !0, shouldResize: g, onResizeStart: y, onResize: w, onResizeEnd: m }) {
  const x = ua(), p = typeof e == "string" ? e : x, b = se(), _ = ne(null), E = n === pt.Handle, C = Q(me(Mm(E && h), [E, h]), ie), A = ne(null), M = t ?? Im[n];
  re(() => {
    if (!(!_.current || !p))
      return A.current || (A.current = tg({
        domNode: _.current,
        nodeId: p,
        getStoreItems: () => {
          const { nodeLookup: P, transform: L, snapGrid: V, snapToGrid: v, nodeOrigin: T, domNode: S } = b.getState();
          return {
            nodeLookup: P,
            transform: L,
            snapGrid: V,
            snapToGrid: v,
            nodeOrigin: T,
            paneDomNode: S
          };
        },
        onChange: (P, L) => {
          const { triggerNodeChanges: V, nodeLookup: v, parentLookup: T, nodeOrigin: S } = b.getState(), O = [], I = { x: P.x, y: P.y }, N = v.get(p);
          if (N && N.expandParent && N.parentId) {
            const $ = N.origin ?? S, R = P.width ?? N.measured.width ?? 0, D = P.height ?? N.measured.height ?? 0, F = {
              id: N.id,
              parentId: N.parentId,
              rect: {
                width: R,
                height: D,
                ...$s({
                  x: P.x ?? N.position.x,
                  y: P.y ?? N.position.y
                }, { width: R, height: D }, N.parentId, v, $)
              }
            }, Y = Jr([F], v, T, S);
            O.push(...Y), I.x = P.x ? Math.max($[0] * R, P.x) : void 0, I.y = P.y ? Math.max($[1] * D, P.y) : void 0;
          }
          if (I.x !== void 0 && I.y !== void 0) {
            const $ = {
              id: p,
              type: "position",
              position: { ...I }
            };
            O.push($);
          }
          if (P.width !== void 0 && P.height !== void 0) {
            const R = {
              id: p,
              type: "dimensions",
              resizing: !0,
              setAttributes: f ? f === "horizontal" ? "width" : "height" : !0,
              dimensions: {
                width: P.width,
                height: P.height
              }
            };
            O.push(R);
          }
          for (const $ of L) {
            const R = {
              ...$,
              type: "position"
            };
            O.push(R);
          }
          V(O);
        },
        onEnd: ({ width: P, height: L }) => {
          const V = {
            id: p,
            type: "dimensions",
            resizing: !1,
            dimensions: {
              width: P,
              height: L
            }
          };
          b.getState().triggerNodeChanges([V]);
        }
      })), A.current.update({
        controlPosition: M,
        boundaries: {
          minWidth: a,
          minHeight: c,
          maxWidth: l,
          maxHeight: u
        },
        keepAspectRatio: d,
        resizeDirection: f,
        onResizeStart: y,
        onResize: w,
        onResizeEnd: m,
        shouldResize: g
      }), () => {
        var P;
        (P = A.current) == null || P.destroy();
      };
  }, [
    M,
    a,
    c,
    l,
    u,
    d,
    y,
    w,
    m,
    g
  ]);
  const z = M.split("-");
  return k("div", { className: ce(["react-flow__resize-control", "nodrag", ...z, n, r]), ref: _, style: {
    ...o,
    scale: C,
    ...s && { [E ? "backgroundColor" : "borderColor"]: s }
  }, children: i });
}
ae(Pm);
const kn = {
  frontend: { bg: "#eff6ff", border: "#3b82f6", text: "#1e3a8a" },
  backend: { bg: "#ecfdf5", border: "#10b981", text: "#064e3b" },
  database: { bg: "#f5f3ff", border: "#8b5cf6", text: "#4c1d95" },
  storage: { bg: "#fff7ed", border: "#f97316", text: "#7c2d12" },
  cache: { bg: "#fef2f2", border: "#ef4444", text: "#7f1d1d" },
  queue: { bg: "#fefce8", border: "#eab308", text: "#713f12" },
  ai: { bg: "#fdf4ff", border: "#d946ef", text: "#701a75" },
  external: { bg: "#f1f5f9", border: "#64748b", text: "#0f172a" },
  orchestrator: { bg: "#ecfeff", border: "#06b6d4", text: "#164e63" },
  decision: { bg: "#fff7ed", border: "#f59e0b", text: "#78350f" },
  user: { bg: "#f0fdf4", border: "#22c55e", text: "#14532d" },
  monitoring: { bg: "#f8fafc", border: "#0ea5e9", text: "#0c4a6e" },
  security: { bg: "#fef2f2", border: "#dc2626", text: "#7f1d1d" },
  group: { bg: "#f8fafc", border: "#cbd5e1", text: "#334155" },
  title: { bg: "transparent", border: "transparent", text: "#0f172a" },
  note: { bg: "#fefce8", border: "#eab308", text: "#713f12" },
  marker: { bg: "#fef3c7", border: "#f59e0b", text: "#78350f" },
  divider: { bg: "transparent", border: "#cbd5e1", text: "#64748b" },
  "evidence-code": { bg: "#0f172a", border: "#1e293b", text: "#e2e8f0", accent: "#38bdf8" },
  "evidence-json": { bg: "#0f172a", border: "#1e293b", text: "#e2e8f0", accent: "#22c55e" },
  "evidence-ui": { bg: "#ffffff", border: "#e2e8f0", text: "#0f172a" },
  process: { bg: "#ffffff", border: "#94a3b8", text: "#0f172a" },
  start: { bg: "#dcfce7", border: "#16a34a", text: "#14532d" },
  end: { bg: "#fee2e2", border: "#dc2626", text: "#7f1d1d" },
  io: { bg: "#e0f2fe", border: "#0284c7", text: "#0c4a6e" }
}, He = {
  flow: "#64748b",
  stream: "#06b6d4",
  callback: "#8b5cf6",
  dependency: "#94a3b8",
  comparison: "#0f172a",
  annotated: "#334155",
  rejected: "#dc2626",
  async: "#f59e0b"
};
function xe({ data: e, type: t }) {
  var s;
  const n = kn[t] ?? kn.process, r = {
    background: n.bg,
    borderColor: n.border,
    color: n.text
  }, o = /* @__PURE__ */ J(ve, { children: [
    /* @__PURE__ */ J("div", { className: "pma-node__label", children: [
      e.icon ? /* @__PURE__ */ k("span", { "aria-hidden": !0, children: e.icon }) : null,
      /* @__PURE__ */ k("span", { children: e.label ?? t })
    ] }),
    e.subtitle ? /* @__PURE__ */ k("div", { className: "pma-node__subtitle", children: e.subtitle }) : null,
    (s = e.badges) != null && s.length ? /* @__PURE__ */ k("div", { className: "pma-node__badges", children: e.badges.map((a, c) => /* @__PURE__ */ k("span", { className: "pma-node__badge", children: a }, c)) }) : null
  ] }), i = `pma-node pma-node--${t}${e.dimmed ? " pma-node--dimmed" : ""}`;
  return /* @__PURE__ */ J("div", { className: i, style: r, children: [
    /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in" }),
    e.href ? /* @__PURE__ */ k("a", { href: e.href, target: "_blank", rel: "noreferrer", style: { color: "inherit", textDecoration: "none" }, children: o }) : o,
    /* @__PURE__ */ k(le, { type: "source", position: B.Bottom, id: "out" })
  ] });
}
function Am({ data: e }) {
  const t = kn.decision;
  return /* @__PURE__ */ J(
    "div",
    {
      className: "pma-node pma-node--decision",
      style: { background: t.bg, borderColor: t.border, color: t.text, borderWidth: 1.5, borderStyle: "solid" },
      children: [
        /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in" }),
        /* @__PURE__ */ J("div", { children: [
          /* @__PURE__ */ k("div", { className: "pma-node__label", children: e.label ?? "Decision" }),
          e.subtitle ? /* @__PURE__ */ k("div", { className: "pma-node__subtitle", children: e.subtitle }) : null
        ] }),
        /* @__PURE__ */ k(le, { type: "source", position: B.Left, id: "no" }),
        /* @__PURE__ */ k(le, { type: "source", position: B.Right, id: "yes" })
      ]
    }
  );
}
function Tm({ data: e }) {
  return /* @__PURE__ */ J("div", { className: "pma-node pma-node--group", style: { width: "100%", height: "100%" }, children: [
    e.label ? /* @__PURE__ */ k("div", { className: "pma-node__label", children: e.label }) : null,
    e.subtitle ? /* @__PURE__ */ k("div", { className: "pma-node__subtitle", children: e.subtitle }) : null
  ] });
}
function Om({ data: e }) {
  return /* @__PURE__ */ k("div", { className: "pma-node pma-node--title", children: e.label ?? e.text ?? "" });
}
function Lm({ data: e }) {
  return /* @__PURE__ */ k("div", { className: "pma-node pma-node--note", style: { background: "#fefce8", borderColor: "#eab308", color: "#713f12" }, children: e.text ?? e.label ?? "" });
}
function $m({ data: e }) {
  return /* @__PURE__ */ k("div", { className: "pma-node", style: { background: "#fef3c7", borderColor: "#f59e0b", color: "#78350f", padding: "4px 8px", minWidth: 0 }, children: e.label ?? "•" });
}
function Dm({ data: e }) {
  return /* @__PURE__ */ k("div", { style: { borderTop: "1px dashed #cbd5e1", width: "100%", color: "#64748b", fontSize: 11, paddingTop: 2 }, children: e.label ?? "" });
}
function Rm({ data: e }) {
  const t = e.language ?? "";
  return /* @__PURE__ */ J("div", { className: "pma-node pma-node--evidence-code", style: { background: "#0f172a", borderColor: "#1e293b", color: "#e2e8f0", borderWidth: 1, borderStyle: "solid", borderRadius: 10 }, children: [
    /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in", style: { background: "#38bdf8" } }),
    e.label || t ? /* @__PURE__ */ k("div", { style: { fontSize: 11, color: "#38bdf8", marginBottom: 6 }, children: e.label ?? t }) : null,
    /* @__PURE__ */ k("code", { style: { whiteSpace: "pre-wrap", fontFamily: "inherit" }, children: e.code ?? "" }),
    /* @__PURE__ */ k(le, { type: "source", position: B.Bottom, id: "out", style: { background: "#38bdf8" } })
  ] });
}
function zm({ data: e }) {
  const t = typeof e.json == "string" ? e.json : JSON.stringify(e.json ?? {}, null, 2);
  return /* @__PURE__ */ J("div", { className: "pma-node pma-node--evidence-json", style: { background: "#0f172a", borderColor: "#1e293b", color: "#e2e8f0", borderWidth: 1, borderStyle: "solid", borderRadius: 10 }, children: [
    /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in", style: { background: "#22c55e" } }),
    e.label ? /* @__PURE__ */ k("div", { style: { fontSize: 11, color: "#22c55e", marginBottom: 6 }, children: e.label }) : null,
    /* @__PURE__ */ k("pre", { style: { margin: 0, fontFamily: "inherit" }, children: t }),
    /* @__PURE__ */ k(le, { type: "source", position: B.Bottom, id: "out", style: { background: "#22c55e" } })
  ] });
}
function Vm({ data: e }) {
  return /* @__PURE__ */ J("div", { className: "pma-node", style: { background: "#ffffff", borderColor: "#e2e8f0", color: "#0f172a", padding: 12, maxWidth: 320 }, children: [
    /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in" }),
    e.label ? /* @__PURE__ */ k("div", { className: "pma-node__label", children: e.label }) : null,
    e.subtitle ? /* @__PURE__ */ k("div", { className: "pma-node__subtitle", children: e.subtitle }) : null,
    /* @__PURE__ */ k(le, { type: "source", position: B.Bottom, id: "out" })
  ] });
}
function Wn(e, t, n) {
  const r = kn[e], o = {
    background: r.bg,
    borderColor: r.border,
    color: r.text,
    borderRadius: n === "round" ? 999 : 10
  };
  return /* @__PURE__ */ J("div", { className: `pma-node pma-node--${e}`, style: o, children: [
    /* @__PURE__ */ k(le, { type: "target", position: B.Top, id: "in" }),
    /* @__PURE__ */ k("div", { className: "pma-node__label", children: t.label ?? e }),
    t.subtitle ? /* @__PURE__ */ k("div", { className: "pma-node__subtitle", children: t.subtitle }) : null,
    /* @__PURE__ */ k(le, { type: "source", position: B.Bottom, id: "out" })
  ] });
}
function Hm({ data: e }) {
  return Wn("process", e);
}
function Bm({ data: e }) {
  return Wn("start", e, "round");
}
function Fm({ data: e }) {
  return Wn("end", e, "round");
}
function Ym({ data: e }) {
  return Wn("io", e);
}
const Xm = {
  frontend: xe,
  backend: xe,
  database: xe,
  storage: xe,
  cache: xe,
  queue: xe,
  ai: xe,
  external: xe,
  orchestrator: xe,
  user: xe,
  monitoring: xe,
  security: xe,
  decision: Am,
  group: Tm,
  title: Om,
  note: Lm,
  marker: $m,
  divider: Dm,
  "evidence-code": Rm,
  "evidence-json": zm,
  "evidence-ui": Vm,
  process: Hm,
  start: Bm,
  end: Fm,
  io: Ym
};
function La(e, t, n, r) {
  return e ? /* @__PURE__ */ k(rm, { children: /* @__PURE__ */ k(
    "div",
    {
      style: {
        position: "absolute",
        transform: `translate(-50%, -50%) translate(${t}px, ${n}px)`,
        background: "#ffffff",
        padding: "2px 6px",
        borderRadius: 4,
        fontSize: 11,
        color: r,
        border: `1px solid ${r}33`,
        pointerEvents: "all"
      },
      children: e
    }
  ) }) : null;
}
function nt(e, t = !1, n = !1, r = 1.5) {
  return function(i) {
    const [s, a, c] = Nn({
      sourceX: i.sourceX,
      sourceY: i.sourceY,
      targetX: i.targetX,
      targetY: i.targetY,
      sourcePosition: i.sourcePosition,
      targetPosition: i.targetPosition,
      borderRadius: 8
    });
    return /* @__PURE__ */ J(ve, { children: [
      /* @__PURE__ */ k(
        yt,
        {
          id: i.id,
          path: s,
          style: { stroke: e, strokeWidth: r, strokeDasharray: t ? "6 4" : void 0 },
          className: n ? "animated" : void 0,
          markerEnd: i.markerEnd
        }
      ),
      La(i.label, a, c, e)
    ] });
  };
}
function Si(e, t = !1, n = 1.5) {
  return function(o) {
    const [i, s, a] = qr({
      sourceX: o.sourceX,
      sourceY: o.sourceY,
      targetX: o.targetX,
      targetY: o.targetY,
      sourcePosition: o.sourcePosition,
      targetPosition: o.targetPosition
    });
    return /* @__PURE__ */ J(ve, { children: [
      /* @__PURE__ */ k(
        yt,
        {
          id: o.id,
          path: i,
          style: { stroke: e, strokeWidth: n, strokeDasharray: t ? "4 3" : void 0 },
          markerEnd: o.markerEnd
        }
      ),
      La(o.label, s, a, e)
    ] });
  };
}
const Wm = {
  flow: nt(He.flow, !1, !1, 1.5),
  stream: nt(He.stream, !0, !0, 2),
  callback: Si(He.callback, !0, 1.25),
  dependency: nt(He.dependency, !1, !1, 1),
  comparison: nt(He.comparison, !1, !1, 2),
  annotated: nt(He.annotated, !1, !1, 1.5),
  rejected: nt(He.rejected, !0, !1, 1.5),
  async: Si(He.async, !0, 1.5)
}, Or = "pma-draw/v1";
function vb(e) {
  if (typeof e != "object" || e === null) return !1;
  const t = e;
  return t.schema === Or && t.type === "reactflow" && Array.isArray(t.nodes) && Array.isArray(t.edges);
}
function Ni(e) {
  if (typeof e != "object" || e === null)
    return { ok: !1, error: "Input is not an object" };
  const t = e;
  if (t.schema !== Or)
    return { ok: !1, error: `Expected schema "${Or}", got "${String(t.schema)}"` };
  if (t.type !== "reactflow")
    return { ok: !1, error: `Expected type "reactflow", got "${String(t.type)}"` };
  if (!Array.isArray(t.nodes)) return { ok: !1, error: "nodes[] missing" };
  if (!Array.isArray(t.edges)) return { ok: !1, error: "edges[] missing" };
  const n = /* @__PURE__ */ new Set();
  for (const r of t.nodes) {
    if (!r.id) return { ok: !1, error: "node missing id" };
    if (n.has(r.id)) return { ok: !1, error: `duplicate node id: ${r.id}` };
    n.add(r.id);
  }
  for (const r of t.edges) {
    if (!r.id || !r.source || !r.target) return { ok: !1, error: "edge missing id/source/target" };
    if (!n.has(r.source)) return { ok: !1, error: `edge.source not found: ${r.source}` };
    if (!n.has(r.target)) return { ok: !1, error: `edge.target not found: ${r.target}` };
  }
  return { ok: !0, file: t };
}
function Gm(e, t) {
  if (e.match(/^[a-z]+:\/\//i))
    return e;
  if (e.match(/^\/\//))
    return window.location.protocol + e;
  if (e.match(/^[a-z]+:/i))
    return e;
  const n = document.implementation.createHTMLDocument(), r = n.createElement("base"), o = n.createElement("a");
  return n.head.appendChild(r), n.body.appendChild(o), t && (r.href = t), o.href = e, o.href;
}
const jm = /* @__PURE__ */ (() => {
  let e = 0;
  const t = () => (
    // eslint-disable-next-line no-bitwise
    `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4)
  );
  return () => (e += 1, `u${t()}${e}`);
})();
function Ye(e) {
  const t = [];
  for (let n = 0, r = e.length; n < r; n++)
    t.push(e[n]);
  return t;
}
let rt = null;
function $a(e = {}) {
  return rt || (e.includeStyleProperties ? (rt = e.includeStyleProperties, rt) : (rt = Ye(window.getComputedStyle(document.documentElement)), rt));
}
function Mn(e, t) {
  const r = (e.ownerDocument.defaultView || window).getComputedStyle(e).getPropertyValue(t);
  return r ? parseFloat(r.replace("px", "")) : 0;
}
function qm(e) {
  const t = Mn(e, "border-left-width"), n = Mn(e, "border-right-width");
  return e.clientWidth + t + n;
}
function Km(e) {
  const t = Mn(e, "border-top-width"), n = Mn(e, "border-bottom-width");
  return e.clientHeight + t + n;
}
function Da(e, t = {}) {
  const n = t.width || qm(e), r = t.height || Km(e);
  return { width: n, height: r };
}
function Um() {
  let e, t;
  try {
    t = process;
  } catch {
  }
  const n = t && t.env ? t.env.devicePixelRatio : null;
  return n && (e = parseInt(n, 10), Number.isNaN(e) && (e = 1)), e || window.devicePixelRatio || 1;
}
const ge = 16384;
function Zm(e) {
  (e.width > ge || e.height > ge) && (e.width > ge && e.height > ge ? e.width > e.height ? (e.height *= ge / e.width, e.width = ge) : (e.width *= ge / e.height, e.height = ge) : e.width > ge ? (e.height *= ge / e.width, e.width = ge) : (e.width *= ge / e.height, e.height = ge));
}
function In(e) {
  return new Promise((t, n) => {
    const r = new Image();
    r.onload = () => {
      r.decode().then(() => {
        requestAnimationFrame(() => t(r));
      });
    }, r.onerror = n, r.crossOrigin = "anonymous", r.decoding = "async", r.src = e;
  });
}
async function Qm(e) {
  return Promise.resolve().then(() => new XMLSerializer().serializeToString(e)).then(encodeURIComponent).then((t) => `data:image/svg+xml;charset=utf-8,${t}`);
}
async function Jm(e, t, n) {
  const r = "http://www.w3.org/2000/svg", o = document.createElementNS(r, "svg"), i = document.createElementNS(r, "foreignObject");
  return o.setAttribute("width", `${t}`), o.setAttribute("height", `${n}`), o.setAttribute("viewBox", `0 0 ${t} ${n}`), i.setAttribute("width", "100%"), i.setAttribute("height", "100%"), i.setAttribute("x", "0"), i.setAttribute("y", "0"), i.setAttribute("externalResourcesRequired", "true"), o.appendChild(i), i.appendChild(e), Qm(o);
}
const he = (e, t) => {
  if (e instanceof t)
    return !0;
  const n = Object.getPrototypeOf(e);
  return n === null ? !1 : n.constructor.name === t.name || he(n, t);
};
function e0(e) {
  const t = e.getPropertyValue("content");
  return `${e.cssText} content: '${t.replace(/'|"/g, "")}';`;
}
function t0(e, t) {
  return $a(t).map((n) => {
    const r = e.getPropertyValue(n), o = e.getPropertyPriority(n);
    return `${n}: ${r}${o ? " !important" : ""};`;
  }).join(" ");
}
function n0(e, t, n, r) {
  const o = `.${e}:${t}`, i = n.cssText ? e0(n) : t0(n, r);
  return document.createTextNode(`${o}{${i}}`);
}
function Ci(e, t, n, r) {
  const o = window.getComputedStyle(e, n), i = o.getPropertyValue("content");
  if (i === "" || i === "none")
    return;
  const s = jm();
  try {
    t.className = `${t.className} ${s}`;
  } catch {
    return;
  }
  const a = document.createElement("style");
  a.appendChild(n0(s, n, o, r)), t.appendChild(a);
}
function r0(e, t, n) {
  Ci(e, t, ":before", n), Ci(e, t, ":after", n);
}
const ki = "application/font-woff", Mi = "image/jpeg", o0 = {
  woff: ki,
  woff2: ki,
  ttf: "application/font-truetype",
  eot: "application/vnd.ms-fontobject",
  png: "image/png",
  jpg: Mi,
  jpeg: Mi,
  gif: "image/gif",
  tiff: "image/tiff",
  svg: "image/svg+xml",
  webp: "image/webp"
};
function i0(e) {
  const t = /\.([^./]*?)$/g.exec(e);
  return t ? t[1] : "";
}
function to(e) {
  const t = i0(e).toLowerCase();
  return o0[t] || "";
}
function s0(e) {
  return e.split(/,/)[1];
}
function Lr(e) {
  return e.search(/^(data:)/) !== -1;
}
function a0(e, t) {
  return `data:${t};base64,${e}`;
}
async function Ra(e, t, n) {
  const r = await fetch(e, t);
  if (r.status === 404)
    throw new Error(`Resource "${r.url}" not found`);
  const o = await r.blob();
  return new Promise((i, s) => {
    const a = new FileReader();
    a.onerror = s, a.onloadend = () => {
      try {
        i(n({ res: r, result: a.result }));
      } catch (c) {
        s(c);
      }
    }, a.readAsDataURL(o);
  });
}
const dr = {};
function c0(e, t, n) {
  let r = e.replace(/\?.*/, "");
  return n && (r = e), /ttf|otf|eot|woff2?/i.test(r) && (r = r.replace(/.*\//, "")), t ? `[${t}]${r}` : r;
}
async function no(e, t, n) {
  const r = c0(e, t, n.includeQueryParams);
  if (dr[r] != null)
    return dr[r];
  n.cacheBust && (e += (/\?/.test(e) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
  let o;
  try {
    const i = await Ra(e, n.fetchRequestInit, ({ res: s, result: a }) => (t || (t = s.headers.get("Content-Type") || ""), s0(a)));
    o = a0(i, t);
  } catch (i) {
    o = n.imagePlaceholder || "";
    let s = `Failed to fetch resource: ${e}`;
    i && (s = typeof i == "string" ? i : i.message), s && console.warn(s);
  }
  return dr[r] = o, o;
}
async function l0(e) {
  const t = e.toDataURL();
  return t === "data:," ? e.cloneNode(!1) : In(t);
}
async function u0(e, t) {
  if (e.currentSrc) {
    const i = document.createElement("canvas"), s = i.getContext("2d");
    i.width = e.clientWidth, i.height = e.clientHeight, s == null || s.drawImage(e, 0, 0, i.width, i.height);
    const a = i.toDataURL();
    return In(a);
  }
  const n = e.poster, r = to(n), o = await no(n, r, t);
  return In(o);
}
async function d0(e, t) {
  var n;
  try {
    if (!((n = e == null ? void 0 : e.contentDocument) === null || n === void 0) && n.body)
      return await Gn(e.contentDocument.body, t, !0);
  } catch {
  }
  return e.cloneNode(!1);
}
async function f0(e, t) {
  return he(e, HTMLCanvasElement) ? l0(e) : he(e, HTMLVideoElement) ? u0(e, t) : he(e, HTMLIFrameElement) ? d0(e, t) : e.cloneNode(za(e));
}
const h0 = (e) => e.tagName != null && e.tagName.toUpperCase() === "SLOT", za = (e) => e.tagName != null && e.tagName.toUpperCase() === "SVG";
async function g0(e, t, n) {
  var r, o;
  if (za(t))
    return t;
  let i = [];
  return h0(e) && e.assignedNodes ? i = Ye(e.assignedNodes()) : he(e, HTMLIFrameElement) && (!((r = e.contentDocument) === null || r === void 0) && r.body) ? i = Ye(e.contentDocument.body.childNodes) : i = Ye(((o = e.shadowRoot) !== null && o !== void 0 ? o : e).childNodes), i.length === 0 || he(e, HTMLVideoElement) || await i.reduce((s, a) => s.then(() => Gn(a, n)).then((c) => {
    c && t.appendChild(c);
  }), Promise.resolve()), t;
}
function p0(e, t, n) {
  const r = t.style;
  if (!r)
    return;
  const o = window.getComputedStyle(e);
  o.cssText ? (r.cssText = o.cssText, r.transformOrigin = o.transformOrigin) : $a(n).forEach((i) => {
    let s = o.getPropertyValue(i);
    i === "font-size" && s.endsWith("px") && (s = `${Math.floor(parseFloat(s.substring(0, s.length - 2))) - 0.1}px`), he(e, HTMLIFrameElement) && i === "display" && s === "inline" && (s = "block"), i === "d" && t.getAttribute("d") && (s = `path(${t.getAttribute("d")})`), r.setProperty(i, s, o.getPropertyPriority(i));
  });
}
function m0(e, t) {
  he(e, HTMLTextAreaElement) && (t.innerHTML = e.value), he(e, HTMLInputElement) && t.setAttribute("value", e.value);
}
function y0(e, t) {
  if (he(e, HTMLSelectElement)) {
    const n = t, r = Array.from(n.children).find((o) => e.value === o.getAttribute("value"));
    r && r.setAttribute("selected", "");
  }
}
function w0(e, t, n) {
  return he(t, Element) && (p0(e, t, n), r0(e, t, n), m0(e, t), y0(e, t)), t;
}
async function b0(e, t) {
  const n = e.querySelectorAll ? e.querySelectorAll("use") : [];
  if (n.length === 0)
    return e;
  const r = {};
  for (let i = 0; i < n.length; i++) {
    const a = n[i].getAttribute("xlink:href");
    if (a) {
      const c = e.querySelector(a), l = document.querySelector(a);
      !c && l && !r[a] && (r[a] = await Gn(l, t, !0));
    }
  }
  const o = Object.values(r);
  if (o.length) {
    const i = "http://www.w3.org/1999/xhtml", s = document.createElementNS(i, "svg");
    s.setAttribute("xmlns", i), s.style.position = "absolute", s.style.width = "0", s.style.height = "0", s.style.overflow = "hidden", s.style.display = "none";
    const a = document.createElementNS(i, "defs");
    s.appendChild(a);
    for (let c = 0; c < o.length; c++)
      a.appendChild(o[c]);
    e.appendChild(s);
  }
  return e;
}
async function Gn(e, t, n) {
  return !n && t.filter && !t.filter(e) ? null : Promise.resolve(e).then((r) => f0(r, t)).then((r) => g0(e, r, t)).then((r) => w0(e, r, t)).then((r) => b0(r, t));
}
const Va = /url\((['"]?)([^'"]+?)\1\)/g, x0 = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g, v0 = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function E0(e) {
  const t = e.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${t})(['"]?\\))`, "g");
}
function _0(e) {
  const t = [];
  return e.replace(Va, (n, r, o) => (t.push(o), n)), t.filter((n) => !Lr(n));
}
async function S0(e, t, n, r, o) {
  try {
    const i = n ? Gm(t, n) : t, s = to(t);
    let a;
    return o || (a = await no(i, s, r)), e.replace(E0(t), `$1${a}$3`);
  } catch {
  }
  return e;
}
function N0(e, { preferredFontFormat: t }) {
  return t ? e.replace(v0, (n) => {
    for (; ; ) {
      const [r, , o] = x0.exec(n) || [];
      if (!o)
        return "";
      if (o === t)
        return `src: ${r};`;
    }
  }) : e;
}
function Ha(e) {
  return e.search(Va) !== -1;
}
async function Ba(e, t, n) {
  if (!Ha(e))
    return e;
  const r = N0(e, n);
  return _0(r).reduce((i, s) => i.then((a) => S0(a, s, t, n)), Promise.resolve(r));
}
async function ot(e, t, n) {
  var r;
  const o = (r = t.style) === null || r === void 0 ? void 0 : r.getPropertyValue(e);
  if (o) {
    const i = await Ba(o, null, n);
    return t.style.setProperty(e, i, t.style.getPropertyPriority(e)), !0;
  }
  return !1;
}
async function C0(e, t) {
  await ot("background", e, t) || await ot("background-image", e, t), await ot("mask", e, t) || await ot("-webkit-mask", e, t) || await ot("mask-image", e, t) || await ot("-webkit-mask-image", e, t);
}
async function k0(e, t) {
  const n = he(e, HTMLImageElement);
  if (!(n && !Lr(e.src)) && !(he(e, SVGImageElement) && !Lr(e.href.baseVal)))
    return;
  const r = n ? e.src : e.href.baseVal, o = await no(r, to(r), t);
  await new Promise((i, s) => {
    e.onload = i, e.onerror = t.onImageErrorHandler ? (...c) => {
      try {
        i(t.onImageErrorHandler(...c));
      } catch (l) {
        s(l);
      }
    } : s;
    const a = e;
    a.decode && (a.decode = i), a.loading === "lazy" && (a.loading = "eager"), n ? (e.srcset = "", e.src = o) : e.href.baseVal = o;
  });
}
async function M0(e, t) {
  const r = Ye(e.childNodes).map((o) => Fa(o, t));
  await Promise.all(r).then(() => e);
}
async function Fa(e, t) {
  he(e, Element) && (await C0(e, t), await k0(e, t), await M0(e, t));
}
function I0(e, t) {
  const { style: n } = e;
  t.backgroundColor && (n.backgroundColor = t.backgroundColor), t.width && (n.width = `${t.width}px`), t.height && (n.height = `${t.height}px`);
  const r = t.style;
  return r != null && Object.keys(r).forEach((o) => {
    n[o] = r[o];
  }), e;
}
const Ii = {};
async function Pi(e) {
  let t = Ii[e];
  if (t != null)
    return t;
  const r = await (await fetch(e)).text();
  return t = { url: e, cssText: r }, Ii[e] = t, t;
}
async function Ai(e, t) {
  let n = e.cssText;
  const r = /url\(["']?([^"')]+)["']?\)/g, i = (n.match(/url\([^)]+\)/g) || []).map(async (s) => {
    let a = s.replace(r, "$1");
    return a.startsWith("https://") || (a = new URL(a, e.url).href), Ra(a, t.fetchRequestInit, ({ result: c }) => (n = n.replace(s, `url(${c})`), [s, c]));
  });
  return Promise.all(i).then(() => n);
}
function Ti(e) {
  if (e == null)
    return [];
  const t = [], n = /(\/\*[\s\S]*?\*\/)/gi;
  let r = e.replace(n, "");
  const o = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
  for (; ; ) {
    const c = o.exec(r);
    if (c === null)
      break;
    t.push(c[0]);
  }
  r = r.replace(o, "");
  const i = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, s = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", a = new RegExp(s, "gi");
  for (; ; ) {
    let c = i.exec(r);
    if (c === null) {
      if (c = a.exec(r), c === null)
        break;
      i.lastIndex = a.lastIndex;
    } else
      a.lastIndex = i.lastIndex;
    t.push(c[0]);
  }
  return t;
}
async function P0(e, t) {
  const n = [], r = [];
  return e.forEach((o) => {
    if ("cssRules" in o)
      try {
        Ye(o.cssRules || []).forEach((i, s) => {
          if (i.type === CSSRule.IMPORT_RULE) {
            let a = s + 1;
            const c = i.href, l = Pi(c).then((u) => Ai(u, t)).then((u) => Ti(u).forEach((d) => {
              try {
                o.insertRule(d, d.startsWith("@import") ? a += 1 : o.cssRules.length);
              } catch (f) {
                console.error("Error inserting rule from remote css", {
                  rule: d,
                  error: f
                });
              }
            })).catch((u) => {
              console.error("Error loading remote css", u.toString());
            });
            r.push(l);
          }
        });
      } catch (i) {
        const s = e.find((a) => a.href == null) || document.styleSheets[0];
        o.href != null && r.push(Pi(o.href).then((a) => Ai(a, t)).then((a) => Ti(a).forEach((c) => {
          s.insertRule(c, s.cssRules.length);
        })).catch((a) => {
          console.error("Error loading remote stylesheet", a);
        })), console.error("Error inlining remote css file", i);
      }
  }), Promise.all(r).then(() => (e.forEach((o) => {
    if ("cssRules" in o)
      try {
        Ye(o.cssRules || []).forEach((i) => {
          n.push(i);
        });
      } catch (i) {
        console.error(`Error while reading CSS rules from ${o.href}`, i);
      }
  }), n));
}
function A0(e) {
  return e.filter((t) => t.type === CSSRule.FONT_FACE_RULE).filter((t) => Ha(t.style.getPropertyValue("src")));
}
async function T0(e, t) {
  if (e.ownerDocument == null)
    throw new Error("Provided element is not within a Document");
  const n = Ye(e.ownerDocument.styleSheets), r = await P0(n, t);
  return A0(r);
}
function Ya(e) {
  return e.trim().replace(/["']/g, "");
}
function O0(e) {
  const t = /* @__PURE__ */ new Set();
  function n(r) {
    (r.style.fontFamily || getComputedStyle(r).fontFamily).split(",").forEach((i) => {
      t.add(Ya(i));
    }), Array.from(r.children).forEach((i) => {
      i instanceof HTMLElement && n(i);
    });
  }
  return n(e), t;
}
async function L0(e, t) {
  const n = await T0(e, t), r = O0(e);
  return (await Promise.all(n.filter((i) => r.has(Ya(i.style.fontFamily))).map((i) => {
    const s = i.parentStyleSheet ? i.parentStyleSheet.href : null;
    return Ba(i.cssText, s, t);
  }))).join(`
`);
}
async function $0(e, t) {
  const n = t.fontEmbedCSS != null ? t.fontEmbedCSS : t.skipFonts ? null : await L0(e, t);
  if (n) {
    const r = document.createElement("style"), o = document.createTextNode(n);
    r.appendChild(o), e.firstChild ? e.insertBefore(r, e.firstChild) : e.appendChild(r);
  }
}
async function Xa(e, t = {}) {
  const { width: n, height: r } = Da(e, t), o = await Gn(e, t, !0);
  return await $0(o, t), await Fa(o, t), I0(o, t), await Jm(o, n, r);
}
async function D0(e, t = {}) {
  const { width: n, height: r } = Da(e, t), o = await Xa(e, t), i = await In(o), s = document.createElement("canvas"), a = s.getContext("2d"), c = t.pixelRatio || Um(), l = t.canvasWidth || n, u = t.canvasHeight || r;
  return s.width = l * c, s.height = u * c, t.skipAutoScale || Zm(s), s.style.width = `${l}`, s.style.height = `${u}`, t.backgroundColor && (a.fillStyle = t.backgroundColor, a.fillRect(0, 0, s.width, s.height)), a.drawImage(i, 0, 0, s.width, s.height), s;
}
async function R0(e, t = {}) {
  return (await D0(e, t)).toDataURL();
}
async function z0(e) {
  const t = e.querySelector(".react-flow__viewport") ?? e;
  return R0(t, { pixelRatio: 2, cacheBust: !0, backgroundColor: "#ffffff" });
}
async function V0(e) {
  const t = e.querySelector(".react-flow__viewport") ?? e;
  return Xa(t, { cacheBust: !0, backgroundColor: "#ffffff" });
}
var Wa = Object.defineProperty, H0 = (e, t, n) => t in e ? Wa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, B0 = (e, t) => {
  for (var n in t) Wa(e, n, { get: t[n], enumerable: !0 });
}, F0 = (e, t, n) => H0(e, t + "", n), Ga = {};
B0(Ga, { Graph: () => Ee, alg: () => ro, json: () => qa, version: () => W0 });
var Y0 = Object.defineProperty, ja = (e, t) => {
  for (var n in t) Y0(e, n, { get: t[n], enumerable: !0 });
}, Ee = class {
  constructor(e) {
    this._isDirected = !0, this._isMultigraph = !1, this._isCompound = !1, this._nodes = {}, this._in = {}, this._preds = {}, this._out = {}, this._sucs = {}, this._edgeObjs = {}, this._edgeLabels = {}, this._nodeCount = 0, this._edgeCount = 0, this._defaultNodeLabelFn = () => {
    }, this._defaultEdgeLabelFn = () => {
    }, e && (this._isDirected = "directed" in e ? e.directed : !0, this._isMultigraph = "multigraph" in e ? e.multigraph : !1, this._isCompound = "compound" in e ? e.compound : !1), this._isCompound && (this._parent = {}, this._children = {}, this._children["\0"] = {});
  }
  isDirected() {
    return this._isDirected;
  }
  isMultigraph() {
    return this._isMultigraph;
  }
  isCompound() {
    return this._isCompound;
  }
  setGraph(e) {
    return this._label = e, this;
  }
  graph() {
    return this._label;
  }
  setDefaultNodeLabel(e) {
    return typeof e != "function" ? this._defaultNodeLabelFn = () => e : this._defaultNodeLabelFn = e, this;
  }
  nodeCount() {
    return this._nodeCount;
  }
  nodes() {
    return Object.keys(this._nodes);
  }
  sources() {
    return this.nodes().filter((e) => Object.keys(this._in[e]).length === 0);
  }
  sinks() {
    return this.nodes().filter((e) => Object.keys(this._out[e]).length === 0);
  }
  setNodes(e, t) {
    return e.forEach((n) => {
      t !== void 0 ? this.setNode(n, t) : this.setNode(n);
    }), this;
  }
  setNode(e, t) {
    return e in this._nodes ? (arguments.length > 1 && (this._nodes[e] = t), this) : (this._nodes[e] = arguments.length > 1 ? t : this._defaultNodeLabelFn(e), this._isCompound && (this._parent[e] = "\0", this._children[e] = {}, this._children["\0"][e] = !0), this._in[e] = {}, this._preds[e] = {}, this._out[e] = {}, this._sucs[e] = {}, ++this._nodeCount, this);
  }
  node(e) {
    return this._nodes[e];
  }
  hasNode(e) {
    return e in this._nodes;
  }
  removeNode(e) {
    if (e in this._nodes) {
      let t = (n) => this.removeEdge(this._edgeObjs[n]);
      delete this._nodes[e], this._isCompound && (this._removeFromParentsChildList(e), delete this._parent[e], this.children(e).forEach((n) => {
        this.setParent(n);
      }), delete this._children[e]), Object.keys(this._in[e]).forEach(t), delete this._in[e], delete this._preds[e], Object.keys(this._out[e]).forEach(t), delete this._out[e], delete this._sucs[e], --this._nodeCount;
    }
    return this;
  }
  setParent(e, t) {
    if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
    if (t === void 0) t = "\0";
    else {
      t += "";
      for (let n = t; n !== void 0; n = this.parent(n)) if (n === e) throw new Error("Setting " + t + " as parent of " + e + " would create a cycle");
      this.setNode(t);
    }
    return this.setNode(e), this._removeFromParentsChildList(e), this._parent[e] = t, this._children[t][e] = !0, this;
  }
  parent(e) {
    if (this._isCompound) {
      let t = this._parent[e];
      if (t !== "\0") return t;
    }
  }
  children(e = "\0") {
    if (this._isCompound) {
      let t = this._children[e];
      if (t) return Object.keys(t);
    } else {
      if (e === "\0") return this.nodes();
      if (this.hasNode(e)) return [];
    }
    return [];
  }
  predecessors(e) {
    let t = this._preds[e];
    if (t) return Object.keys(t);
  }
  successors(e) {
    let t = this._sucs[e];
    if (t) return Object.keys(t);
  }
  neighbors(e) {
    let t = this.predecessors(e);
    if (t) {
      let n = new Set(t);
      for (let r of this.successors(e)) n.add(r);
      return Array.from(n.values());
    }
  }
  isLeaf(e) {
    let t;
    return this.isDirected() ? t = this.successors(e) : t = this.neighbors(e), t.length === 0;
  }
  filterNodes(e) {
    let t = new this.constructor({ directed: this._isDirected, multigraph: this._isMultigraph, compound: this._isCompound });
    t.setGraph(this.graph()), Object.entries(this._nodes).forEach(([o, i]) => {
      e(o) && t.setNode(o, i);
    }), Object.values(this._edgeObjs).forEach((o) => {
      t.hasNode(o.v) && t.hasNode(o.w) && t.setEdge(o, this.edge(o));
    });
    let n = {}, r = (o) => {
      let i = this.parent(o);
      return !i || t.hasNode(i) ? (n[o] = i ?? void 0, i ?? void 0) : i in n ? n[i] : r(i);
    };
    return this._isCompound && t.nodes().forEach((o) => t.setParent(o, r(o))), t;
  }
  setDefaultEdgeLabel(e) {
    return typeof e != "function" ? this._defaultEdgeLabelFn = () => e : this._defaultEdgeLabelFn = e, this;
  }
  edgeCount() {
    return this._edgeCount;
  }
  edges() {
    return Object.values(this._edgeObjs);
  }
  setPath(e, t) {
    return e.reduce((n, r) => (t !== void 0 ? this.setEdge(n, r, t) : this.setEdge(n, r), r)), this;
  }
  setEdge(e, t, n, r) {
    let o, i, s, a, c = !1;
    typeof e == "object" && e !== null && "v" in e ? (o = e.v, i = e.w, s = e.name, arguments.length === 2 && (a = t, c = !0)) : (o = e, i = t, s = r, arguments.length > 2 && (a = n, c = !0)), o = "" + o, i = "" + i, s !== void 0 && (s = "" + s);
    let l = Mt(this._isDirected, o, i, s);
    if (l in this._edgeLabels) return c && (this._edgeLabels[l] = a), this;
    if (s !== void 0 && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
    this.setNode(o), this.setNode(i), this._edgeLabels[l] = c ? a : this._defaultEdgeLabelFn(o, i, s);
    let u = X0(this._isDirected, o, i, s);
    return o = u.v, i = u.w, Object.freeze(u), this._edgeObjs[l] = u, Oi(this._preds[i], o), Oi(this._sucs[o], i), this._in[i][l] = u, this._out[o][l] = u, this._edgeCount++, this;
  }
  edge(e, t, n) {
    let r = arguments.length === 1 ? fr(this._isDirected, e) : Mt(this._isDirected, e, t, n);
    return this._edgeLabels[r];
  }
  edgeAsObj(e, t, n) {
    let r = arguments.length === 1 ? this.edge(e) : this.edge(e, t, n);
    return typeof r != "object" ? { label: r } : r;
  }
  hasEdge(e, t, n) {
    return (arguments.length === 1 ? fr(this._isDirected, e) : Mt(this._isDirected, e, t, n)) in this._edgeLabels;
  }
  removeEdge(e, t, n) {
    let r = arguments.length === 1 ? fr(this._isDirected, e) : Mt(this._isDirected, e, t, n), o = this._edgeObjs[r];
    if (o) {
      let i = o.v, s = o.w;
      delete this._edgeLabels[r], delete this._edgeObjs[r], Li(this._preds[s], i), Li(this._sucs[i], s), delete this._in[s][r], delete this._out[i][r], this._edgeCount--;
    }
    return this;
  }
  inEdges(e, t) {
    return this.isDirected() ? this.filterEdges(this._in[e], e, t) : this.nodeEdges(e, t);
  }
  outEdges(e, t) {
    return this.isDirected() ? this.filterEdges(this._out[e], e, t) : this.nodeEdges(e, t);
  }
  nodeEdges(e, t) {
    if (e in this._nodes) return this.filterEdges({ ...this._in[e], ...this._out[e] }, e, t);
  }
  _removeFromParentsChildList(e) {
    delete this._children[this._parent[e]][e];
  }
  filterEdges(e, t, n) {
    if (!e) return;
    let r = Object.values(e);
    return n ? r.filter((o) => o.v === t && o.w === n || o.v === n && o.w === t) : r;
  }
};
function Oi(e, t) {
  e[t] ? e[t]++ : e[t] = 1;
}
function Li(e, t) {
  e[t] !== void 0 && !--e[t] && delete e[t];
}
function Mt(e, t, n, r) {
  let o = "" + t, i = "" + n;
  if (!e && o > i) {
    let s = o;
    o = i, i = s;
  }
  return o + "" + i + "" + (r === void 0 ? "\0" : r);
}
function X0(e, t, n, r) {
  let o = "" + t, i = "" + n;
  if (!e && o > i) {
    let a = o;
    o = i, i = a;
  }
  let s = { v: o, w: i };
  return r && (s.name = r), s;
}
function fr(e, t) {
  return Mt(e, t.v, t.w, t.name);
}
var W0 = "4.0.1", qa = {};
ja(qa, { read: () => K0, write: () => G0 });
function G0(e) {
  let t = { options: { directed: e.isDirected(), multigraph: e.isMultigraph(), compound: e.isCompound() }, nodes: j0(e), edges: q0(e) }, n = e.graph();
  return n !== void 0 && (t.value = structuredClone(n)), t;
}
function j0(e) {
  return e.nodes().map((t) => {
    let n = e.node(t), r = e.parent(t), o = { v: t };
    return n !== void 0 && (o.value = n), r !== void 0 && (o.parent = r), o;
  });
}
function q0(e) {
  return e.edges().map((t) => {
    let n = e.edge(t), r = { v: t.v, w: t.w };
    return t.name !== void 0 && (r.name = t.name), n !== void 0 && (r.value = n), r;
  });
}
function K0(e) {
  let t = new Ee(e.options);
  return e.value !== void 0 && t.setGraph(e.value), e.nodes.forEach((n) => {
    t.setNode(n.v, n.value), n.parent && t.setParent(n.v, n.parent);
  }), e.edges.forEach((n) => {
    t.setEdge({ v: n.v, w: n.w, name: n.name }, n.value);
  }), t;
}
var ro = {};
ja(ro, { CycleException: () => An, bellmanFord: () => Ka, components: () => Q0, dijkstra: () => Pn, dijkstraAll: () => ty, findCycles: () => ny, floydWarshall: () => oy, isAcyclic: () => sy, postorder: () => cy, preorder: () => ly, prim: () => uy, shortestPaths: () => dy, tarjan: () => Za, topsort: () => Qa });
var U0 = () => 1;
function Ka(e, t, n, r) {
  return Z0(e, String(t), n || U0, r || function(o) {
    return e.outEdges(o);
  });
}
function Z0(e, t, n, r) {
  let o = {}, i, s = 0, a = e.nodes(), c = function(d) {
    let f = n(d);
    o[d.v].distance + f < o[d.w].distance && (o[d.w] = { distance: o[d.v].distance + f, predecessor: d.v }, i = !0);
  }, l = function() {
    a.forEach(function(d) {
      r(d).forEach(function(f) {
        let h = f.v === d ? f.v : f.w, g = h === f.v ? f.w : f.v;
        c({ v: h, w: g });
      });
    });
  };
  a.forEach(function(d) {
    let f = d === t ? 0 : Number.POSITIVE_INFINITY;
    o[d] = { distance: f, predecessor: "" };
  });
  let u = a.length;
  for (let d = 1; d < u && (i = !1, s++, l(), !!i); d++) ;
  if (s === u - 1 && (i = !1, l(), i)) throw new Error("The graph contains a negative weight cycle");
  return o;
}
function Q0(e) {
  let t = {}, n = [], r;
  function o(i) {
    i in t || (t[i] = !0, r.push(i), e.successors(i).forEach(o), e.predecessors(i).forEach(o));
  }
  return e.nodes().forEach(function(i) {
    r = [], o(i), r.length && n.push(r);
  }), n;
}
var Ua = class {
  constructor() {
    this._arr = [], this._keyIndices = {};
  }
  size() {
    return this._arr.length;
  }
  keys() {
    return this._arr.map((e) => e.key);
  }
  has(e) {
    return e in this._keyIndices;
  }
  priority(e) {
    let t = this._keyIndices[e];
    if (t !== void 0) return this._arr[t].priority;
  }
  min() {
    if (this.size() === 0) throw new Error("Queue underflow");
    return this._arr[0].key;
  }
  add(e, t) {
    let n = this._keyIndices, r = String(e);
    if (!(r in n)) {
      let o = this._arr, i = o.length;
      return n[r] = i, o.push({ key: r, priority: t }), this._decrease(i), !0;
    }
    return !1;
  }
  removeMin() {
    this._swap(0, this._arr.length - 1);
    let e = this._arr.pop();
    return delete this._keyIndices[e.key], this._heapify(0), e.key;
  }
  decrease(e, t) {
    let n = this._keyIndices[e];
    if (n === void 0) throw new Error(`Key not found: ${e}`);
    let r = this._arr[n].priority;
    if (t > r) throw new Error(`New priority is greater than current priority. Key: ${e} Old: ${r} New: ${t}`);
    this._arr[n].priority = t, this._decrease(n);
  }
  _heapify(e) {
    let t = this._arr, n = 2 * e, r = n + 1, o = e;
    n < t.length && (o = t[n].priority < t[o].priority ? n : o, r < t.length && (o = t[r].priority < t[o].priority ? r : o), o !== e && (this._swap(e, o), this._heapify(o)));
  }
  _decrease(e) {
    let t = this._arr, n = t[e].priority, r;
    for (; e !== 0 && (r = e >> 1, !(t[r].priority < n)); ) this._swap(e, r), e = r;
  }
  _swap(e, t) {
    let n = this._arr, r = this._keyIndices, o = n[e], i = n[t];
    n[e] = i, n[t] = o, r[i.key] = e, r[o.key] = t;
  }
}, J0 = () => 1;
function Pn(e, t, n, r) {
  let o = function(i) {
    return e.outEdges(i);
  };
  return ey(e, String(t), n || J0, r || o);
}
function ey(e, t, n, r) {
  let o = {}, i = new Ua(), s, a, c = function(l) {
    let u = l.v !== s ? l.v : l.w, d = o[u], f = n(l), h = a.distance + f;
    if (f < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + l + " Weight: " + f);
    h < d.distance && (d.distance = h, d.predecessor = s, i.decrease(u, h));
  };
  for (e.nodes().forEach(function(l) {
    let u = l === t ? 0 : Number.POSITIVE_INFINITY;
    o[l] = { distance: u, predecessor: "" }, i.add(l, u);
  }); i.size() > 0 && (s = i.removeMin(), a = o[s], a.distance !== Number.POSITIVE_INFINITY); ) r(s).forEach(c);
  return o;
}
function ty(e, t, n) {
  return e.nodes().reduce(function(r, o) {
    return r[o] = Pn(e, o, t, n), r;
  }, {});
}
function Za(e) {
  let t = 0, n = [], r = {}, o = [];
  function i(s) {
    let a = r[s] = { onStack: !0, lowlink: t, index: t++ };
    if (n.push(s), e.successors(s).forEach(function(c) {
      c in r ? r[c].onStack && (a.lowlink = Math.min(a.lowlink, r[c].index)) : (i(c), a.lowlink = Math.min(a.lowlink, r[c].lowlink));
    }), a.lowlink === a.index) {
      let c = [], l;
      do
        l = n.pop(), r[l].onStack = !1, c.push(l);
      while (s !== l);
      o.push(c);
    }
  }
  return e.nodes().forEach(function(s) {
    s in r || i(s);
  }), o;
}
function ny(e) {
  return Za(e).filter(function(t) {
    return t.length > 1 || t.length === 1 && e.hasEdge(t[0], t[0]);
  });
}
var ry = () => 1;
function oy(e, t, n) {
  return iy(e, t || ry, n || function(r) {
    return e.outEdges(r);
  });
}
function iy(e, t, n) {
  let r = {}, o = e.nodes();
  return o.forEach(function(i) {
    r[i] = {}, r[i][i] = { distance: 0, predecessor: "" }, o.forEach(function(s) {
      i !== s && (r[i][s] = { distance: Number.POSITIVE_INFINITY, predecessor: "" });
    }), n(i).forEach(function(s) {
      let a = s.v === i ? s.w : s.v, c = t(s);
      r[i][a] = { distance: c, predecessor: i };
    });
  }), o.forEach(function(i) {
    let s = r[i];
    o.forEach(function(a) {
      let c = r[a];
      o.forEach(function(l) {
        let u = c[i], d = s[l], f = c[l], h = u.distance + d.distance;
        h < f.distance && (f.distance = h, f.predecessor = d.predecessor);
      });
    });
  }), r;
}
var An = class extends Error {
  constructor(...e) {
    super(...e);
  }
};
function Qa(e) {
  let t = {}, n = {}, r = [];
  function o(i) {
    if (i in n) throw new An();
    i in t || (n[i] = !0, t[i] = !0, e.predecessors(i).forEach(o), delete n[i], r.push(i));
  }
  if (e.sinks().forEach(o), Object.keys(t).length !== e.nodeCount()) throw new An();
  return r;
}
function sy(e) {
  try {
    Qa(e);
  } catch (t) {
    if (t instanceof An) return !1;
    throw t;
  }
  return !0;
}
function ay(e, t, n, r, o) {
  Array.isArray(t) || (t = [t]);
  let i = (a) => {
    var c;
    return (c = e.isDirected() ? e.successors(a) : e.neighbors(a)) != null ? c : [];
  }, s = {};
  return t.forEach(function(a) {
    if (!e.hasNode(a)) throw new Error("Graph does not have node: " + a);
    o = Ja(e, a, n === "post", s, i, r, o);
  }), o;
}
function Ja(e, t, n, r, o, i, s) {
  return t in r || (r[t] = !0, n || (s = i(s, t)), o(t).forEach(function(a) {
    s = Ja(e, a, n, r, o, i, s);
  }), n && (s = i(s, t))), s;
}
function ec(e, t, n) {
  return ay(e, t, n, function(r, o) {
    return r.push(o), r;
  }, []);
}
function cy(e, t) {
  return ec(e, t, "post");
}
function ly(e, t) {
  return ec(e, t, "pre");
}
function uy(e, t) {
  let n = new Ee(), r = {}, o = new Ua(), i;
  function s(c) {
    let l = c.v === i ? c.w : c.v, u = o.priority(l);
    if (u !== void 0) {
      let d = t(c);
      d < u && (r[l] = i, o.decrease(l, d));
    }
  }
  if (e.nodeCount() === 0) return n;
  e.nodes().forEach(function(c) {
    o.add(c, Number.POSITIVE_INFINITY), n.setNode(c);
  }), o.decrease(e.nodes()[0], 0);
  let a = !1;
  for (; o.size() > 0; ) {
    if (i = o.removeMin(), i in r) n.setEdge(i, r[i]);
    else {
      if (a) throw new Error("Input graph is not connected: " + e);
      a = !0;
    }
    e.nodeEdges(i).forEach(s);
  }
  return n;
}
function dy(e, t, n, r) {
  return fy(e, t, n, r ?? ((o) => {
    let i = e.outEdges(o);
    return i ?? [];
  }));
}
function fy(e, t, n, r) {
  if (n === void 0) return Pn(e, t, n, r);
  let o = !1, i = e.nodes();
  for (let s = 0; s < i.length; s++) {
    let a = r(i[s]);
    for (let c = 0; c < a.length; c++) {
      let l = a[c], u = l.v === i[s] ? l.v : l.w, d = u === l.v ? l.w : l.v;
      n({ v: u, w: d }) < 0 && (o = !0);
    }
    if (o) return Ka(e, t, n, r);
  }
  return Pn(e, t, n, r);
}
function wt(e, t, n, r) {
  let o = r;
  for (; e.hasNode(o); ) o = oo(r);
  return n.dummy = t, e.setNode(o, n), o;
}
function hy(e) {
  let t = new Ee().setGraph(e.graph());
  return e.nodes().forEach((n) => t.setNode(n, e.node(n))), e.edges().forEach((n) => {
    let r = t.edge(n.v, n.w) || { weight: 0, minlen: 1 }, o = e.edge(n);
    t.setEdge(n.v, n.w, { weight: r.weight + o.weight, minlen: Math.max(r.minlen, o.minlen) });
  }), t;
}
function tc(e) {
  let t = new Ee({ multigraph: e.isMultigraph() }).setGraph(e.graph());
  return e.nodes().forEach((n) => {
    e.children(n).length || t.setNode(n, e.node(n));
  }), e.edges().forEach((n) => {
    t.setEdge(n, e.edge(n));
  }), t;
}
function $i(e, t) {
  let n = e.x, r = e.y, o = t.x - n, i = t.y - r, s = e.width / 2, a = e.height / 2;
  if (!o && !i) throw new Error("Not possible to find intersection inside of the rectangle");
  let c, l;
  return Math.abs(i) * s > Math.abs(o) * a ? (i < 0 && (a = -a), c = a * o / i, l = a) : (o < 0 && (s = -s), c = s, l = s * i / o), { x: n + c, y: r + l };
}
function Kt(e) {
  let t = Ht(rc(e) + 1).map(() => []);
  return e.nodes().forEach((n) => {
    let r = e.node(n), o = r.rank;
    o !== void 0 && (t[o] || (t[o] = []), t[o][r.order] = n);
  }), t;
}
function gy(e) {
  let t = e.nodes().map((r) => {
    let o = e.node(r).rank;
    return o === void 0 ? Number.MAX_VALUE : o;
  }), n = Ie(Math.min, t);
  e.nodes().forEach((r) => {
    let o = e.node(r);
    Object.hasOwn(o, "rank") && (o.rank -= n);
  });
}
function py(e) {
  let t = e.nodes().map((s) => e.node(s).rank).filter((s) => s !== void 0), n = Ie(Math.min, t), r = [];
  e.nodes().forEach((s) => {
    let a = e.node(s).rank - n;
    r[a] || (r[a] = []), r[a].push(s);
  });
  let o = 0, i = e.graph().nodeRankFactor;
  Array.from(r).forEach((s, a) => {
    s === void 0 && a % i !== 0 ? --o : s !== void 0 && o && s.forEach((c) => e.node(c).rank += o);
  });
}
function Di(e, t, n, r) {
  let o = { width: 0, height: 0 };
  return arguments.length >= 4 && (o.rank = n, o.order = r), wt(e, "border", o, t);
}
function my(e, t = nc) {
  let n = [];
  for (let r = 0; r < e.length; r += t) {
    let o = e.slice(r, r + t);
    n.push(o);
  }
  return n;
}
var nc = 65535;
function Ie(e, t) {
  if (t.length > nc) {
    let n = my(t);
    return e(...n.map((r) => e(...r)));
  } else return e(...t);
}
function rc(e) {
  let t = e.nodes().map((n) => {
    let r = e.node(n).rank;
    return r === void 0 ? Number.MIN_VALUE : r;
  });
  return Ie(Math.max, t);
}
function yy(e, t) {
  let n = { lhs: [], rhs: [] };
  return e.forEach((r) => {
    t(r) ? n.lhs.push(r) : n.rhs.push(r);
  }), n;
}
function oc(e, t) {
  let n = Date.now();
  try {
    return t();
  } finally {
    console.log(e + " time: " + (Date.now() - n) + "ms");
  }
}
function ic(e, t) {
  return t();
}
var wy = 0;
function oo(e) {
  let t = ++wy;
  return e + ("" + t);
}
function Ht(e, t, n = 1) {
  t == null && (t = e, e = 0);
  let r = (i) => i < t;
  n < 0 && (r = (i) => t < i);
  let o = [];
  for (let i = e; r(i); i += n) o.push(i);
  return o;
}
function Tn(e, t) {
  let n = {};
  for (let r of t) e[r] !== void 0 && (n[r] = e[r]);
  return n;
}
function jn(e, t) {
  let n;
  return typeof t == "string" ? n = (r) => r[t] : n = t, Object.entries(e).reduce((r, [o, i]) => (r[o] = n(i, o), r), {});
}
function by(e, t) {
  return e.reduce((n, r, o) => (n[r] = t[o], n), {});
}
var qn = "\0", xy = "3.0.0", vy = class {
  constructor() {
    F0(this, "_sentinel");
    let e = {};
    e._next = e._prev = e, this._sentinel = e;
  }
  dequeue() {
    let e = this._sentinel, t = e._prev;
    if (t !== e) return Ri(t), t;
  }
  enqueue(e) {
    let t = this._sentinel;
    e._prev && e._next && Ri(e), e._next = t._next, t._next._prev = e, t._next = e, e._prev = t;
  }
  toString() {
    let e = [], t = this._sentinel, n = t._prev;
    for (; n !== t; ) e.push(JSON.stringify(n, Ey)), n = n._prev;
    return "[" + e.join(", ") + "]";
  }
};
function Ri(e) {
  e._prev._next = e._next, e._next._prev = e._prev, delete e._next, delete e._prev;
}
function Ey(e, t) {
  if (e !== "_next" && e !== "_prev") return t;
}
var _y = vy, Sy = () => 1;
function Ny(e, t) {
  if (e.nodeCount() <= 1) return [];
  let n = ky(e, t || Sy);
  return Cy(n.graph, n.buckets, n.zeroIdx).flatMap((r) => e.outEdges(r.v, r.w) || []);
}
function Cy(e, t, n) {
  var r;
  let o = [], i = t[t.length - 1], s = t[0], a;
  for (; e.nodeCount(); ) {
    for (; a = s.dequeue(); ) hr(e, t, n, a);
    for (; a = i.dequeue(); ) hr(e, t, n, a);
    if (e.nodeCount()) {
      for (let c = t.length - 2; c > 0; --c) if (a = (r = t[c]) == null ? void 0 : r.dequeue(), a) {
        o = o.concat(hr(e, t, n, a, !0) || []);
        break;
      }
    }
  }
  return o;
}
function hr(e, t, n, r, o) {
  let i = [], s = o ? i : void 0;
  return (e.inEdges(r.v) || []).forEach((a) => {
    let c = e.edge(a), l = e.node(a.v);
    o && i.push({ v: a.v, w: a.w }), l.out -= c, $r(t, n, l);
  }), (e.outEdges(r.v) || []).forEach((a) => {
    let c = e.edge(a), l = a.w, u = e.node(l);
    u.in -= c, $r(t, n, u);
  }), e.removeNode(r.v), s;
}
function ky(e, t) {
  let n = new Ee(), r = 0, o = 0;
  e.nodes().forEach((a) => {
    n.setNode(a, { v: a, in: 0, out: 0 });
  }), e.edges().forEach((a) => {
    let c = n.edge(a.v, a.w) || 0, l = t(a), u = c + l;
    n.setEdge(a.v, a.w, u);
    let d = n.node(a.v), f = n.node(a.w);
    o = Math.max(o, d.out += l), r = Math.max(r, f.in += l);
  });
  let i = My(o + r + 3).map(() => new _y()), s = r + 1;
  return n.nodes().forEach((a) => {
    $r(i, s, n.node(a));
  }), { graph: n, buckets: i, zeroIdx: s };
}
function $r(e, t, n) {
  var r, o, i;
  n.out ? n.in ? (i = e[n.out - n.in + t]) == null || i.enqueue(n) : (o = e[e.length - 1]) == null || o.enqueue(n) : (r = e[0]) == null || r.enqueue(n);
}
function My(e) {
  let t = [];
  for (let n = 0; n < e; n++) t.push(n);
  return t;
}
function Iy(e) {
  (e.graph().acyclicer === "greedy" ? Ny(e, t(e)) : Py(e)).forEach((n) => {
    let r = e.edge(n);
    e.removeEdge(n), r.forwardName = n.name, r.reversed = !0, e.setEdge(n.w, n.v, r, oo("rev"));
  });
  function t(n) {
    return (r) => n.edge(r).weight;
  }
}
function Py(e) {
  let t = [], n = {}, r = {};
  function o(i) {
    Object.hasOwn(r, i) || (r[i] = !0, n[i] = !0, e.outEdges(i).forEach((s) => {
      Object.hasOwn(n, s.w) ? t.push(s) : o(s.w);
    }), delete n[i]);
  }
  return e.nodes().forEach(o), t;
}
function Ay(e) {
  e.edges().forEach((t) => {
    let n = e.edge(t);
    if (n.reversed) {
      e.removeEdge(t);
      let r = n.forwardName;
      delete n.reversed, delete n.forwardName, e.setEdge(t.w, t.v, n, r);
    }
  });
}
function Ty(e) {
  e.graph().dummyChains = [], e.edges().forEach((t) => Oy(e, t));
}
function Oy(e, t) {
  let n = t.v, r = e.node(n).rank, o = t.w, i = e.node(o).rank, s = t.name, a = e.edge(t), c = a.labelRank;
  if (i === r + 1) return;
  e.removeEdge(t);
  let l, u, d;
  for (d = 0, ++r; r < i; ++d, ++r) a.points = [], u = { width: 0, height: 0, edgeLabel: a, edgeObj: t, rank: r }, l = wt(e, "edge", u, "_d"), r === c && (u.width = a.width, u.height = a.height, u.dummy = "edge-label", u.labelpos = a.labelpos), e.setEdge(n, l, { weight: a.weight }, s), d === 0 && e.graph().dummyChains.push(l), n = l;
  e.setEdge(n, o, { weight: a.weight }, s);
}
function Ly(e) {
  e.graph().dummyChains.forEach((t) => {
    let n = e.node(t), r = n.edgeLabel, o;
    for (e.setEdge(n.edgeObj, r); n.dummy; ) o = e.successors(t)[0], e.removeNode(t), r.points.push({ x: n.x, y: n.y }), n.dummy === "edge-label" && (r.x = n.x, r.y = n.y, r.width = n.width, r.height = n.height), t = o, n = e.node(t);
  });
}
function io(e) {
  let t = {};
  function n(r) {
    let o = e.node(r);
    if (Object.hasOwn(t, r)) return o.rank;
    t[r] = !0;
    let i = e.outEdges(r), s = i ? i.map((c) => c == null ? Number.POSITIVE_INFINITY : n(c.w) - e.edge(c).minlen) : [], a = Ie(Math.min, s);
    return a === Number.POSITIVE_INFINITY && (a = 0), o.rank = a;
  }
  e.sources().forEach(n);
}
function mt(e, t) {
  return e.node(t.w).rank - e.node(t.v).rank - e.edge(t).minlen;
}
var sc = $y;
function $y(e) {
  let t = new Ee({ directed: !1 }), n = e.nodes();
  if (n.length === 0) throw new Error("Graph must have at least one node");
  let r = n[0], o = e.nodeCount();
  t.setNode(r, {});
  let i, s;
  for (; Dy(t, e) < o && (i = Ry(t, e), !!i); ) s = t.hasNode(i.v) ? mt(e, i) : -mt(e, i), zy(t, e, s);
  return t;
}
function Dy(e, t) {
  function n(r) {
    let o = t.nodeEdges(r);
    o && o.forEach((i) => {
      let s = i.v, a = r === s ? i.w : s;
      !e.hasNode(a) && !mt(t, i) && (e.setNode(a, {}), e.setEdge(r, a, {}), n(a));
    });
  }
  return e.nodes().forEach(n), e.nodeCount();
}
function Ry(e, t) {
  return t.edges().reduce((n, r) => {
    let o = Number.POSITIVE_INFINITY;
    return e.hasNode(r.v) !== e.hasNode(r.w) && (o = mt(t, r)), o < n[0] ? [o, r] : n;
  }, [Number.POSITIVE_INFINITY, null])[1];
}
function zy(e, t, n) {
  e.nodes().forEach((r) => t.node(r).rank += n);
}
var { preorder: Vy, postorder: Hy } = ro, By = Je;
Je.initLowLimValues = ao;
Je.initCutValues = so;
Je.calcCutValue = ac;
Je.leaveEdge = lc;
Je.enterEdge = uc;
Je.exchangeEdges = dc;
function Je(e) {
  e = hy(e), io(e);
  let t = sc(e);
  ao(t), so(t, e);
  let n, r;
  for (; n = lc(t); ) r = uc(t, e, n), dc(t, e, n, r);
}
function so(e, t) {
  let n = Hy(e, e.nodes());
  n = n.slice(0, n.length - 1), n.forEach((r) => Fy(e, t, r));
}
function Fy(e, t, n) {
  let r = e.node(n).parent, o = e.edge(n, r);
  o.cutvalue = ac(e, t, n);
}
function ac(e, t, n) {
  let r = e.node(n).parent, o = !0, i = t.edge(n, r), s = 0;
  i || (o = !1, i = t.edge(r, n)), s = i.weight;
  let a = t.nodeEdges(n);
  return a && a.forEach((c) => {
    let l = c.v === n, u = l ? c.w : c.v;
    if (u !== r) {
      let d = l === o, f = t.edge(c).weight;
      if (s += d ? f : -f, Xy(e, n, u)) {
        let h = e.edge(n, u).cutvalue;
        s += d ? -h : h;
      }
    }
  }), s;
}
function ao(e, t) {
  arguments.length < 2 && (t = e.nodes()[0]), cc(e, {}, 1, t);
}
function cc(e, t, n, r, o) {
  let i = n, s = e.node(r);
  t[r] = !0;
  let a = e.neighbors(r);
  return a && a.forEach((c) => {
    Object.hasOwn(t, c) || (n = cc(e, t, n, c, r));
  }), s.low = i, s.lim = n++, o ? s.parent = o : delete s.parent, n;
}
function lc(e) {
  return e.edges().find((t) => e.edge(t).cutvalue < 0);
}
function uc(e, t, n) {
  let r = n.v, o = n.w;
  t.hasEdge(r, o) || (r = n.w, o = n.v);
  let i = e.node(r), s = e.node(o), a = i, c = !1;
  return i.lim > s.lim && (a = s, c = !0), t.edges().filter((l) => c === zi(e, e.node(l.v), a) && c !== zi(e, e.node(l.w), a)).reduce((l, u) => mt(t, u) < mt(t, l) ? u : l);
}
function dc(e, t, n, r) {
  let o = n.v, i = n.w;
  e.removeEdge(o, i), e.setEdge(r.v, r.w, {}), ao(e), so(e, t), Yy(e, t);
}
function Yy(e, t) {
  let n = e.nodes().find((o) => !e.node(o).parent);
  if (!n) return;
  let r = Vy(e, [n]);
  r = r.slice(1), r.forEach((o) => {
    let i = e.node(o).parent, s = t.edge(o, i), a = !1;
    s || (s = t.edge(i, o), a = !0), t.node(o).rank = t.node(i).rank + (a ? s.minlen : -s.minlen);
  });
}
function Xy(e, t, n) {
  return e.hasEdge(t, n);
}
function zi(e, t, n) {
  return n.low <= t.lim && t.lim <= n.lim;
}
var Wy = Gy;
function Gy(e) {
  let t = e.graph().ranker;
  if (typeof t == "function") return t(e);
  switch (t) {
    case "network-simplex":
      Vi(e);
      break;
    case "tight-tree":
      qy(e);
      break;
    case "longest-path":
      jy(e);
      break;
    case "none":
      break;
    default:
      Vi(e);
  }
}
var jy = io;
function qy(e) {
  io(e), sc(e);
}
function Vi(e) {
  By(e);
}
var Ky = Uy;
function Uy(e) {
  let t = Qy(e);
  e.graph().dummyChains.forEach((n) => {
    let r = e.node(n), o = r.edgeObj, i = Zy(e, t, o.v, o.w), s = i.path, a = i.lca, c = 0, l = s[c], u = !0;
    for (; n !== o.w; ) {
      if (r = e.node(n), u) {
        for (; (l = s[c]) !== a && e.node(l).maxRank < r.rank; ) c++;
        l === a && (u = !1);
      }
      if (!u) {
        for (; c < s.length - 1 && e.node(s[c + 1]).minRank <= r.rank; ) c++;
        l = s[c];
      }
      l !== void 0 && e.setParent(n, l), n = e.successors(n)[0];
    }
  });
}
function Zy(e, t, n, r) {
  let o = [], i = [], s = Math.min(t[n].low, t[r].low), a = Math.max(t[n].lim, t[r].lim), c;
  c = n;
  do
    c = e.parent(c), o.push(c);
  while (c && (t[c].low > s || a > t[c].lim));
  let l = c, u = r;
  for (; (u = e.parent(u)) !== l; ) i.push(u);
  return { path: o.concat(i.reverse()), lca: l };
}
function Qy(e) {
  let t = {}, n = 0;
  function r(o) {
    let i = n;
    e.children(o).forEach(r), t[o] = { low: i, lim: n++ };
  }
  return e.children(qn).forEach(r), t;
}
function Jy(e) {
  let t = wt(e, "root", {}, "_root"), n = ew(e), r = Object.values(n), o = Ie(Math.max, r) - 1, i = 2 * o + 1;
  e.graph().nestingRoot = t, e.edges().forEach((a) => e.edge(a).minlen *= i);
  let s = tw(e) + 1;
  e.children(qn).forEach((a) => fc(e, t, i, s, o, n, a)), e.graph().nodeRankFactor = i;
}
function fc(e, t, n, r, o, i, s) {
  var a;
  let c = e.children(s);
  if (!c.length) {
    s !== t && e.setEdge(t, s, { weight: 0, minlen: n });
    return;
  }
  let l = Di(e, "_bt"), u = Di(e, "_bb"), d = e.node(s);
  e.setParent(l, s), d.borderTop = l, e.setParent(u, s), d.borderBottom = u, c.forEach((f) => {
    var h;
    fc(e, t, n, r, o, i, f);
    let g = e.node(f), y = g.borderTop ? g.borderTop : f, w = g.borderBottom ? g.borderBottom : f, m = g.borderTop ? r : 2 * r, x = y !== w ? 1 : o - ((h = i[s]) != null ? h : 0) + 1;
    e.setEdge(l, y, { weight: m, minlen: x, nestingEdge: !0 }), e.setEdge(w, u, { weight: m, minlen: x, nestingEdge: !0 });
  }), e.parent(s) || e.setEdge(t, l, { weight: 0, minlen: o + ((a = i[s]) != null ? a : 0) });
}
function ew(e) {
  let t = {};
  function n(r, o) {
    let i = e.children(r);
    i && i.length && i.forEach((s) => n(s, o + 1)), t[r] = o;
  }
  return e.children(qn).forEach((r) => n(r, 1)), t;
}
function tw(e) {
  return e.edges().reduce((t, n) => t + e.edge(n).weight, 0);
}
function nw(e) {
  let t = e.graph();
  e.removeNode(t.nestingRoot), delete t.nestingRoot, e.edges().forEach((n) => {
    e.edge(n).nestingEdge && e.removeEdge(n);
  });
}
var rw = ow;
function ow(e) {
  function t(n) {
    let r = e.children(n), o = e.node(n);
    if (r.length && r.forEach(t), Object.hasOwn(o, "minRank")) {
      o.borderLeft = [], o.borderRight = [];
      for (let i = o.minRank, s = o.maxRank + 1; i < s; ++i) Hi(e, "borderLeft", "_bl", n, o, i), Hi(e, "borderRight", "_br", n, o, i);
    }
  }
  e.children(qn).forEach(t);
}
function Hi(e, t, n, r, o, i) {
  let s = { width: 0, height: 0, rank: i, borderType: t }, a = o[t][i - 1], c = wt(e, "border", s, n);
  o[t][i] = c, e.setParent(c, r), a && e.setEdge(a, c, { weight: 1 });
}
function iw(e) {
  var t;
  let n = (t = e.graph().rankdir) == null ? void 0 : t.toLowerCase();
  (n === "lr" || n === "rl") && hc(e);
}
function sw(e) {
  var t;
  let n = (t = e.graph().rankdir) == null ? void 0 : t.toLowerCase();
  (n === "bt" || n === "rl") && aw(e), (n === "lr" || n === "rl") && (cw(e), hc(e));
}
function hc(e) {
  e.nodes().forEach((t) => Bi(e.node(t))), e.edges().forEach((t) => Bi(e.edge(t)));
}
function Bi(e) {
  let t = e.width;
  e.width = e.height, e.height = t;
}
function aw(e) {
  e.nodes().forEach((t) => gr(e.node(t))), e.edges().forEach((t) => {
    var n;
    let r = e.edge(t);
    (n = r.points) == null || n.forEach(gr), Object.hasOwn(r, "y") && gr(r);
  });
}
function gr(e) {
  e.y = -e.y;
}
function cw(e) {
  e.nodes().forEach((t) => pr(e.node(t))), e.edges().forEach((t) => {
    var n;
    let r = e.edge(t);
    (n = r.points) == null || n.forEach(pr), Object.hasOwn(r, "x") && pr(r);
  });
}
function pr(e) {
  let t = e.x;
  e.x = e.y, e.y = t;
}
function lw(e) {
  let t = {}, n = e.nodes().filter((a) => !e.children(a).length), r = n.map((a) => e.node(a).rank), o = Ie(Math.max, r), i = Ht(o + 1).map(() => []);
  function s(a) {
    if (t[a]) return;
    t[a] = !0;
    let c = e.node(a);
    i[c.rank].push(a);
    let l = e.successors(a);
    l && l.forEach(s);
  }
  return n.sort((a, c) => e.node(a).rank - e.node(c).rank).forEach(s), i;
}
function uw(e, t) {
  let n = 0;
  for (let r = 1; r < t.length; ++r) n += dw(e, t[r - 1], t[r]);
  return n;
}
function dw(e, t, n) {
  let r = by(n, n.map((l, u) => u)), o = t.flatMap((l) => {
    let u = e.outEdges(l);
    return u ? u.map((d) => ({ pos: r[d.w], weight: e.edge(d).weight })).sort((d, f) => d.pos - f.pos) : [];
  }), i = 1;
  for (; i < n.length; ) i <<= 1;
  let s = 2 * i - 1;
  i -= 1;
  let a = new Array(s).fill(0), c = 0;
  return o.forEach((l) => {
    let u = l.pos + i;
    a[u] += l.weight;
    let d = 0;
    for (; u > 0; ) u % 2 && (d += a[u + 1]), u = u - 1 >> 1, a[u] += l.weight;
    c += l.weight * d;
  }), c;
}
function fw(e, t = []) {
  return t.map((n) => {
    let r = e.inEdges(n);
    if (!r || !r.length) return { v: n };
    {
      let o = r.reduce((i, s) => {
        let a = e.edge(s), c = e.node(s.v);
        return { sum: i.sum + a.weight * c.order, weight: i.weight + a.weight };
      }, { sum: 0, weight: 0 });
      return { v: n, barycenter: o.sum / o.weight, weight: o.weight };
    }
  });
}
function hw(e, t) {
  let n = {};
  e.forEach((o, i) => {
    let s = { indegree: 0, in: [], out: [], vs: [o.v], i };
    o.barycenter !== void 0 && (s.barycenter = o.barycenter, s.weight = o.weight), n[o.v] = s;
  }), t.edges().forEach((o) => {
    let i = n[o.v], s = n[o.w];
    i !== void 0 && s !== void 0 && (s.indegree++, i.out.push(s));
  });
  let r = Object.values(n).filter((o) => !o.indegree);
  return gw(r);
}
function gw(e) {
  let t = [];
  function n(o) {
    return (i) => {
      i.merged || (i.barycenter === void 0 || o.barycenter === void 0 || i.barycenter >= o.barycenter) && pw(o, i);
    };
  }
  function r(o) {
    return (i) => {
      i.in.push(o), --i.indegree === 0 && e.push(i);
    };
  }
  for (; e.length; ) {
    let o = e.pop();
    t.push(o), o.in.reverse().forEach(n(o)), o.out.forEach(r(o));
  }
  return t.filter((o) => !o.merged).map((o) => Tn(o, ["vs", "i", "barycenter", "weight"]));
}
function pw(e, t) {
  let n = 0, r = 0;
  e.weight && (n += e.barycenter * e.weight, r += e.weight), t.weight && (n += t.barycenter * t.weight, r += t.weight), e.vs = t.vs.concat(e.vs), e.barycenter = n / r, e.weight = r, e.i = Math.min(t.i, e.i), t.merged = !0;
}
function mw(e, t) {
  let n = yy(e, (u) => Object.hasOwn(u, "barycenter")), r = n.lhs, o = n.rhs.sort((u, d) => d.i - u.i), i = [], s = 0, a = 0, c = 0;
  r.sort(yw(!!t)), c = Fi(i, o, c), r.forEach((u) => {
    c += u.vs.length, i.push(u.vs), s += u.barycenter * u.weight, a += u.weight, c = Fi(i, o, c);
  });
  let l = { vs: i.flat(1) };
  return a && (l.barycenter = s / a, l.weight = a), l;
}
function Fi(e, t, n) {
  let r;
  for (; t.length && (r = t[t.length - 1]).i <= n; ) t.pop(), e.push(r.vs), n++;
  return n;
}
function yw(e) {
  return (t, n) => t.barycenter < n.barycenter ? -1 : t.barycenter > n.barycenter ? 1 : e ? n.i - t.i : t.i - n.i;
}
function gc(e, t, n, r) {
  let o = e.children(t), i = e.node(t), s = i ? i.borderLeft : void 0, a = i ? i.borderRight : void 0, c = {};
  s && (o = o.filter((f) => f !== s && f !== a));
  let l = fw(e, o);
  l.forEach((f) => {
    if (e.children(f.v).length) {
      let h = gc(e, f.v, n, r);
      c[f.v] = h, Object.hasOwn(h, "barycenter") && bw(f, h);
    }
  });
  let u = hw(l, n);
  ww(u, c);
  let d = mw(u, r);
  if (s && a) {
    d.vs = [s, d.vs, a].flat(1);
    let f = e.predecessors(s);
    if (f && f.length) {
      let h = e.node(f[0]), g = e.predecessors(a), y = e.node(g[0]);
      Object.hasOwn(d, "barycenter") || (d.barycenter = 0, d.weight = 0), d.barycenter = (d.barycenter * d.weight + h.order + y.order) / (d.weight + 2), d.weight += 2;
    }
  }
  return d;
}
function ww(e, t) {
  e.forEach((n) => {
    n.vs = n.vs.flatMap((r) => t[r] ? t[r].vs : r);
  });
}
function bw(e, t) {
  e.barycenter !== void 0 ? (e.barycenter = (e.barycenter * e.weight + t.barycenter * t.weight) / (e.weight + t.weight), e.weight += t.weight) : (e.barycenter = t.barycenter, e.weight = t.weight);
}
function xw(e, t, n, r) {
  r || (r = e.nodes());
  let o = vw(e), i = new Ee({ compound: !0 }).setGraph({ root: o }).setDefaultNodeLabel((s) => e.node(s));
  return r.forEach((s) => {
    let a = e.node(s), c = e.parent(s);
    if (a.rank === t || a.minRank <= t && t <= a.maxRank) {
      i.setNode(s), i.setParent(s, c || o);
      let l = e[n](s);
      l && l.forEach((u) => {
        let d = u.v === s ? u.w : u.v, f = i.edge(d, s), h = f !== void 0 ? f.weight : 0;
        i.setEdge(d, s, { weight: e.edge(u).weight + h });
      }), Object.hasOwn(a, "minRank") && i.setNode(s, { borderLeft: a.borderLeft[t], borderRight: a.borderRight[t] });
    }
  }), i;
}
function vw(e) {
  let t;
  for (; e.hasNode(t = oo("_root")); ) ;
  return t;
}
function Ew(e, t, n) {
  let r = {}, o;
  n.forEach((i) => {
    let s = e.parent(i), a, c;
    for (; s; ) {
      if (a = e.parent(s), a ? (c = r[a], r[a] = s) : (c = o, o = s), c && c !== s) {
        t.setEdge(c, s);
        return;
      }
      s = a;
    }
  });
}
function pc(e, t = {}) {
  if (typeof t.customOrder == "function") {
    t.customOrder(e, pc);
    return;
  }
  let n = rc(e), r = Yi(e, Ht(1, n + 1), "inEdges"), o = Yi(e, Ht(n - 1, -1, -1), "outEdges"), i = lw(e);
  if (Xi(e, i), t.disableOptimalOrderHeuristic) return;
  let s = Number.POSITIVE_INFINITY, a, c = t.constraints || [];
  for (let l = 0, u = 0; u < 4; ++l, ++u) {
    _w(l % 2 ? r : o, l % 4 >= 2, c), i = Kt(e);
    let d = uw(e, i);
    d < s ? (u = 0, a = Object.assign({}, i), s = d) : d === s && (a = structuredClone(i));
  }
  Xi(e, a);
}
function Yi(e, t, n) {
  let r = /* @__PURE__ */ new Map(), o = (i, s) => {
    r.has(i) || r.set(i, []), r.get(i).push(s);
  };
  for (let i of e.nodes()) {
    let s = e.node(i);
    if (typeof s.rank == "number" && o(s.rank, i), typeof s.minRank == "number" && typeof s.maxRank == "number") for (let a = s.minRank; a <= s.maxRank; a++) a !== s.rank && o(a, i);
  }
  return t.map(function(i) {
    return xw(e, i, n, r.get(i) || []);
  });
}
function _w(e, t, n) {
  let r = new Ee();
  e.forEach(function(o) {
    n.forEach((a) => r.setEdge(a.left, a.right));
    let i = o.graph().root, s = gc(o, i, r, t);
    s.vs.forEach((a, c) => o.node(a).order = c), Ew(o, r, s.vs);
  });
}
function Xi(e, t) {
  Object.values(t).forEach((n) => n.forEach((r, o) => e.node(r).order = o));
}
function Sw(e, t) {
  let n = {};
  function r(o, i) {
    let s = 0, a = 0, c = o.length, l = i[i.length - 1];
    return i.forEach((u, d) => {
      let f = Cw(e, u), h = f ? e.node(f).order : c;
      (f || u === l) && (i.slice(a, d + 1).forEach((g) => {
        let y = e.predecessors(g);
        y && y.forEach((w) => {
          let m = e.node(w), x = m.order;
          (x < s || h < x) && !(m.dummy && e.node(g).dummy) && mc(n, w, g);
        });
      }), a = d + 1, s = h);
    }), i;
  }
  return t.length && t.reduce(r), n;
}
function Nw(e, t) {
  let n = {};
  function r(i, s, a, c, l) {
    Ht(s, a).forEach((u) => {
      let d = i[u];
      if (d !== void 0 && e.node(d).dummy) {
        let f = e.predecessors(d);
        f && f.forEach((h) => {
          if (h === void 0) return;
          let g = e.node(h);
          g.dummy && (g.order < c || g.order > l) && mc(n, h, d);
        });
      }
    });
  }
  function o(i, s) {
    let a = -1, c = -1, l = 0;
    return s.forEach((u, d) => {
      if (e.node(u).dummy === "border") {
        let f = e.predecessors(u);
        if (f && f.length) {
          let h = f[0];
          if (h === void 0) return;
          c = e.node(h).order, r(s, l, d, a, c), l = d, a = c;
        }
      }
      r(s, l, s.length, c, i.length);
    }), s;
  }
  return t.length && t.reduce(o), n;
}
function Cw(e, t) {
  if (e.node(t).dummy) {
    let n = e.predecessors(t);
    if (n) return n.find((r) => e.node(r).dummy);
  }
}
function mc(e, t, n) {
  if (t > n) {
    let o = t;
    t = n, n = o;
  }
  let r = e[t];
  r || (e[t] = r = {}), r[n] = !0;
}
function kw(e, t, n) {
  if (t > n) {
    let o = t;
    t = n, n = o;
  }
  let r = e[t];
  return r !== void 0 && Object.hasOwn(r, n);
}
function Mw(e, t, n, r) {
  let o = {}, i = {}, s = {};
  return t.forEach((a) => {
    a.forEach((c, l) => {
      o[c] = c, i[c] = c, s[c] = l;
    });
  }), t.forEach((a) => {
    let c = -1;
    a.forEach((l) => {
      let u = r(l);
      if (u && u.length) {
        let d = u.sort((h, g) => {
          let y = s[h], w = s[g];
          return (y !== void 0 ? y : 0) - (w !== void 0 ? w : 0);
        }), f = (d.length - 1) / 2;
        for (let h = Math.floor(f), g = Math.ceil(f); h <= g; ++h) {
          let y = d[h];
          if (y === void 0) continue;
          let w = s[y];
          if (w !== void 0 && i[l] === l && c < w && !kw(n, l, y)) {
            let m = o[y];
            m !== void 0 && (i[y] = l, i[l] = o[l] = m, c = w);
          }
        }
      }
    });
  }), { root: o, align: i };
}
function Iw(e, t, n, r, o = !1) {
  let i = {}, s = Pw(e, t, n, o), a = o ? "borderLeft" : "borderRight";
  function c(h, g) {
    let y = s.nodes().slice(), w = {}, m = y.pop();
    for (; m; ) {
      if (w[m]) h(m);
      else {
        w[m] = !0, y.push(m);
        for (let x of g(m)) y.push(x);
      }
      m = y.pop();
    }
  }
  function l(h) {
    let g = s.inEdges(h);
    g ? i[h] = g.reduce((y, w) => {
      var m;
      let x = (m = i[w.v]) != null ? m : 0, p = s.edge(w);
      return Math.max(y, x + (p !== void 0 ? p : 0));
    }, 0) : i[h] = 0;
  }
  function u(h) {
    let g = s.outEdges(h), y = Number.POSITIVE_INFINITY;
    g && (y = g.reduce((m, x) => {
      let p = i[x.w], b = s.edge(x);
      return Math.min(m, (p !== void 0 ? p : 0) - (b !== void 0 ? b : 0));
    }, Number.POSITIVE_INFINITY));
    let w = e.node(h);
    y !== Number.POSITIVE_INFINITY && w.borderType !== a && (i[h] = Math.max(i[h] !== void 0 ? i[h] : 0, y));
  }
  function d(h) {
    return s.predecessors(h) || [];
  }
  function f(h) {
    return s.successors(h) || [];
  }
  return c(l, d), c(u, f), Object.keys(r).forEach((h) => {
    var g;
    let y = n[h];
    y !== void 0 && (i[h] = (g = i[y]) != null ? g : 0);
  }), i;
}
function Pw(e, t, n, r) {
  let o = new Ee(), i = e.graph(), s = $w(i.nodesep, i.edgesep, r);
  return t.forEach((a) => {
    let c;
    a.forEach((l) => {
      let u = n[l];
      if (u !== void 0) {
        if (o.setNode(u), c !== void 0) {
          let d = n[c];
          if (d !== void 0) {
            let f = o.edge(d, u);
            o.setEdge(d, u, Math.max(s(e, l, c), f || 0));
          }
        }
        c = l;
      }
    });
  }), o;
}
function Aw(e, t) {
  return Object.values(t).reduce((n, r) => {
    let o = Number.NEGATIVE_INFINITY, i = Number.POSITIVE_INFINITY;
    Object.entries(r).forEach(([a, c]) => {
      let l = Dw(e, a) / 2;
      o = Math.max(c + l, o), i = Math.min(c - l, i);
    });
    let s = o - i;
    return s < n[0] && (n = [s, r]), n;
  }, [Number.POSITIVE_INFINITY, null])[1];
}
function Tw(e, t) {
  let n = Object.values(t), r = Ie(Math.min, n), o = Ie(Math.max, n);
  ["u", "d"].forEach((i) => {
    ["l", "r"].forEach((s) => {
      let a = i + s, c = e[a];
      if (!c || c === t) return;
      let l = Object.values(c), u = r - Ie(Math.min, l);
      s !== "l" && (u = o - Ie(Math.max, l)), u && (e[a] = jn(c, (d) => d + u));
    });
  });
}
function Ow(e, t = void 0) {
  let n = e.ul;
  return n ? jn(n, (r, o) => {
    var i, s;
    if (t) {
      let c = t.toLowerCase(), l = e[c];
      if (l && l[o] !== void 0) return l[o];
    }
    let a = Object.values(e).map((c) => {
      let l = c[o];
      return l !== void 0 ? l : 0;
    }).sort((c, l) => c - l);
    return (((i = a[1]) != null ? i : 0) + ((s = a[2]) != null ? s : 0)) / 2;
  }) : {};
}
function Lw(e) {
  let t = Kt(e), n = Object.assign(Sw(e, t), Nw(e, t)), r = {}, o;
  ["u", "d"].forEach((s) => {
    o = s === "u" ? t : Object.values(t).reverse(), ["l", "r"].forEach((a) => {
      a === "r" && (o = o.map((u) => Object.values(u).reverse()));
      let c = Mw(e, o, n, (u) => (s === "u" ? e.predecessors(u) : e.successors(u)) || []), l = Iw(e, o, c.root, c.align, a === "r");
      a === "r" && (l = jn(l, (u) => -u)), r[s + a] = l;
    });
  });
  let i = Aw(e, r);
  return Tw(r, i), Ow(r, e.graph().align);
}
function $w(e, t, n) {
  return (r, o, i) => {
    let s = r.node(o), a = r.node(i), c = 0, l;
    if (c += s.width / 2, Object.hasOwn(s, "labelpos")) switch (s.labelpos.toLowerCase()) {
      case "l":
        l = -s.width / 2;
        break;
      case "r":
        l = s.width / 2;
        break;
    }
    if (l && (c += n ? l : -l), l = void 0, c += (s.dummy ? t : e) / 2, c += (a.dummy ? t : e) / 2, c += a.width / 2, Object.hasOwn(a, "labelpos")) switch (a.labelpos.toLowerCase()) {
      case "l":
        l = a.width / 2;
        break;
      case "r":
        l = -a.width / 2;
        break;
    }
    return l && (c += n ? l : -l), c;
  };
}
function Dw(e, t) {
  return e.node(t).width;
}
function Rw(e) {
  e = tc(e), zw(e), Object.entries(Lw(e)).forEach(([t, n]) => e.node(t).x = n);
}
function zw(e) {
  let t = Kt(e), n = e.graph(), r = n.ranksep, o = n.rankalign, i = 0;
  t.forEach((s) => {
    let a = s.reduce((c, l) => {
      var u;
      let d = (u = e.node(l).height) != null ? u : 0;
      return c > d ? c : d;
    }, 0);
    s.forEach((c) => {
      let l = e.node(c);
      o === "top" ? l.y = i + l.height / 2 : o === "bottom" ? l.y = i + a - l.height / 2 : l.y = i + a / 2;
    }), i += a + r;
  });
}
function Vw(e, t = {}) {
  let n = t.debugTiming ? oc : ic;
  return n("layout", () => {
    let r = n("  buildLayoutGraph", () => Kw(e));
    return n("  runLayout", () => Hw(r, n, t)), n("  updateInputGraph", () => Bw(e, r)), r;
  });
}
function Hw(e, t, n) {
  t("    makeSpaceForEdgeLabels", () => Uw(e)), t("    removeSelfEdges", () => ib(e)), t("    acyclic", () => Iy(e)), t("    nestingGraph.run", () => Jy(e)), t("    rank", () => Wy(tc(e))), t("    injectEdgeLabelProxies", () => Zw(e)), t("    removeEmptyRanks", () => py(e)), t("    nestingGraph.cleanup", () => nw(e)), t("    normalizeRanks", () => gy(e)), t("    assignRankMinMax", () => Qw(e)), t("    removeEdgeLabelProxies", () => Jw(e)), t("    normalize.run", () => Ty(e)), t("    parentDummyChains", () => Ky(e)), t("    addBorderSegments", () => rw(e)), t("    order", () => pc(e, n)), t("    insertSelfEdges", () => sb(e)), t("    adjustCoordinateSystem", () => iw(e)), t("    position", () => Rw(e)), t("    positionSelfEdges", () => ab(e)), t("    removeBorderNodes", () => ob(e)), t("    normalize.undo", () => Ly(e)), t("    fixupEdgeLabelCoords", () => nb(e)), t("    undoCoordinateSystem", () => sw(e)), t("    translateGraph", () => eb(e)), t("    assignNodeIntersects", () => tb(e)), t("    reversePoints", () => rb(e)), t("    acyclic.undo", () => Ay(e));
}
function Bw(e, t) {
  e.nodes().forEach((n) => {
    let r = e.node(n), o = t.node(n);
    r && (r.x = o.x, r.y = o.y, r.order = o.order, r.rank = o.rank, t.children(n).length && (r.width = o.width, r.height = o.height));
  }), e.edges().forEach((n) => {
    let r = e.edge(n), o = t.edge(n);
    r.points = o.points, Object.hasOwn(o, "x") && (r.x = o.x, r.y = o.y);
  }), e.graph().width = t.graph().width, e.graph().height = t.graph().height;
}
var Fw = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"], Yw = { ranksep: 50, edgesep: 20, nodesep: 50, rankdir: "TB", rankalign: "center" }, Xw = ["acyclicer", "ranker", "rankdir", "align", "rankalign"], Ww = ["width", "height", "rank"], Wi = { width: 0, height: 0 }, Gw = ["minlen", "weight", "width", "height", "labeloffset"], jw = { minlen: 1, weight: 1, width: 0, height: 0, labeloffset: 10, labelpos: "r" }, qw = ["labelpos"];
function Kw(e) {
  let t = new Ee({ multigraph: !0, compound: !0 }), n = yr(e.graph());
  return t.setGraph(Object.assign({}, Yw, mr(n, Fw), Tn(n, Xw))), e.nodes().forEach((r) => {
    let o = yr(e.node(r)), i = mr(o, Ww);
    Object.keys(Wi).forEach((a) => {
      i[a] === void 0 && (i[a] = Wi[a]);
    }), t.setNode(r, i);
    let s = e.parent(r);
    s !== void 0 && t.setParent(r, s);
  }), e.edges().forEach((r) => {
    let o = yr(e.edge(r));
    t.setEdge(r, Object.assign({}, jw, mr(o, Gw), Tn(o, qw)));
  }), t;
}
function Uw(e) {
  let t = e.graph();
  t.ranksep /= 2, e.edges().forEach((n) => {
    let r = e.edge(n);
    r.minlen *= 2, r.labelpos.toLowerCase() !== "c" && (t.rankdir === "TB" || t.rankdir === "BT" ? r.width += r.labeloffset : r.height += r.labeloffset);
  });
}
function Zw(e) {
  e.edges().forEach((t) => {
    let n = e.edge(t);
    if (n.width && n.height) {
      let r = e.node(t.v), o = { rank: (e.node(t.w).rank - r.rank) / 2 + r.rank, e: t };
      wt(e, "edge-proxy", o, "_ep");
    }
  });
}
function Qw(e) {
  let t = 0;
  e.nodes().forEach((n) => {
    let r = e.node(n);
    r.borderTop && (r.minRank = e.node(r.borderTop).rank, r.maxRank = e.node(r.borderBottom).rank, t = Math.max(t, r.maxRank));
  }), e.graph().maxRank = t;
}
function Jw(e) {
  e.nodes().forEach((t) => {
    let n = e.node(t);
    if (n.dummy === "edge-proxy") {
      let r = n;
      e.edge(r.e).labelRank = n.rank, e.removeNode(t);
    }
  });
}
function eb(e) {
  let t = Number.POSITIVE_INFINITY, n = 0, r = Number.POSITIVE_INFINITY, o = 0, i = e.graph(), s = i.marginx || 0, a = i.marginy || 0;
  function c(l) {
    let u = l.x, d = l.y, f = l.width, h = l.height;
    t = Math.min(t, u - f / 2), n = Math.max(n, u + f / 2), r = Math.min(r, d - h / 2), o = Math.max(o, d + h / 2);
  }
  e.nodes().forEach((l) => c(e.node(l))), e.edges().forEach((l) => {
    let u = e.edge(l);
    Object.hasOwn(u, "x") && c(u);
  }), t -= s, r -= a, e.nodes().forEach((l) => {
    let u = e.node(l);
    u.x -= t, u.y -= r;
  }), e.edges().forEach((l) => {
    let u = e.edge(l);
    u.points.forEach((d) => {
      d.x -= t, d.y -= r;
    }), Object.hasOwn(u, "x") && (u.x -= t), Object.hasOwn(u, "y") && (u.y -= r);
  }), i.width = n - t + s, i.height = o - r + a;
}
function tb(e) {
  e.edges().forEach((t) => {
    let n = e.edge(t), r = e.node(t.v), o = e.node(t.w), i, s;
    n.points ? (i = n.points[0], s = n.points[n.points.length - 1]) : (n.points = [], i = o, s = r), n.points.unshift($i(r, i)), n.points.push($i(o, s));
  });
}
function nb(e) {
  e.edges().forEach((t) => {
    let n = e.edge(t);
    if (Object.hasOwn(n, "x")) switch ((n.labelpos === "l" || n.labelpos === "r") && (n.width -= n.labeloffset), n.labelpos) {
      case "l":
        n.x -= n.width / 2 + n.labeloffset;
        break;
      case "r":
        n.x += n.width / 2 + n.labeloffset;
        break;
    }
  });
}
function rb(e) {
  e.edges().forEach((t) => {
    let n = e.edge(t);
    n.reversed && n.points.reverse();
  });
}
function ob(e) {
  e.nodes().forEach((t) => {
    if (e.children(t).length) {
      let n = e.node(t), r = e.node(n.borderTop), o = e.node(n.borderBottom), i = e.node(n.borderLeft[n.borderLeft.length - 1]), s = e.node(n.borderRight[n.borderRight.length - 1]);
      n.width = Math.abs(s.x - i.x), n.height = Math.abs(o.y - r.y), n.x = i.x + n.width / 2, n.y = r.y + n.height / 2;
    }
  }), e.nodes().forEach((t) => {
    e.node(t).dummy === "border" && e.removeNode(t);
  });
}
function ib(e) {
  e.edges().forEach((t) => {
    if (t.v === t.w) {
      let n = e.node(t.v);
      n.selfEdges || (n.selfEdges = []), n.selfEdges.push({ e: t, label: e.edge(t) }), e.removeEdge(t);
    }
  });
}
function sb(e) {
  Kt(e).forEach((t) => {
    let n = 0;
    t.forEach((r, o) => {
      let i = e.node(r);
      i.order = o + n, (i.selfEdges || []).forEach((s) => {
        wt(e, "selfedge", { width: s.label.width, height: s.label.height, rank: i.rank, order: o + ++n, e: s.e, label: s.label }, "_se");
      }), delete i.selfEdges;
    });
  });
}
function ab(e) {
  e.nodes().forEach((t) => {
    let n = e.node(t);
    if (n.dummy === "selfedge") {
      let r = n, o = e.node(r.e.v), i = o.x + o.width / 2, s = o.y, a = n.x - i, c = o.height / 2;
      e.setEdge(r.e, r.label), e.removeNode(t), r.label.points = [{ x: i + 2 * a / 3, y: s - c }, { x: i + 5 * a / 6, y: s - c }, { x: i + a, y: s }, { x: i + 5 * a / 6, y: s + c }, { x: i + 2 * a / 3, y: s + c }], r.label.x = n.x, r.label.y = n.y;
    }
  });
}
function mr(e, t) {
  return jn(Tn(e, t), Number);
}
function yr(e) {
  let t = {};
  return e && Object.entries(e).forEach(([n, r]) => {
    typeof n == "string" && (n = n.toLowerCase()), t[n] = r;
  }), t;
}
function cb(e) {
  let t = Kt(e), n = new Ee({ compound: !0, multigraph: !0 }).setGraph({});
  return e.nodes().forEach((r) => {
    n.setNode(r, { label: r }), n.setParent(r, "layer" + e.node(r).rank);
  }), e.edges().forEach((r) => n.setEdge(r.v, r.w, {}, r.name)), t.forEach((r, o) => {
    let i = "layer" + o;
    n.setNode(i, { rank: "same" }), r.reduce((s, a) => (n.setEdge(s, a, { style: "invis" }), a));
  }), n;
}
var lb = { graphlib: Ga, version: xy, layout: Vw, debug: cb, util: { time: oc, notime: ic } }, ln = lb;
/*! For license information please see dagre.esm.js.LEGAL.txt */
function Nt(e) {
  var t, n;
  if (e.width && e.height) return { width: e.width, height: e.height };
  if (e.type === "group") {
    const r = typeof ((t = e.style) == null ? void 0 : t.width) == "number" ? e.style.width : 320, o = typeof ((n = e.style) == null ? void 0 : n.height) == "number" ? e.style.height : 200;
    return { width: r, height: o };
  }
  return e.type === "decision" ? { width: 180, height: 110 } : e.type === "user" ? { width: 160, height: 80 } : e.type === "note" ? { width: 220, height: 100 } : e.type === "marker" || e.type === "divider" ? { width: 120, height: 40 } : e.type === "evidence-code" || e.type === "evidence-json" ? { width: 320, height: 200 } : { width: 220, height: 90 };
}
function ub(e, t, n = {}) {
  const r = n.direction ?? "LR", o = r === "LR" || r === "RL", i = /* @__PURE__ */ new Map(), s = [];
  for (const f of e)
    if (f.parentNode) {
      const h = i.get(f.parentNode) ?? [];
      h.push(f), i.set(f.parentNode, h);
    } else
      s.push(f);
  const a = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map();
  for (const [f, h] of i.entries()) {
    const g = new ln.graphlib.Graph();
    g.setGraph({
      rankdir: r,
      nodesep: n.nodesep ?? (o ? 40 : 30),
      ranksep: n.ranksep ?? (o ? 80 : 60),
      marginx: 20,
      marginy: 30
    }), g.setDefaultEdgeLabel(() => ({}));
    const y = new Set(h.map((x) => x.id));
    for (const x of h) {
      const p = Nt(x);
      g.setNode(x.id, { width: p.width, height: p.height });
    }
    for (const x of t)
      y.has(x.source) && y.has(x.target) && g.setEdge(x.source, x.target);
    ln.layout(g);
    let w = 0, m = 0;
    for (const x of h) {
      const p = g.node(x.id);
      if (!p) continue;
      const b = p.x - p.width / 2, _ = p.y - p.height / 2;
      c.set(x.id, { x: b, y: _ }), w = Math.max(w, b + p.width), m = Math.max(m, _ + p.height);
    }
    a.set(f, { width: w + 20, height: m + 20 });
  }
  const l = new ln.graphlib.Graph();
  l.setGraph({
    rankdir: r,
    nodesep: n.nodesep ?? (o ? 60 : 40),
    ranksep: n.ranksep ?? (o ? 100 : 80),
    marginx: n.marginx ?? 20,
    marginy: n.marginy ?? 20
  }), l.setDefaultEdgeLabel(() => ({}));
  const u = new Set(s.map((f) => f.id));
  for (const f of s) {
    const h = f.type === "group" ? a.get(f.id) ?? Nt(f) : Nt(f);
    l.setNode(f.id, { width: h.width, height: h.height });
  }
  const d = /* @__PURE__ */ new Map();
  for (const [f, h] of i)
    for (const g of h) d.set(g.id, f);
  for (const f of t) {
    const h = u.has(f.source) ? f.source : d.get(f.source), g = u.has(f.target) ? f.target : d.get(f.target);
    !h || !g || h === g || l.setEdge(h, g);
  }
  return ln.layout(l), e.map((f) => {
    if (f.parentNode) {
      const w = c.get(f.id);
      return w ? { ...f, position: w } : f;
    }
    const h = l.node(f.id);
    if (!h) return f;
    const g = f.type === "group" ? a.get(f.id) ?? Nt(f) : Nt(f), y = { x: h.x - g.width / 2, y: h.y - g.height / 2 };
    return f.type === "group" ? {
      ...f,
      position: y,
      style: { ...f.style, width: g.width, height: g.height }
    } : { ...f, position: y };
  });
}
function db(e) {
  switch (e) {
    case "auto-lr":
      return "LR";
    case "auto-tb":
      return "TB";
    case "auto-rl":
      return "RL";
    case "auto-bt":
      return "BT";
    default:
      return null;
  }
}
function fb(e) {
  const [t, n] = ye(() => e === "light" || e === "dark" ? e : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
  return re(() => {
    if (e === "light" || e === "dark") {
      n(e);
      return;
    }
    if (typeof window > "u" || !window.matchMedia) return;
    const r = window.matchMedia("(prefers-color-scheme: dark)"), o = (i) => n(i.matches ? "dark" : "light");
    return r.addEventListener("change", o), () => r.removeEventListener("change", o);
  }, [e]), t;
}
function hb(e) {
  return e.map((t) => ({
    id: t.id,
    type: t.type,
    position: t.position,
    data: t.data,
    parentId: t.parentNode,
    extent: t.extent,
    style: t.style,
    width: t.width,
    height: t.height,
    draggable: t.draggable,
    selectable: t.selectable
  }));
}
function gb(e) {
  return e.map((t) => ({
    id: t.id,
    source: t.source,
    target: t.target,
    type: t.type,
    label: t.label,
    sourceHandle: t.sourceHandle,
    targetHandle: t.targetHandle,
    animated: t.animated,
    data: t.data,
    style: t.style
  }));
}
function pb(e) {
  const { src: t, data: n, height: r = "60vh", width: o = "100%", fitView: i = !0, interactive: s = !0, theme: a = "auto", toolbar: c = !0, layout: l, onReady: u } = e, d = ne(null), [f, h] = ye(n ?? null), [g, y] = ye(null), w = fb(a), m = Yn();
  re(() => {
    if (n) {
      const M = Ni(n);
      M.ok ? (h(M.file), y(null)) : y(M.error);
      return;
    }
    if (!t) return;
    let A = !1;
    return y(null), fetch(t).then((M) => M.json()).then((M) => {
      if (A) return;
      const z = Ni(M);
      z.ok ? h(z.file) : y(z.error);
    }).catch((M) => {
      A || y(M instanceof Error ? M.message : String(M));
    }), () => {
      A = !0;
    };
  }, [t, n]);
  const x = fe(() => {
    var z;
    if (!f) return null;
    const A = l ?? ((z = f.metadata) == null ? void 0 : z.layout), M = db(A);
    return M ? ub(f.nodes, f.edges, { direction: M }) : f.nodes;
  }, [f, l]), p = fe(() => x ? hb(x) : [], [x]), b = fe(() => f ? gb(f.edges) : [], [f]), _ = me(() => m.fitView({ padding: 0.15, duration: 300 }), [m]), E = me(async () => {
    if (!d.current) throw new Error("viewer not mounted");
    return z0(d.current);
  }, []), C = me(async () => {
    if (!d.current) throw new Error("viewer not mounted");
    return V0(d.current);
  }, []);
  return re(() => {
    f && (u == null || u({ fitView: _, exportPNG: E, exportSVG: C }));
  }, [f, _, E, C, u]), g ? /* @__PURE__ */ k("div", { className: "pma-viewer", "data-pma-theme": w, style: { width: o, height: r }, children: /* @__PURE__ */ J("pre", { className: "pma-error", children: [
    "Failed to load diagram: ",
    g
  ] }) }) : f ? /* @__PURE__ */ J("div", { ref: d, className: "pma-viewer", "data-pma-theme": w, style: { width: o, height: r }, children: [
    /* @__PURE__ */ J(
      tm,
      {
        nodes: p,
        edges: b,
        nodeTypes: Xm,
        edgeTypes: Wm,
        defaultViewport: f.viewport,
        fitView: i,
        nodesDraggable: s,
        nodesConnectable: !1,
        elementsSelectable: s,
        panOnDrag: s,
        zoomOnScroll: s,
        zoomOnPinch: s,
        proOptions: { hideAttribution: !0 },
        children: [
          /* @__PURE__ */ k(cm, { gap: 16, size: 1 }),
          s ? /* @__PURE__ */ k(pm, { showInteractive: !1 }) : null
        ]
      }
    ),
    c ? /* @__PURE__ */ J("div", { className: "pma-toolbar", children: [
      /* @__PURE__ */ k("button", { type: "button", onClick: _, children: "Fit" }),
      /* @__PURE__ */ k("button", { type: "button", onClick: async () => {
        var M;
        const A = await E();
        Gi(A, (((M = f.metadata) == null ? void 0 : M.title) ?? "diagram") + ".png");
      }, children: "PNG" }),
      /* @__PURE__ */ k("button", { type: "button", onClick: async () => {
        var M;
        const A = await C();
        Gi(A, (((M = f.metadata) == null ? void 0 : M.title) ?? "diagram") + ".svg");
      }, children: "SVG" })
    ] }) : null
  ] }) : /* @__PURE__ */ k("div", { className: "pma-viewer", "data-pma-theme": w, style: { width: o, height: r, display: "flex", alignItems: "center", justifyContent: "center" }, children: /* @__PURE__ */ k("span", { style: { opacity: 0.6 }, children: "Loading diagram…" }) });
}
function Gi(e, t) {
  const n = document.createElement("a");
  n.href = e, n.download = t, document.body.appendChild(n), n.click(), n.remove();
}
function mb(e) {
  return /* @__PURE__ */ k(Pa, { children: /* @__PURE__ */ k(pb, { ...e }) });
}
function Eb(e, t) {
  const n = typeof e == "string" ? document.querySelector(e) : e;
  if (!n) throw new Error(`mount target not found: ${String(e)}`);
  let r = _l(n), o = null, i = t;
  const s = () => {
    r == null || r.render(
      vl(mb, {
        ...i,
        onReady: (a) => {
          o = a;
        }
      })
    );
  };
  return s(), {
    fitView: () => o == null ? void 0 : o.fitView(),
    exportPNG: async () => {
      if (!o) throw new Error("viewer not ready");
      return o.exportPNG();
    },
    exportSVG: async () => {
      if (!o) throw new Error("viewer not ready");
      return o.exportSVG();
    },
    update: (a) => {
      i = { ...i, ...a }, s();
    },
    destroy: () => {
      r == null || r.unmount(), r = null, o = null;
    }
  };
}
export {
  mb as PmaViewer,
  Or as RFD_SCHEMA_VERSION,
  vb as isRfdFile,
  Eb as mount,
  Ni as validateRfdFile
};
//# sourceMappingURL=pma-viewer.js.map
